var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg201818446238850(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "transparent"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M148.735,439.898c54.439-6.899,107.577-21.486,161.803-29.795c0.94-0.144,0.541-1.573-0.394-1.43 c-54.173,8.317-107.489,21.442-161.416,31.168C148.695,439.847,148.702,439.902,148.735,439.898L148.735,439.898z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M148.768,440.312c16.297-22.486,32.448-45.018,48.074-67.982 c7.582-11.143,15.099-22.33,22.53-33.575c3.801-5.751,7.583-11.515,11.346-17.292c3.604-5.531,8.213-11.145,10.576-17.326 c0.089-0.232-0.243-0.395-0.402-0.234c-4.457,4.503-7.542,10.684-11,15.977c-3.775,5.777-7.569,11.543-11.382,17.296 c-7.617,11.493-15.297,22.945-23.04,34.352c-15.564,22.929-31.123,45.873-46.769,68.745 C148.673,440.315,148.739,440.352,148.768,440.312L148.768,440.312z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M148.986,439.617c-15.122-16.818-30.056-33.808-45.248-50.568 c-7.026-7.751-14.071-15.484-21.095-23.237c-3.384-3.735-6.678-8.345-10.804-11.311c-0.23-0.165-0.432,0.175-0.28,0.363 c9.946,12.306,21.039,23.858,31.498,35.738c14.801,16.811,29.697,33.569,45.426,49.519 C148.807,440.449,149.292,439.956,148.986,439.617L148.986,439.617z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M72.215,354.25c8.631-26.409,15.152-53.537,22.481-80.325 c3.535-12.919,7.182-25.809,11.088-38.621c1.968-6.455,4.011-12.887,6.107-19.302c2.351-7.194,5.421-14.395,6.949-21.812 c0.069-0.336-0.403-0.58-0.581-0.245c-3.143,5.931-5.003,12.59-7.135,18.932c-2.257,6.711-4.404,13.459-6.484,20.227 c-4.025,13.101-7.771,26.285-11.396,39.502c-7.431,27.088-14.935,54.192-22.014,81.373 C71.064,354.618,72.011,354.872,72.215,354.25L72.215,354.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M311.141,409.737c20.662-9.032,40.098-22.034,59.022-34.198 c19.067-12.255,38.665-24.323,56.923-37.753c0.936-0.689,0.119-2.211-0.933-1.596c-19.593,11.443-37.965,25.263-57.011,37.604 c-9.048,5.862-18.183,11.583-27.414,17.152c-10.233,6.174-20.908,11.694-30.995,18.093 C310.283,409.324,310.673,409.942,311.141,409.737L311.141,409.737z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M426.703,336.965c-11.169-49.265-14.868-99.468-22.341-149.317 c-0.13-0.867-1.448-0.499-1.318,0.363c7.454,49.724,8.884,100.585,23.492,149C426.568,337.118,426.728,337.074,426.703,336.965 L426.703,336.965z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M240.705,304.283c11.047,17.841,23.279,34.987,34.482,52.748 c11.186,17.735,22.167,35.801,34.754,52.59c0.348,0.464,1.135,0.039,0.798-0.467c-11.819-17.746-23.633-35.435-35.001-53.481 c-10.996-17.456-21.449-35.776-34.383-51.893C241.059,303.413,240.461,303.889,240.705,304.283L240.705,304.283z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M71.812,355.026c14.704-2.891,29.141-7.466,43.534-11.599c13.88-3.986,27.72-8.111,41.539-12.301 c13.523-4.1,27.024-8.272,40.523-12.45c14.569-4.509,29.646-8.333,43.852-13.887c0.873-0.341,0.555-1.654-0.394-1.43 c-14.541,3.434-28.802,8.79-43.056,13.261c-13.781,4.322-27.576,8.6-41.394,12.802c-13.518,4.111-27.061,8.141-40.631,12.081 c-14.696,4.267-29.682,7.882-44.151,12.873C71.222,354.518,71.386,355.109,71.812,355.026L71.812,355.026z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M118.48,194.16c11.07,10.283,22.344,20.345,33.581,30.447 c10.76,9.673,21.232,20.208,32.763,28.951c0.531,0.403,1.153-0.456,0.7-0.907c-10.433-10.404-22.258-19.695-33.271-29.496 c-11.082-9.863-22.163-19.73-33.664-29.103C118.514,193.99,118.406,194.092,118.48,194.16L118.48,194.16z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M185.027,253.147c16.212,19.357,34.808,37.161,55.919,51.127c0.216,0.143,0.482-0.192,0.28-0.363 c-19.359-16.385-39.097-31.903-56.022-50.941C185.096,252.849,184.924,253.025,185.027,253.147L185.027,253.147z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M185.015,253.421c14.68,2.859,29.615,4.631,44.387,6.976c13.594,2.159,27.172,4.418,40.754,6.646 c13.603,2.231,27.216,4.395,40.854,6.406c14.039,2.07,28.752,5.276,42.953,5.541c0.396,0.007,0.491-0.61,0.095-0.7 c-7.422-1.687-15.23-2.15-22.764-3.199c-7.244-1.009-14.479-2.078-21.708-3.186c-13.601-2.084-27.177-4.323-40.753-6.562 c-27.717-4.571-55.695-10.417-83.717-12.659C184.696,252.65,184.6,253.34,185.015,253.421L185.015,253.421z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M241.062,304.161c18.74-2.224,37.445-7.231,55.847-11.333c9.348-2.084,18.689-4.2,28.022-6.354 c9.691-2.237,19.775-4.068,29.111-7.552c0.289-0.108,0.281-0.628-0.079-0.586c-9.004,1.05-17.908,3.595-26.722,5.66 c-9.641,2.259-19.291,4.478-28.949,6.661c-18.997,4.295-38.651,7.539-57.252,13.334 C240.951,304.018,240.961,304.173,241.062,304.161L241.062,304.161z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M185.028,252.909c-42.042,28.066-80.214,62.99-113.598,100.913 c-0.35,0.397,0.197,0.958,0.585,0.585c18.121-17.389,35.304-35.709,53.873-52.646c18.864-17.205,38.891-33.244,59.314-48.553 C185.377,253.078,185.217,252.783,185.028,252.909L185.028,252.909z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M118.535,194.414c29.364,3.498,58.897,5.546,88.364,7.978c15.027,1.24,30.048,2.55,45.046,4.106 c7.021,0.728,14.036,1.504,21.044,2.346c7.236,0.869,14.771,2.706,22.046,2.634c0.438-0.004,0.518-0.63,0.102-0.757 c-6.408-1.949-13.789-2.174-20.422-2.985c-6.992-0.854-13.992-1.64-20.997-2.377c-15.288-1.609-30.597-3.015-45.912-4.342 c-29.742-2.577-59.51-4.891-89.271-7.219C118.134,193.766,118.149,194.368,118.535,194.414L118.535,194.414z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M294.898,210.601c-19.027,5.793-37.932,12.173-56.602,19.034 c-18.047,6.632-36.633,13.546-53.308,23.208c-0.237,0.137-0.078,0.564,0.193,0.458c18.244-7.147,35.917-15.591,54.314-22.403 c18.427-6.822,37.185-12.677,55.674-19.313C295.78,211.366,295.535,210.407,294.898,210.601L294.898,210.601z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M294.905,211.222c9.652,11.419,19.565,22.604,29.129,34.106 c9.415,11.323,18.572,23.829,29.773,33.462c0.176,0.151,0.511-0.056,0.348-0.268c-8.888-11.585-19.249-22.204-28.611-33.428 c-9.712-11.644-19.352-23.691-30.38-34.13C294.99,210.799,294.754,211.044,294.905,211.222L294.905,211.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M295.037,211.103c18.242-3.349,36.395-7.064,54.557-10.826 c18.079-3.745,36.443-7.022,54.196-12.132c0.415-0.12,0.233-0.693-0.174-0.631c-18.288,2.775-36.395,7.242-54.472,11.131 c-18.106,3.896-36.162,7.874-54.112,12.438C295.018,211.086,295.024,211.105,295.037,211.103L295.037,211.103z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M353.924,278.7c25.215,18.242,46.522,41.424,72.579,58.487c0.255,0.167,0.461-0.223,0.233-0.399 c-24.575-18.973-46.426-41.562-72.734-58.221C353.916,278.513,353.845,278.643,353.924,278.7L353.924,278.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M241.019,304.232c4.842,1.78,10.307,2.384,15.356,3.284c11.573,2.063,23.18,3.94,34.773,5.891 c30.346,5.108,60.701,10.182,90.973,15.723c14.794,2.708,29.493,5.945,44.284,8.638c1.008,0.184,1.453-1.297,0.43-1.56 c-27.786-7.139-56.706-11.1-84.954-15.958c-27.122-4.665-54.269-9.223-81.451-13.526c-6.403-1.014-12.963-1.591-19.324-2.808 C240.898,303.877,240.821,304.159,241.019,304.232L241.019,304.232z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M118.555,194.18c33.386-10.661,64.359-28.193,95.454-44.095c0.333-0.171,0.096-0.764-0.26-0.616 c-32.387,13.453-62.276,32.352-95.235,44.562C118.423,194.066,118.459,194.211,118.555,194.18L118.555,194.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M213.744,149.89c7.769,7.905,17.799,14.134,26.618,20.811 c8.978,6.797,17.953,13.598,26.933,20.392c9.098,6.883,18.525,13.346,27.593,20.249c0.296,0.225,0.584-0.276,0.292-0.499 c-8.919-6.79-17.527-14-26.471-20.777c-8.495-6.437-17.003-12.853-25.53-19.247c-9.441-7.08-18.837-15.576-29.272-21.141 C213.774,149.607,213.634,149.778,213.744,149.89L213.744,149.89z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M213.819,149.869c15.498,4.532,31.913,6.857,47.731,10.081 c15.986,3.258,31.971,6.524,47.956,9.791c15.675,3.204,31.353,6.397,47.031,9.586c15.647,3.182,31.332,6.911,47.166,9.033 c0.597,0.08,0.708-0.896,0.141-1.04c-15.735-4.01-31.906-6.56-47.828-9.728c-16.003-3.185-31.99-6.452-47.979-9.707 c-15.68-3.192-31.36-6.383-47.055-9.499c-15.541-3.086-31.362-7.113-47.142-8.668 C213.751,149.709,213.738,149.845,213.819,149.869L213.819,149.869z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M354.029,278.673c15.228-26.048,29.976-52.445,44.029-79.145 c2.012-3.824,3.769-7.792,5.845-11.582c0.143-0.261-0.256-0.494-0.399-0.233c-14.504,26.477-29.792,52.512-43.657,79.361 c-1.983,3.84-3.98,7.673-5.95,11.52C353.851,278.683,353.979,278.759,354.029,278.673L354.029,278.673z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 214.265,
    cy: 150.416,
    rx: 29.866,
    ry: 7.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 214.265,
    cy: 152.168,
    rx: 42.86,
    ry: 11.297
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1196_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M226.09,68.006c0.135,0.13,0.267,0.264,0.396,0.4l0.095,0.102l0.072,0.087l0.142,0.176 c0.203,0.246,0.339,0.453,0.484,0.666c0.278,0.42,0.491,0.804,0.689,1.181c0.388,0.747,0.693,1.452,0.978,2.151 c0.563,1.394,1.019,2.751,1.444,4.111c0.422,1.359,0.804,2.715,1.156,4.083c0.176,0.685,0.345,1.371,0.504,2.072l0.242,1.117 c0.065,0.288,0.111,0.568,0.163,0.851c0.04,0.283,0.061,0.565,0.071,0.848c-0.034,0.441-0.105,0.876-0.247,1.298 c-0.072,0.21-0.137,0.421-0.22,0.628c-0.077,0.201-0.174,0.439-0.227,0.549c-0.246,0.552-0.495,1.061-0.751,1.559 c-0.51,0.996-1.036,1.95-1.574,2.897c-1.08,1.889-2.199,3.734-3.388,5.557l-3.186-1.86c0.954-1.853,1.853-3.75,2.696-5.655 c0.419-0.953,0.825-1.91,1.193-2.859c0.185-0.474,0.357-0.947,0.505-1.397c0.046-0.133,0.051-0.17,0.069-0.238l0.042-0.186 c0.022-0.124,0.05-0.247,0.03-0.372c-0.036-0.158-0.095-0.313-0.148-0.455l-0.289-0.882 c-0.209-0.618-0.431-1.241-0.661-1.862c-0.46-1.241-0.949-2.476-1.465-3.684c-0.517-1.206-1.062-2.397-1.647-3.501 c-0.292-0.549-0.595-1.08-0.898-1.539c-0.151-0.225-0.303-0.437-0.438-0.594c-0.065-0.074-0.133-0.157-0.175-0.185 l-0.034-0.032l-0.016-0.017c-0.003-0.001-0.004,0.002-0.006,0.003c-0.006,0.004-0.009,0.006-0.009,0.006L226.09,68.006z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M225.66,67.548l-4.142,5.57c-0.057-0.081,0.31,0.403,0.612,1 c0.313,0.598,0.621,1.287,0.912,1.996c2.285-0.941,4.574-1.871,6.868-2.791c-0.396-0.876-0.841-1.749-1.411-2.661 c-0.134-0.222-0.306-0.468-0.461-0.697l-0.269-0.367l-0.137-0.182l-0.16-0.197c-0.113-0.134-0.206-0.253-0.337-0.397 c-0.134-0.146-0.27-0.289-0.408-0.429c-0.169-0.162-0.36-0.33-0.545-0.485C226.003,67.77,225.836,67.665,225.66,67.548z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M224.767,95.1c-1.192,0.201-2.374,0.431-3.538,0.676c-0.224,0.048-0.466-0.091-0.543-0.307 c-0.068-0.192,0.017-0.38,0.193-0.454c1.087-0.462,2.206-0.914,3.354-1.341l0.002-0.001 c0.389-0.145,0.858,0.044,1.044,0.428c0.188,0.385,0.017,0.818-0.374,0.963C224.861,95.079,224.812,95.092,224.767,95.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M225.165,94.873c-1.328,1.666-2.636,3.374-3.969,4.942c-0.14,0.159-0.402,0.16-0.587,0.003 c-0.173-0.147-0.221-0.376-0.117-0.528c0.555-0.827,1.113-1.716,1.671-2.608c0.562-0.899,1.123-1.799,1.686-2.7 c0.211-0.336,0.684-0.427,1.061-0.2c0.377,0.226,0.512,0.689,0.298,1.031C225.195,94.833,225.18,94.854,225.165,94.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M225.782,95.801c-1.208,1.732-2.361,3.495-3.628,5.205c-0.139,0.18-0.406,0.203-0.596,0.052 c-0.177-0.141-0.23-0.379-0.13-0.546c1.033-1.785,1.987-3.676,2.991-5.531c0.189-0.352,0.654-0.473,1.044-0.267 c0.388,0.205,0.551,0.664,0.359,1.022C225.81,95.758,225.796,95.78,225.782,95.801z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M226.495,96.493c-0.917,1.624-1.852,3.224-2.943,4.819c-0.136,0.195-0.41,0.238-0.606,0.096 c-0.182-0.132-0.24-0.371-0.142-0.554l0.006-0.012c0.852-1.66,1.562-3.338,2.248-5.03l0.008-0.021 c0.15-0.375,0.6-0.542,1.006-0.374c0.406,0.169,0.614,0.615,0.46,0.996C226.522,96.44,226.508,96.469,226.495,96.493z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M227.54,96.13c-0.544,1.37-1.114,2.732-1.744,4.105c-0.099,0.213-0.357,0.301-0.576,0.195 c-0.198-0.096-0.297-0.316-0.242-0.512l0.002-0.006c0.403-1.437,0.74-2.857,1.054-4.279l0.002-0.01 c0.086-0.4,0.501-0.636,0.926-0.53c0.425,0.106,0.702,0.521,0.612,0.926C227.566,96.057,227.553,96.096,227.54,96.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M223.96,94.514c0.686-0.053,1.24-0.39,1.935,0.06c0.822,0.533,0.539,1.385,0.234,2.064 c-0.237,0.526,0.492,0.932,0.831,0.468c0.554-0.757,0.951-1.68,0.32-2.571c-0.564-0.796-1.6-1.016-2.456-0.743 c-0.356,0.115-0.471,0.64-0.06,0.839c0.389,0.188,0.667,0.39,0.92,0.736l0.364-0.666l-0.111,0.216l-0.313,0.316l0.162,0.179 l0.205-0.274l0.362,0.281l-0.122,0.322l-0.295-0.028l0.1-0.435c-0.096,0.124-0.169,0.219-0.192,0.379 c-0.027,0.191,0.08,0.386,0.29,0.444l0.085,0.023c0.144,0.039,0.351,0.008,0.442-0.109c0.343-0.442,0.053-1.079-0.579-1.138 c-0.577-0.054-0.885,0.589-0.453,0.994c0.463,0.436,1.151,0.07,1.124-0.5c-0.03-0.626-0.834-1.188-1.426-1.005 c-0.141,0.044-0.3,0.155-0.311,0.313c-0.041,0.599,0.485,0.944,1.088,0.921c0.327-0.013,0.588-0.369,0.366-0.669 c-0.346-0.467-0.751-0.822-1.279-1.089l-0.06,0.841c0.515-0.154,1.248-0.081,1.492,0.52c0.21,0.523-0.214,1.051-0.495,1.435 l0.831,0.468c0.467-1.047,0.713-2.258-0.387-3.111c-0.775-0.599-2.38-0.733-2.851,0.161 C223.648,94.298,223.766,94.529,223.96,94.514z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1195_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M203.112,67.915c-0.862,0.671-1.484,1.373-2.02,2.062c-0.536,0.691-0.97,1.376-1.356,2.056 c-0.776,1.361-1.37,2.706-1.895,4.052c-0.523,1.345-0.965,2.689-1.359,4.04c-0.391,1.355-0.733,2.704-1.019,4.12 l-0.142,0.724c-0.057,0.277-0.093,0.554-0.135,0.83l-0.04,0.413c-0.007,0.137-0.004,0.273-0.006,0.409l0.013,0.203 l0.003,0.051l0.002,0.025l0.001,0.013c0.076-0.005,0.022,0.006,0.04,0.008l0.014,0.102c0.016,0.136,0.044,0.269,0.071,0.402 c0.13,0.527,0.402,1.021,0.676,1.501c0.141,0.231,0.288,0.494,0.424,0.696l0.305,0.452c0.809,1.168,1.624,2.243,2.449,3.315 c1.648,2.136,3.326,4.214,5.015,6.282l2.962-2.201c-1.475-2.198-2.938-4.405-4.34-6.625 c-0.698-1.108-1.389-2.226-2.005-3.323l-0.222-0.406c-0.05-0.094-0.072-0.153-0.108-0.23 c-0.064-0.145-0.125-0.289-0.165-0.437c-0.051-0.151,0.024-0.31,0.061-0.457l0.071-0.219l0.036-0.107 c0.011-0.029,0.037-0.119,0.058-0.19c0.727-2.381,1.673-4.797,2.773-7.006c0.552-1.104,1.155-2.166,1.809-3.093 c0.325-0.465,0.665-0.895,1.005-1.251c0.337-0.358,0.68-0.649,0.951-0.806L203.112,67.915z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M203.548,67.497l3.71,5.877c-0.278,0.206-0.712,0.634-1.113,1.192 c-0.407,0.56-0.802,1.223-1.17,1.928c-2.191-1.142-4.392-2.266-6.602-3.373c0.542-0.969,1.169-1.933,1.963-2.886 C201.129,69.294,202.11,68.318,203.548,67.497z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M204.996,96.142c1.254,0.109,2.506,0.265,3.754,0.47c0.24,0.04,0.467-0.123,0.508-0.363 c0.036-0.212-0.088-0.414-0.283-0.486c-1.21-0.441-2.442-0.837-3.695-1.189l-0.003-0.001 c-0.425-0.12-0.867,0.127-0.985,0.553c-0.119,0.426,0.131,0.869,0.557,0.989C204.896,96.129,204.948,96.138,204.996,96.142z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M204.549,95.937c1.656,1.657,3.276,3.353,4.854,5.089c0.164,0.18,0.442,0.193,0.622,0.03 c0.168-0.153,0.189-0.408,0.057-0.587c-1.404-1.897-2.858-3.765-4.352-5.597c-0.278-0.341-0.779-0.394-1.121-0.117 c-0.342,0.277-0.394,0.78-0.114,1.123C204.512,95.897,204.531,95.918,204.549,95.937z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M204.085,96.975c1.523,1.726,3,3.495,4.428,5.309c0.151,0.192,0.429,0.226,0.619,0.075 c0.178-0.141,0.216-0.394,0.098-0.582c-1.243-1.964-2.545-3.896-3.9-5.791c-0.256-0.359-0.754-0.445-1.113-0.19 c-0.359,0.255-0.442,0.754-0.184,1.115C204.049,96.932,204.067,96.955,204.085,96.975z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M203.478,97.77c1.199,1.623,2.409,3.236,3.629,4.842c0.148,0.195,0.425,0.234,0.618,0.087 c0.179-0.136,0.223-0.384,0.111-0.575l-0.007-0.012c-1.013-1.724-2.015-3.453-3.004-5.188l-0.012-0.022 c-0.219-0.385-0.707-0.521-1.091-0.305c-0.384,0.216-0.517,0.706-0.297,1.092C203.441,97.716,203.46,97.745,203.478,97.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M202.354,97.487c0.786,1.382,1.58,2.758,2.38,4.131c0.124,0.213,0.395,0.286,0.605,0.164 c0.191-0.111,0.266-0.344,0.186-0.545l-0.002-0.006c-0.583-1.468-1.158-2.938-1.723-4.41l-0.004-0.01 c-0.159-0.415-0.622-0.624-1.035-0.47c-0.413,0.155-0.62,0.618-0.459,1.035C202.316,97.413,202.335,97.453,202.354,97.487z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M205.715,95.449c-0.712,0.002-1.338-0.305-1.963,0.24c-0.739,0.644-0.301,1.514,0.122,2.202 c0.329,0.534-0.348,1.021-0.768,0.566c-0.685-0.743-1.247-1.667-0.77-2.671c0.427-0.897,1.437-1.24,2.362-1.029 c0.385,0.088,0.6,0.639,0.216,0.887c-0.363,0.234-0.609,0.475-0.806,0.864l-0.49-0.67l0.152,0.218l0.375,0.305l-0.134,0.204 l-0.258-0.271l-0.318,0.331l0.18,0.328l0.295-0.056l-0.178-0.45c0.12,0.122,0.211,0.215,0.262,0.382 c0.061,0.2-0.015,0.415-0.219,0.495l-0.083,0.032c-0.14,0.054-0.355,0.041-0.468-0.074 c-0.424-0.432-0.244-1.132,0.388-1.256c0.577-0.113,1.008,0.542,0.637,1.01c-0.398,0.501-1.158,0.179-1.231-0.423 c-0.08-0.662,0.633-1.337,1.271-1.199c0.152,0.033,0.335,0.137,0.374,0.304c0.152,0.632-0.328,1.044-0.944,1.075 c-0.336,0.017-0.663-0.333-0.491-0.671c0.268-0.527,0.614-0.943,1.102-1.277l0.216,0.888 c-0.553-0.117-1.285,0.033-1.425,0.691c-0.121,0.572,0.401,1.086,0.75,1.467l-0.768,0.566 c-0.643-1.054-1.109-2.299-0.151-3.313c0.675-0.713,2.286-1.015,2.937-0.097C205.995,95.19,205.915,95.448,205.715,95.449z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M205.661,66.681c-2.929,0.596-4.247,1.854-3.62,5.661l2.991,21.129h9.535h9.535l2.991-21.129 c0.627-3.806-0.69-5.064-3.62-5.661l-8.907-1.469L205.661,66.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M203.01,104.114h11.557h11.557c0-3.471-1.037-7.528-2.04-10.644h-9.517h-9.517 C204.047,96.586,203.01,100.644,203.01,104.114z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1194_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M207.378,95.342c-0.13,2.283-1.852,4.169-4.094,4.559c-0.322,0.056-0.186,0.547,0.135,0.491 c2.474-0.43,4.325-2.554,4.468-5.05C207.906,95.015,207.396,95.016,207.378,95.342L207.378,95.342z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1193_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M214.329,93.509c-0.034,2.353-0.068,4.706-0.103,7.058c-0.003,0.238,0.273,0.313,0.435,0.18 c0.869-0.713,1.602-1.032,1.674-2.17c0.104-1.644,0.006-3.327-0.081-4.97c-0.017-0.326-0.527-0.328-0.509,0 c0.06,1.133,0.098,2.266,0.099,3.4c0.001,0.632,0.057,1.245-0.171,1.847c-0.282,0.745-0.753,1.025-1.372,1.533 c0.145,0.06,0.29,0.12,0.435,0.18c0.034-2.353,0.068-4.706,0.103-7.058C214.843,93.181,214.334,93.181,214.329,93.509 L214.329,93.509z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1192_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M221.331,95.342c0.143,2.496,1.994,4.62,4.468,5.05c0.321,0.056,0.458-0.435,0.135-0.491 c-2.242-0.39-3.964-2.276-4.094-4.559C221.822,95.016,221.312,95.014,221.331,95.342L221.331,95.342z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 3.8513,
      strokeMiterlimit: 10
    },
    points: "207.597,140.078  207.679,144.783 207.725,147.389  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M204.447,145.387l-0.044-0.591l-1.675-21.496l-0.209-2.684l-0.105-1.342l-0.032-0.625 c-0.007-0.205,0.025-0.409,0.034-0.614l0.011-0.148l0.004-0.084l0.008-0.169l0.016-0.337l0.253-5.398l0.507-10.796 l11.679,1.254l-1.798,10.658l-0.899,5.329l-0.056,0.333l-0.028,0.167l-0.014,0.083c-0.003,0.016-0.004,0.012-0.007,0.02 c-0.02,0.036-0.033,0.08-0.046,0.107l-0.057,1.355l-0.115,2.709l-0.919,21.652l-0.023,0.594L204.447,145.387z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M209.795,146.445c-1.36,0.048-2.721,0.064-4.083,0.05c-0.526,1.007-0.86,2.113-0.982,3.246 c-0.031,0.288,0.196,0.544,0.486,0.544l5.117-0.001c0.292,0,0.517-0.26,0.465-0.549 C210.594,148.604,210.257,147.498,209.795,146.445z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M205.919,147.945l0.127-1.096c0.041-0.354,0.094-0.734,0.342-0.988 c0.178-0.181,0.431-0.268,0.68-0.323c0.463-0.102,0.969-0.109,1.395,0.108c0.449,0.228,0.754,0.68,0.914,1.158 c0.16,0.478,0.192,0.985,0.223,1.486"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 3.8513,
      strokeMiterlimit: 10
    },
    points: "220.533,140.185  220.396,145.111 220.346,147.497  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M222.447,146.734c0,0,0.964,0.45,2.226,1.04c1.255,0.6,2.798,1.351,3.949,1.962 c0.233,0.125,0.494,0.401,0.312,0.588c-0.084,0.086-0.221,0.092-0.344,0.092h-7.95c-0.042-0.696-0.403-1.366-0.952-1.784 l-0.553,1.368c-0.107,0.271-0.164,0.415-0.164,0.415h-1.587c0,0-0.113-0.892,0.002-1.69c0.084-0.537,0.569-1.925,0.748-2.028 c0.114-0.067,0.255-0.055,0.386-0.041C219.681,146.783,222.447,146.734,222.447,146.734"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M223.629,145.55l0.029-0.361c0.615-7.184,1.328-14.38,2.049-21.568l0.273-2.695l0.138-1.347 l0.039-0.424c0.017-0.166,0.028-0.332,0.018-0.498c-0.009-0.381-0.005-0.542-0.006-0.782l0.003-5.426l0.006-10.852 l-11.726,0.7l1.297,10.774l0.648,5.387c0.026,0.198,0.059,0.541,0.07,0.485c0.009,0.016,0.014,0.032,0.02,0.048l0.01,0.024 l0.004,0.158l0.025,1.361l0.052,2.719c0.147,7.253,0.302,14.49,0.555,21.781l0.012,0.367L223.629,145.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M202.201,72.373c0.048,4.14,0.817,8.209,1.264,12.313c0.031,0.287,0.486,0.29,0.454,0 c-0.447-4.104-1.216-8.174-1.264-12.313C202.651,72.081,202.197,72.081,202.201,72.373L202.201,72.373z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M226.175,71.307c0.252,4.327-0.239,8.633-0.987,12.891c-0.05,0.286,0.387,0.408,0.438,0.121 c0.756-4.297,1.258-8.644,1.004-13.012C226.612,71.017,226.158,71.015,226.175,71.307L226.175,71.307z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1140_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1154_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 214.596,
    y1: 63.269,
    x2: 214.596,
    y2: 66.731
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M214.596,67.362c1.772,0,3.208-0.282,3.208-0.631c0-0.349-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C211.388,67.08,212.825,67.362,214.596,67.362z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 214.596,
    y1: 63.269,
    x2: 214.596,
    y2: 66.731
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M214.596,67.362c1.772,0,3.208-0.282,3.208-0.631c0-0.349-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C211.388,67.08,212.825,67.362,214.596,67.362z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1152_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M211.471,65.021h6.25c2.3,0,4.164-1.864,4.164-4.164v-8.106c0-3.704-3.003-6.707-6.707-6.707 h-1.164c-3.704,0-6.707,3.003-6.707,6.707v8.106C207.307,63.157,209.172,65.021,211.471,65.021z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1150_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M216.911,62.942c0.106,0.219-0.028,0.473-0.159,0.678c-0.272,0.429-0.565,0.877-1.018,1.105 c-0.304,0.153-0.653,0.191-0.993,0.196c-0.57,0.007-1.157-0.082-1.644-0.376c-0.488-0.294-0.859-0.823-0.852-1.393"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M216.98,62.908c0.211,0.093,0.316,0.385,0.328,0.602c0.028,0.227-0.017,0.432-0.006,0.591 c-0.03,0.326-0.094,0.686-0.316,1.046c-0.184,0.378-0.638,0.733-1.099,0.94c-0.462,0.185-0.878,0.207-1.223,0.233 c-0.357-0.023-0.735-0.063-1.118-0.188c-0.37-0.158-0.769-0.331-1.071-0.666c-0.329-0.312-0.531-0.72-0.613-1.137 c-0.059-0.425,0.002-0.879,0.303-1.178l0.156,0.002c0.025,0.528,0.378,0.993,0.814,1.263 c0.45,0.272,0.997,0.356,1.533,0.349c0.543,0.021,1.068-0.082,1.431-0.478c0.186-0.186,0.343-0.41,0.497-0.639 c0.156-0.219,0.328-0.459,0.244-0.673L216.98,62.908z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1147_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1149_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M220.239,58.228c0,0.013-0.001,0.027-0.001,0.04c-0.012,0.33,0.056,0.638,0.206,0.924 c0.097,0.297,0.262,0.555,0.496,0.772c0.217,0.234,0.475,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.207 c0.62-0.028,1.264-0.231,1.696-0.702c0.437-0.476,0.685-1.041,0.702-1.696c0-0.013,0.001-0.027,0.001-0.04 c0.012-0.33-0.056-0.638-0.207-0.924c-0.097-0.297-0.262-0.555-0.496-0.772c-0.217-0.234-0.475-0.399-0.772-0.496 c-0.286-0.15-0.594-0.219-0.924-0.207c-0.62,0.028-1.264,0.231-1.696,0.702C220.505,57.009,220.256,57.573,220.239,58.228 L220.239,58.228z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1148_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M224.05,57.98c-0.113-1.078-1.919-1.428-2.236-0.308c-0.036,0.128,0.07,0.305,0.219,0.287 c0.353-0.042,0.554,0.221,0.514,0.537c-0.042,0.334-0.309,0.455-0.613,0.501c-0.288,0.043-0.166,0.48,0.121,0.438 c0.533-0.079,0.944-0.442,0.951-1.004c0.007-0.533-0.419-0.992-0.973-0.926c0.073,0.096,0.146,0.191,0.219,0.287 c0.17-0.602,1.284-0.389,1.344,0.187C223.626,58.267,224.08,58.27,224.05,57.98L224.05,57.98z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1146_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M204.157,58.228c0,0.013,0.001,0.027,0.001,0.04c0.016,0.625,0.256,1.25,0.702,1.696 c0.217,0.234,0.474,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.207c0.62-0.028,1.264-0.231,1.696-0.702 c0.424-0.462,0.719-1.052,0.702-1.696c0-0.013-0.001-0.027-0.001-0.04c-0.016-0.625-0.256-1.25-0.702-1.696 c-0.217-0.234-0.475-0.399-0.772-0.496c-0.286-0.15-0.594-0.219-0.924-0.207c-0.62,0.028-1.264,0.231-1.696,0.702 C204.435,56.995,204.14,57.585,204.157,58.228L204.157,58.228z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1145_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M205.597,57.98c0.061-0.577,1.174-0.788,1.344-0.187c0.073-0.096,0.146-0.192,0.219-0.287 c-0.552-0.066-0.982,0.392-0.973,0.926c0.01,0.562,0.416,0.924,0.951,1.004c0.286,0.042,0.409-0.395,0.121-0.438 c-0.304-0.045-0.571-0.166-0.614-0.501c-0.04-0.317,0.165-0.579,0.515-0.537c0.149,0.018,0.255-0.159,0.219-0.287 c-0.317-1.121-2.123-0.77-2.236,0.308C205.112,58.27,205.567,58.268,205.597,57.98L205.597,57.98z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1127_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1143_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M214.581,57.828c0.119,0.602-0.88,0.928-0.571,1.582c0.175,0.37,0.897,0.52,1.172,0.207 c0.169-0.192-0.112-0.476-0.283-0.283c-0.092,0.104-0.465,0.03-0.532-0.102c-0.091-0.178,0.169-0.405,0.262-0.514 c0.259-0.306,0.418-0.587,0.337-0.996C214.917,57.47,214.531,57.576,214.581,57.828L214.581,57.828z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1142_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M215.46,60.53c-0.406,0.678-1.317,0.684-1.728,0.005c-0.133-0.22-0.479-0.019-0.345,0.202 c0.564,0.933,1.857,0.932,2.418-0.005C215.938,60.511,215.592,60.31,215.46,60.53L215.46,60.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1139_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M219.097,61.162c1.654,0,1.656-2.57,0-2.57C217.444,58.592,217.441,61.162,219.097,61.162 L219.097,61.162z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1137_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M210.115,61.162c1.653,0,1.656-2.57,0-2.57C208.462,58.592,208.459,61.162,210.115,61.162 L210.115,61.162z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1133_",
    style: {
      fill: "#5D3338"
    },
    d: "M210.908,58.519c-0.343,0-0.621-0.375-0.621-0.837 c0-0.463,0.278-0.837,0.621-0.837c0.343,0,0.621,0.375,0.621,0.838C211.528,58.144,211.251,58.519,210.908,58.519z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1132_",
    style: {
      fill: "#5D3338"
    },
    d: "M218.285,58.519c0.343,0,0.621-0.375,0.621-0.837 c0-0.463-0.278-0.838-0.621-0.838s-0.621,0.375-0.621,0.837C217.664,58.144,217.942,58.519,218.285,58.519z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1130_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M220.377,56.603c-0.182-0.714-0.938-1.105-1.62-1.196 c-0.587-0.078-1.529-0.004-1.766,0.634c-0.068,0.183,0.104,0.332,0.265,0.349c0.437,0.044,0.821-0.271,1.282-0.257 c0.589,0.018,1.015,0.329,1.438,0.704C220.153,56.993,220.439,56.843,220.377,56.603L220.377,56.603z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1128_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M212.456,56.433c-0.359-0.63-0.884-1.008-1.64-0.961 c-0.601,0.037-1.372,0.388-1.258,1.085c0.014,0.086,0.11,0.143,0.191,0.145c0.416,0.012,0.649-0.257,1.037-0.36 c0.448-0.118,1.06-0.012,1.427,0.279C212.343,56.725,212.55,56.597,212.456,56.433L212.456,56.433z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M220.112,47.899c0.169-0.773-0.306-1.576-0.987-2.036s-1.532-0.635-2.365-0.727 c-2.607-0.29-5.299,0.135-7.662,1.209c-0.495,0.225-0.986,0.485-1.346,0.875c-0.323,0.35-0.523,0.784-0.694,1.218 c-0.501,1.281-0.784,2.637-0.833,4.002c-0.022,0.594,0.004,1.206,0.247,1.755c0.073,0.166,0.186,0.34,0.371,0.383 c0.233,0.055,0.449-0.121,0.618-0.282c1.73-1.658,3.46-3.316,5.191-4.974c-0.225,0.925-0.4,1.862-0.525,2.804 c-0.065,0.492-0.085,1.066,0.307,1.397c1.401-1.355,2.743-2.765,4.019-4.226c-0.215,1.291-0.413,2.584-0.593,3.879 c-0.04,0.289-0.023,0.668,0.27,0.761c0.225,0.071,0.453-0.09,0.624-0.245c1.828-1.655,2.986-3.951,3.192-6.331"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M220.175,47.899c0.091-3.499-5.02-3.14-7.337-2.774c-3.481,0.551-5.722,1.676-6.49,5.248 c-0.193,0.9-0.899,4.521,0.876,4.227c0.757-0.126,4.489-4.686,4.813-4.441c0.324,0.246-0.238,2.562,0.247,3.45 c0.054,0.1,0.194,0.11,0.272,0.035c0.93-0.897,1.785-1.897,2.736-2.767c0.693-0.634,0.514-0.989,0.736-0.18 c0.137,0.498-0.253,1.415-0.29,1.94c-0.034,0.485-0.284,1.229,0.339,1.491c0.693,0.292,1.68-1.167,1.936-1.486 c1.231-1.531,1.877-3.297,2.137-5.225c0.041-0.302-0.376-0.362-0.415-0.056c-0.195,1.527-0.731,4.024-2.05,4.997 c-0.24,0.725-0.571,0.811-0.992,0.258c-0.499-0.13-0.643-0.412-0.431-0.844c-0.116-0.6,0.29-1.862,0.381-2.423 c0.028-0.175-0.185-0.354-0.329-0.192c-0.697,0.789-1.69,2.385-2.632,2.858c-0.707,1.144-1.114,0.885-1.222-0.777 c0.108-0.625,0.233-1.247,0.375-1.866c0.039-0.182-0.177-0.322-0.318-0.185c-1.102,1.076-2.217,2.14-3.314,3.22 c-0.227,0.223-1.483,1.859-1.812,1.818c-1.444-0.18-0.815-3.732-0.671-4.282c0.405-1.548,0.628-2.041,2.008-2.986 c1.087-0.745,1.92-1.163,3.173-1.445c2.203-0.496,7.786-1.14,8.148,2.387C220.057,47.978,220.173,47.981,220.175,47.899 L220.175,47.899z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M221.411,56.692c-0.425-2.796-0.851-5.79-1.636-8.506c-0.092-0.317-0.179-0.683,0.007-0.956 c0.256-0.376,0.844-0.301,1.236-0.07c0.617,0.364,1.047,0.993,1.282,1.669c0.235,0.676,0.292,1.402,0.293,2.119 C222.596,52.916,222.191,54.884,221.411,56.692"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M221.564,56.692c-0.147-1.228-0.333-2.449-0.543-3.668 c-0.133-0.774-0.274-1.546-0.437-2.314c-0.121-0.567-0.517-1.393-0.46-1.941c-0.424-0.771-0.159-0.93,0.796-0.476 c0.875-0.155,1.311,0.216,1.307,1.112c0.166,0.71,0.154,1.473,0.122,2.199c-0.078,1.779-0.558,3.367-1.087,5.047 c-0.052,0.166,0.204,0.278,0.284,0.119c0.994-1.987,1.444-4.41,1.24-6.629c-0.11-1.198-0.687-3.147-2.15-3.348 c-1.076-0.148-1.122,0.619-1.031,1.44c0.143,1.283,0.65,2.615,0.887,3.894c0.283,1.531,0.492,3.075,0.773,4.606 C221.294,56.9,221.585,56.864,221.564,56.692L221.564,56.692z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M207.239,56.21c-0.064-0.878-0.121-1.757-0.171-2.637c-0.087-1.549-0.141-3.159,0.464-4.588 c0.078-0.185,0.214-0.394,0.414-0.379c0.185,0.014,0.292,0.214,0.348,0.391c0.23,0.731,0.183,1.518,0.096,2.279 C208.201,52.931,207.775,54.633,207.239,56.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M207.326,56.21c0.035-1.054-0.051-2.102-0.089-3.155c-0.02-0.542-0.222-3.36,0.308-3.535 c1.229-0.406,0.408,3.15,0.368,3.36c-0.212,1.114-0.604,2.182-0.81,3.292c-0.027,0.147,0.184,0.264,0.259,0.109 c0.402-0.829,2.586-7.679,0.613-7.877c-1.886-0.189-0.98,6.923-0.82,7.829C207.172,56.334,207.323,56.305,207.326,56.21 L207.326,56.21z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 403.58,
    cy: 188.965,
    rx: 29.866,
    ry: 7.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 403.58,
    cy: 190.717,
    rx: 42.86,
    ry: 11.297
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1165_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M396.228,111.568l0.015-0.02l0.003-0.005l0.002-0.003c0.3,0.281-0.411-0.39-0.321-0.304 l0.142,0.138l0.144,0.135l0.033,0.03h0l-0.001,0l-0.004-0.001c-0.012,0.01-0.031,0.026-0.055,0.051 c-0.051,0.056-0.117,0.132-0.189,0.23c-0.145,0.191-0.307,0.433-0.469,0.691c-0.327,0.522-0.657,1.11-0.98,1.715 c-0.648,1.215-1.274,2.503-1.892,3.805l-0.922,1.97l-0.464,1.006l-0.776,1.769c-0.516,1.167-1.028,2.327-1.558,3.413 c-0.264,0.544-0.537,1.055-0.817,1.523c-0.284,0.452-0.578,0.836-0.873,1.147c-0.296,0.305-0.584,0.548-0.865,0.744 c-0.28,0.206-0.557,0.299-0.828,0.433c-0.136,0.063-0.273,0.126-0.423,0.188c-0.075,0.031-0.156,0.062-0.249,0.091 c-0.049,0.017-0.102,0.021-0.162,0.042c-0.06-0.005-0.114-0.02-0.165-0.038c-0.375-0.144-0.626-0.306-0.912-0.471 c-0.555-0.301-1.112-0.855-1.671-1.59c-0.277-0.382-0.546-0.829-0.803-1.314c-0.254-0.498-0.501-1.012-0.737-1.553 c-0.474-1.07-0.917-2.18-1.344-3.274l-0.596-1.563l-0.374-1.049c-0.495-1.398-0.975-2.796-1.447-4.196l3.443-1.326 c0.583,1.341,1.174,2.678,1.775,4.006l0.453,0.994l0.162,0.335l0.139,0.274c0.184,0.361,0.363,0.706,0.54,1.034 c0.356,0.654,0.687,1.249,1.056,1.748c0.097,0.12,0.186,0.248,0.325,0.323c0.035,0.021,0.087,0.013,0.12-0.029 c0.033-0.037,0.062-0.079,0.087-0.123c0.051-0.087,0.095-0.179,0.136-0.27c0.162-0.367,0.29-0.732,0.41-1.082 c0.238-0.701,0.434-1.348,0.607-1.931l0.124-0.427l0.373-1.031l0.768-2.087c0.522-1.396,1.06-2.794,1.666-4.214 c0.305-0.711,0.627-1.426,1.003-2.167c0.191-0.372,0.395-0.75,0.641-1.153c0.122-0.2,0.261-0.411,0.419-0.633 c0.168-0.228,0.34-0.458,0.619-0.744L396.228,111.568z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M396.293,111.642l-4.326-5.428c-0.089,0.069-0.181,0.134-0.267,0.209 c-0.086,0.073-0.168,0.14-0.274,0.246c-0.102,0.098-0.199,0.197-0.272,0.279c-0.08,0.087-0.161,0.178-0.223,0.255 c-0.275,0.327-0.476,0.612-0.662,0.887c-0.371,0.55-0.662,1.052-0.941,1.551c-0.55,0.994-1.022,1.953-1.478,2.911l6.662,3.255 c0.4-0.921,0.79-1.836,1.164-2.668c0.185-0.41,0.371-0.812,0.525-1.12c0.076-0.158,0.144-0.283,0.165-0.346l0.007-0.024 l-0.003-0.001l-0.002-0.001c-0.008-0.007,0.019,0.018-0.032-0.028c-0.141-0.125-0.279-0.254-0.414-0.387l-0.006-0.006 c-0.4-0.377,0.537,0.505,0.441,0.415l-0.001,0.001l-0.002,0.002l-0.004,0.003l-0.008,0.006l-0.017,0.011 c-0.009,0.005-0.029,0.017-0.031,0.015v-0.011C396.291,111.657,396.292,111.65,396.293,111.642z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M380.194,116.712c0.544-1.2,1.048-2.427,1.508-3.679c0.088-0.241,0.347-0.347,0.577-0.236 c0.204,0.098,0.318,0.333,0.28,0.553c-0.234,1.362-0.517,2.717-0.845,4.063l-0.001,0.003 c-0.111,0.457-0.553,0.706-0.987,0.554c-0.435-0.152-0.696-0.65-0.584-1.108 C380.155,116.81,380.174,116.758,380.194,116.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M380.147,117.242c-0.61-2.51-1.262-5.016-1.964-7.51c-0.073-0.259,0.059-0.518,0.294-0.579 c0.22-0.058,0.453,0.081,0.542,0.31c0.933,2.434,1.82,4.894,2.666,7.364c0.158,0.459-0.051,0.944-0.468,1.085 c-0.417,0.14-0.885-0.12-1.044-0.583C380.162,117.3,380.153,117.27,380.147,117.242z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M378.998,117.026c-0.737-2.435-1.526-4.857-2.373-7.265c-0.09-0.255,0.024-0.527,0.254-0.606 c0.215-0.074,0.455,0.047,0.558,0.27c1.073,2.332,2.094,4.696,3.065,7.08c0.184,0.451,0.006,0.953-0.4,1.123 c-0.406,0.169-0.887-0.062-1.073-0.516C379.018,117.085,379.007,117.055,378.998,117.026z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M377.992,117.088c-0.812-2.081-1.602-4.166-2.377-6.258 c-0.094-0.254,0.015-0.529,0.242-0.613c0.211-0.078,0.451,0.035,0.559,0.254l0.007,0.014 c0.984,1.978,1.982,3.946,2.998,5.903l0.012,0.024c0.226,0.434,0.097,0.959-0.289,1.174 c-0.385,0.215-0.883,0.036-1.11-0.401C378.02,117.155,378.004,117.119,377.992,117.088z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M377.667,118.279c-0.814-1.559-1.613-3.123-2.403-4.691 c-0.122-0.243-0.047-0.533,0.168-0.648c0.195-0.104,0.437-0.029,0.572,0.167l0.004,0.006 c0.985,1.43,1.977,2.853,2.981,4.266l0.007,0.009c0.283,0.398,0.232,0.945-0.114,1.224 c-0.346,0.279-0.858,0.182-1.143-0.218C377.712,118.358,377.688,118.316,377.667,118.279z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M381.169,116.487c-0.365,0.643-0.414,1.396-1.211,1.628c-0.942,0.275-1.483-0.655-1.87-1.459 c-0.3-0.624-1.073-0.311-0.889,0.347c0.302,1.076,0.828,2.152,1.954,2.333c1.005,0.161,1.82-0.545,2.105-1.509 c0.119-0.402-0.256-0.932-0.668-0.737c-0.391,0.185-0.728,0.26-1.169,0.201l0.339,0.853l-0.114-0.271l-0.077-0.526 l-0.247-0.004l0.106,0.399l-0.453,0.085l-0.196-0.364l0.2-0.232l0.305,0.436c-0.046-0.183-0.081-0.323-0.202-0.471 c-0.145-0.177-0.372-0.241-0.546-0.105l-0.07,0.055c-0.119,0.093-0.217,0.296-0.174,0.469 c0.163,0.649,0.871,0.914,1.301,0.417c0.392-0.453,0.038-1.243-0.562-1.194c-0.642,0.053-0.747,0.938-0.256,1.373 c0.541,0.478,1.496,0.245,1.7-0.417c0.049-0.158,0.05-0.386-0.076-0.524c-0.477-0.524-1.083-0.343-1.424,0.196 c-0.186,0.294-0.045,0.804,0.339,0.855c0.599,0.08,1.14,0.021,1.682-0.217l-0.669-0.738 c-0.178,0.571-0.684,1.143-1.332,0.866c-0.564-0.241-0.749-1.028-0.905-1.578l-0.889,0.347 c0.596,1.228,1.454,2.414,2.833,2.165c0.97-0.176,2.053-1.449,1.58-2.596C381.539,116.392,381.272,116.306,381.169,116.487z "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1164_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M414.949,106.464c0.862,0.671,1.483,1.373,2.02,2.062c0.536,0.691,0.97,1.376,1.356,2.056 c0.776,1.361,1.37,2.706,1.895,4.052c0.523,1.345,0.965,2.689,1.359,4.04c0.391,1.355,0.733,2.704,1.019,4.12l0.142,0.724 c0.057,0.277,0.093,0.554,0.135,0.83l0.04,0.413c0.007,0.137,0.003,0.273,0.006,0.409l-0.013,0.203l-0.003,0.051 l-0.002,0.025l-0.001,0.013c-0.076-0.005-0.022,0.006-0.039,0.008l-0.014,0.102c-0.016,0.136-0.044,0.27-0.071,0.402 c-0.13,0.527-0.401,1.021-0.676,1.501c-0.141,0.231-0.288,0.494-0.424,0.696l-0.304,0.452 c-0.809,1.168-1.624,2.243-2.449,3.315c-1.648,2.137-3.326,4.214-5.015,6.282l-2.961-2.201 c1.475-2.197,2.938-4.405,4.34-6.625c0.698-1.108,1.389-2.226,2.005-3.323l0.221-0.406c0.05-0.094,0.072-0.153,0.108-0.23 c0.064-0.145,0.125-0.289,0.165-0.438c0.051-0.151-0.024-0.31-0.061-0.457l-0.071-0.219l-0.036-0.107 c-0.011-0.029-0.037-0.119-0.058-0.19c-0.727-2.381-1.673-4.797-2.773-7.006c-0.552-1.104-1.155-2.166-1.809-3.093 c-0.324-0.465-0.665-0.895-1.005-1.251c-0.337-0.358-0.68-0.649-0.951-0.806L414.949,106.464z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M414.514,106.046l-3.71,5.877c0.278,0.206,0.712,0.634,1.113,1.193 c0.407,0.56,0.802,1.223,1.17,1.928c2.191-1.142,4.392-2.267,6.602-3.373c-0.542-0.969-1.169-1.933-1.963-2.886 C416.932,107.842,415.951,106.866,414.514,106.046z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M413.065,134.691c-1.254,0.109-2.506,0.265-3.754,0.47c-0.24,0.04-0.467-0.123-0.508-0.363 c-0.036-0.212,0.088-0.415,0.283-0.486c1.21-0.441,2.442-0.837,3.695-1.189l0.003-0.001c0.425-0.12,0.867,0.127,0.986,0.553 c0.119,0.426-0.132,0.869-0.557,0.989C413.165,134.678,413.113,134.687,413.065,134.691z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M413.512,134.486c-1.656,1.657-3.276,3.353-4.854,5.089c-0.164,0.18-0.442,0.193-0.622,0.03 c-0.168-0.153-0.188-0.408-0.057-0.587c1.404-1.897,2.858-3.764,4.353-5.597c0.278-0.341,0.779-0.394,1.121-0.117 c0.342,0.277,0.394,0.78,0.114,1.123C413.55,134.446,413.531,134.467,413.512,134.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M413.977,135.524c-1.524,1.726-3,3.495-4.428,5.309c-0.151,0.192-0.429,0.226-0.619,0.075 c-0.178-0.141-0.216-0.394-0.098-0.582c1.243-1.964,2.545-3.896,3.9-5.792c0.256-0.359,0.754-0.445,1.113-0.19 c0.359,0.254,0.442,0.754,0.184,1.115C414.013,135.481,413.995,135.504,413.977,135.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M414.583,136.318c-1.199,1.623-2.409,3.236-3.629,4.842 c-0.148,0.195-0.426,0.234-0.618,0.087c-0.179-0.137-0.223-0.384-0.111-0.575l0.007-0.012 c1.013-1.724,2.015-3.453,3.004-5.188l0.012-0.022c0.22-0.385,0.707-0.521,1.091-0.305c0.384,0.216,0.517,0.706,0.297,1.092 C414.62,136.264,414.601,136.294,414.583,136.318z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M415.707,136.035c-0.786,1.382-1.579,2.758-2.38,4.131c-0.124,0.213-0.395,0.286-0.605,0.164 c-0.191-0.111-0.266-0.344-0.186-0.545l0.002-0.006c0.583-1.468,1.157-2.938,1.723-4.41l0.004-0.01 c0.159-0.415,0.622-0.624,1.035-0.47c0.413,0.155,0.62,0.618,0.459,1.035C415.745,135.962,415.726,136.002,415.707,136.035z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M412.346,133.997c0.712,0.001,1.338-0.305,1.963,0.24c0.739,0.644,0.301,1.514-0.122,2.202 c-0.329,0.533,0.348,1.021,0.768,0.566c0.685-0.743,1.247-1.667,0.77-2.671c-0.427-0.897-1.437-1.24-2.362-1.028 c-0.385,0.088-0.6,0.639-0.216,0.887c0.363,0.235,0.609,0.475,0.806,0.864l0.49-0.67l-0.152,0.218l-0.375,0.305l0.134,0.204 l0.258-0.271l0.318,0.331l-0.18,0.328l-0.295-0.057l0.178-0.45c-0.12,0.122-0.211,0.215-0.262,0.382 c-0.061,0.2,0.015,0.415,0.219,0.495l0.083,0.032c0.14,0.055,0.355,0.041,0.468-0.074c0.424-0.432,0.244-1.132-0.388-1.255 c-0.577-0.113-1.008,0.542-0.637,1.01c0.398,0.501,1.158,0.179,1.231-0.423c0.08-0.662-0.632-1.337-1.271-1.199 c-0.152,0.033-0.335,0.137-0.374,0.304c-0.152,0.632,0.328,1.044,0.944,1.075c0.336,0.016,0.663-0.333,0.491-0.671 c-0.268-0.527-0.614-0.943-1.102-1.277l-0.216,0.888c0.553-0.117,1.285,0.033,1.425,0.691 c0.121,0.572-0.401,1.086-0.751,1.467l0.768,0.566c0.643-1.054,1.109-2.298,0.151-3.313 c-0.675-0.713-2.286-1.015-2.937-0.097C412.066,133.739,412.146,133.997,412.346,133.997z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M394.587,105.23c-2.929,0.596-4.247,1.854-3.62,5.661l2.991,21.129h9.535h9.535l2.991-21.129 c0.627-3.807-0.69-5.064-3.62-5.661l-8.906-1.469L394.587,105.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M391.937,142.663h11.557h11.557c0-3.471-1.037-7.528-2.04-10.644h-9.517h-9.517 C392.974,135.135,391.937,139.192,391.937,142.663z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1163_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M410.174,133.891c0.142,2.497,1.994,4.62,4.468,5.05c0.321,0.056,0.458-0.435,0.135-0.491 c-2.242-0.39-3.964-2.276-4.094-4.559C410.665,133.565,410.155,133.563,410.174,133.891L410.174,133.891z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1162_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M403.223,132.057c0.034,2.353,0.068,4.706,0.103,7.058c0.145-0.06,0.29-0.12,0.435-0.18 c-0.347-0.285-0.956-0.615-1.212-0.995c-0.447-0.662-0.332-1.63-0.331-2.385c0.002-1.135,0.039-2.267,0.099-3.4 c0.017-0.328-0.492-0.327-0.509,0c-0.087,1.643-0.186,3.326-0.081,4.97c0.072,1.133,0.81,1.461,1.674,2.17 c0.162,0.133,0.438,0.057,0.435-0.18c-0.034-2.353-0.068-4.706-0.103-7.058C403.728,131.73,403.218,131.729,403.223,132.057 L403.223,132.057z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1161_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M396.221,133.891c-0.13,2.283-1.852,4.169-4.094,4.559c-0.322,0.056-0.186,0.547,0.135,0.491 c2.474-0.43,4.325-2.554,4.468-5.05C396.749,133.563,396.239,133.564,396.221,133.891L396.221,133.891z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 3.8513,
      strokeMiterlimit: 10
    },
    points: "410.465,178.627  410.382,183.332 410.336,185.938  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M407.129,183.912l-0.023-0.594l-0.919-21.652l-0.115-2.709l-0.057-1.355 c-0.013-0.027-0.026-0.07-0.045-0.107c-0.003-0.007-0.004-0.004-0.007-0.02l-0.014-0.083l-0.028-0.167l-0.056-0.333 l-0.899-5.329l-1.798-10.658l11.679-1.254l0.507,10.796l0.253,5.398l0.016,0.337l0.008,0.169l0.004,0.084l0.011,0.148 c0.01,0.205,0.042,0.409,0.034,0.614l-0.032,0.625l-0.105,1.342l-0.209,2.684l-1.676,21.496l-0.044,0.591L407.129,183.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M412.44,185.005c-1.361,0.041-2.723,0.049-4.084,0.027c-0.562,1.007-0.935,2.117-1.096,3.254 c-0.041,0.289,0.177,0.546,0.467,0.546l5.118-0.001c0.292,0,0.526-0.259,0.484-0.547 C413.163,187.16,412.865,186.057,412.44,185.005z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M408.511,186.487l0.165-1.098c0.053-0.354,0.12-0.736,0.377-0.988 c0.184-0.18,0.44-0.265,0.691-0.318c0.466-0.099,0.972-0.102,1.391,0.117c0.441,0.231,0.73,0.684,0.873,1.161 c0.143,0.477,0.158,0.983,0.171,1.483"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 3.8513,
      strokeMiterlimit: 10
    },
    points: "397.528,178.733  397.665,183.66 397.715,186.046  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M395.615,185.283c0,0-0.964,0.45-2.226,1.04c-1.255,0.6-2.798,1.351-3.949,1.962 c-0.232,0.125-0.494,0.401-0.312,0.588c0.084,0.086,0.221,0.092,0.344,0.092h7.95c0.042-0.695,0.403-1.366,0.952-1.784 l0.553,1.368c0.107,0.271,0.164,0.415,0.164,0.415h1.587c0,0,0.113-0.891-0.002-1.69c-0.084-0.537-0.569-1.925-0.748-2.028 c-0.114-0.067-0.255-0.055-0.386-0.041C398.38,185.332,395.615,185.283,395.615,185.283"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M394.432,184.099l-0.029-0.361c-0.615-7.185-1.329-14.383-2.049-21.572l-0.273-2.696 l-0.138-1.347l-0.039-0.439c-0.018-0.166-0.027-0.332-0.016-0.498l0.01-0.454l0.003-0.339l0.039-5.427l0.078-10.854 l11.72,0.79l-1.379,10.766l-0.69,5.383l-0.043,0.336l-0.011,0.084c-0.003,0.023-0.004,0.013-0.006,0.021 c-0.003,0.008-0.009,0.015-0.012,0.023c-0.009,0.016-0.015,0.031-0.02,0.048l-0.01,0.024l-0.002,0.005l-0.001,0.039 l-0.001,0.085l-0.025,1.361l-0.052,2.72c-0.147,7.254-0.302,14.493-0.555,21.785l-0.012,0.367L394.432,184.099z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M391.072,109.852c-0.398,3.752,0.617,7.627,1.214,11.315c0.047,0.288,0.484,0.166,0.438-0.121 c-0.592-3.656-1.592-7.481-1.197-11.195C391.557,109.562,391.102,109.564,391.072,109.852L391.072,109.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M415.362,110.981c-0.188,3.758-0.558,7.498-1.114,11.22c-0.043,0.286,0.395,0.409,0.438,0.121 c0.561-3.762,0.939-7.542,1.13-11.341C415.831,110.689,415.377,110.689,415.362,110.981L415.362,110.981z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1126_",
    style: {
      opacity: 0,
      fill: "#94533B"
    },
    cx: 403.49,
    cy: 82.126,
    r: 4.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1125_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 403.49,
    y1: 101.818,
    x2: 403.49,
    y2: 105.28
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M403.49,105.911c1.772,0,3.208-0.282,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C400.281,105.628,401.718,105.911,403.49,105.911z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 403.49,
    y1: 101.818,
    x2: 403.49,
    y2: 105.28
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M403.49,105.911c1.772,0,3.208-0.282,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C400.281,105.628,401.718,105.911,403.49,105.911z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1123_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M400.365,103.57h6.25c2.3,0,4.164-1.864,4.164-4.164V91.3c0-3.704-3.003-6.707-6.707-6.707 h-1.164c-3.704,0-6.707,3.003-6.707,6.707v8.106C396.201,101.706,398.065,103.57,400.365,103.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1120_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1122_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M409.133,96.777c0,0.013-0.001,0.027-0.001,0.04c-0.012,0.33,0.056,0.638,0.207,0.924 c0.097,0.297,0.262,0.555,0.496,0.772c0.217,0.234,0.474,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.207 c0.62-0.028,1.264-0.231,1.696-0.702c0.437-0.476,0.685-1.041,0.702-1.696c0-0.013,0.001-0.027,0.001-0.04 c0.012-0.33-0.056-0.638-0.207-0.924c-0.097-0.297-0.262-0.555-0.496-0.772c-0.217-0.234-0.475-0.399-0.772-0.496 c-0.286-0.15-0.594-0.219-0.924-0.206c-0.62,0.028-1.264,0.231-1.696,0.702C409.398,95.557,409.15,96.122,409.133,96.777 L409.133,96.777z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1121_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M412.943,96.528c-0.113-1.077-1.919-1.428-2.236-0.308 c-0.036,0.128,0.07,0.305,0.219,0.287c0.353-0.042,0.555,0.221,0.515,0.537c-0.042,0.334-0.309,0.455-0.614,0.5 c-0.288,0.043-0.166,0.48,0.121,0.438c0.533-0.079,0.944-0.442,0.951-1.004c0.007-0.533-0.419-0.992-0.973-0.926 c0.073,0.096,0.146,0.192,0.219,0.287c0.17-0.602,1.284-0.389,1.344,0.187C412.519,96.816,412.974,96.819,412.943,96.528 L412.943,96.528z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1117_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1119_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M393.05,96.777c0,0.013,0.001,0.027,0.001,0.04c0.016,0.625,0.256,1.25,0.703,1.696 c0.217,0.234,0.474,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.207c0.62-0.028,1.264-0.231,1.696-0.702 c0.424-0.462,0.719-1.052,0.702-1.696c0-0.013-0.001-0.027-0.001-0.04c-0.016-0.625-0.256-1.25-0.703-1.696 c-0.217-0.234-0.474-0.399-0.772-0.496c-0.286-0.15-0.594-0.219-0.924-0.206c-0.62,0.028-1.264,0.231-1.696,0.702 C393.328,95.543,393.033,96.133,393.05,96.777L393.05,96.777z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1118_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M394.49,96.528c0.06-0.577,1.174-0.788,1.344-0.187c0.073-0.096,0.146-0.192,0.219-0.287 c-0.552-0.066-0.982,0.393-0.973,0.926c0.01,0.562,0.416,0.924,0.951,1.004c0.286,0.042,0.409-0.395,0.121-0.438 c-0.304-0.045-0.571-0.166-0.613-0.5c-0.04-0.317,0.165-0.579,0.514-0.537c0.149,0.018,0.255-0.159,0.219-0.287 c-0.317-1.121-2.123-0.77-2.236,0.308C394.006,96.819,394.46,96.816,394.49,96.528L394.49,96.528z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1070_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1116_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M403.475,96.377c0.119,0.602-0.88,0.928-0.571,1.581c0.175,0.37,0.897,0.52,1.172,0.207 c0.169-0.192-0.112-0.476-0.283-0.283c-0.092,0.104-0.465,0.03-0.532-0.102c-0.091-0.178,0.169-0.405,0.262-0.514 c0.259-0.306,0.418-0.587,0.337-0.996C403.81,96.018,403.425,96.125,403.475,96.377L403.475,96.377z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1115_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M404.354,99.079c-0.406,0.678-1.317,0.684-1.728,0.005 c-0.133-0.22-0.479-0.019-0.345,0.202c0.564,0.933,1.858,0.932,2.418-0.005C404.831,99.06,404.486,98.858,404.354,99.079 L404.354,99.079z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1113_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M407.99,99.71c1.654,0,1.656-2.57,0-2.57C406.337,97.141,406.334,99.71,407.99,99.71 L407.99,99.71z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1110_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M399.008,99.71c1.653,0,1.656-2.57,0-2.57C397.355,97.141,397.352,99.71,399.008,99.71 L399.008,99.71z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1109_",
    style: {
      fill: "#5D3338"
    },
    d: "M399.801,97.067c-0.343,0-0.621-0.375-0.621-0.837 c0-0.463,0.278-0.837,0.621-0.837c0.343,0,0.621,0.375,0.621,0.837C400.422,96.693,400.144,97.067,399.801,97.067z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1108_",
    style: {
      fill: "#5D3338"
    },
    d: "M407.178,97.068c0.343,0,0.621-0.375,0.621-0.838 s-0.278-0.837-0.621-0.838c-0.343,0-0.621,0.375-0.621,0.838S406.835,97.068,407.178,97.068z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1073_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M409.271,95.151c-0.182-0.714-0.938-1.105-1.62-1.196 c-0.587-0.078-1.529-0.004-1.766,0.634c-0.068,0.183,0.104,0.332,0.266,0.349c0.437,0.044,0.821-0.271,1.282-0.257 c0.589,0.018,1.015,0.329,1.438,0.704C409.046,95.541,409.332,95.392,409.271,95.151L409.271,95.151z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1071_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M401.35,94.982c-0.359-0.63-0.884-1.008-1.64-0.961c-0.6,0.037-1.371,0.388-1.258,1.085 c0.014,0.086,0.111,0.143,0.191,0.145c0.416,0.012,0.649-0.258,1.037-0.36c0.448-0.118,1.06-0.011,1.427,0.279 C401.237,95.274,401.443,95.146,401.35,94.982L401.35,94.982z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M409.598,88.901c-1.454,2.317-4.058,3.872-6.788,4.052c0.702-1.308,1.624-2.497,2.715-3.504 c-3.187,2.319-7.154,3.544-11.093,3.425c-0.139-1.672,0.037-3.388,0.672-4.941c0.636-1.553,1.752-2.933,3.223-3.739 c1.331-0.73,2.873-0.964,4.382-1.125c0.902-0.096,1.818-0.17,2.714-0.025c0.896,0.145,1.781,0.531,2.37,1.222 c0.487,0.572,0.736,1.302,0.975,2.014c1.13-0.489,2.497,0.294,3.034,1.402c0.537,1.108,0.438,2.413,0.211,3.623 c-0.302,1.611-0.81,3.183-1.508,4.666c-0.572-2.638-1.102-5.286-1.589-7.941"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M409.501,88.804c-1.007,1.28-2.205,2.674-3.834,3.148c-3.199,0.932-1.53-0.81,0.01-2.35 c0.169-0.169-0.052-0.475-0.261-0.338c-1.619,1.06-9.466,5.501-10.775,2.353c-0.976-2.347,1.963-6.16,3.816-7.198 c2.837-1.589,8.547-2.144,10.085,1.926c0.049,0.131,0.152,0.183,0.289,0.164c1.043,0.983,2.086,1.965,3.129,2.948 c-0.005,0.811-0.106,1.607-0.304,2.388c-0.095,0.462-0.517,2.801-1.192,2.741c-0.276-0.024-1.255-5.981-1.428-6.588 c-0.037-0.129-0.256-0.11-0.243,0.033c0.246,2.696,0.891,5.366,1.488,8.003c0.041,0.183,0.347,0.243,0.427,0.056 c1.043-2.414,3.026-6.941,0.772-9.289c-0.656-0.684-1.186-0.465-1.836-0.918c-1.01-0.704-1.372-1.716-2.378-2.4 c-2.332-1.587-6.723-0.804-9.069,0.49c-3.242,1.788-4.137,5.47-4.016,8.903c0.005,0.135,0.111,0.252,0.251,0.251 c2.815-0.017,5.52-0.478,8.1-1.66c-0.112,0.051,2.736-1.259,2.056-1.38c-0.403-0.071-1.874,2.607-1.963,2.758 c-0.075,0.127,0.018,0.344,0.185,0.323c2.949-0.379,5.269-1.687,6.907-4.198C409.8,88.842,409.599,88.68,409.501,88.804 L409.501,88.804z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M397.499,91.428c-0.409,1.591-0.817,3.182-1.226,4.773c-0.415-1.981-0.092-4.034-0.164-6.056 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M397.375,91.356c-0.656,1.492-0.935,3.204-1.345,4.779c0.162,0,0.324,0,0.487,0 c-0.357-2.001,0.032-4.024-0.301-6.019c-0.022-0.133-0.203-0.082-0.216,0.029c-0.247,2.015-0.34,4.119,0.031,6.124 c0.046,0.25,0.428,0.231,0.487,0c0.4-1.579,0.983-3.216,1.127-4.84C397.655,91.29,397.432,91.226,397.375,91.356 L397.375,91.356z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 149.887,
    cy: 439.869,
    rx: 48.3,
    ry: 12.065
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 149.887,
    cy: 442.702,
    rx: 69.315,
    ry: 18.271
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M166.357,305.601c2.033,3.517,3.948,7.293,5.47,11.189c0.765,1.942,1.43,3.885,2.044,5.794 l0.893,2.848l0.431,1.411l0.213,0.703l0.323,1.012c0.236,0.793,0.361,1.619,0.316,2.445c-0.014,0.413-0.055,0.823-0.123,1.232 c-0.031,0.203-0.061,0.41-0.102,0.608l-0.117,0.524c-0.287,1.185-0.627,2.202-0.979,3.206c-0.712,1.983-1.49,3.843-2.292,5.68 c-1.605,3.667-3.313,7.218-5.027,10.749l-4.984-2.141c1.366-3.651,2.715-7.299,3.919-10.945 c0.601-1.82,1.166-3.645,1.623-5.426c0.221-0.883,0.421-1.769,0.531-2.552c0.028-0.215,0.034-0.278,0.037-0.405 c0.007-0.113,0.006-0.225-0.002-0.337c-0.006-0.223-0.072-0.44-0.18-0.636l-2.139-5.118c-0.752-1.755-1.523-3.463-2.357-5.109 c-1.658-3.29-3.605-6.386-5.789-9.463L166.357,305.601z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M166.186,305.063l-8.601,5.518c1.36,2.224,2.618,4.453,3.732,6.707 c3.268-1.589,6.54-3.163,9.821-4.723C169.704,309.856,168.007,307.36,166.186,305.063z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M165.003,348.237c-1.755,0.582-3.495,1.228-5.212,1.951c-0.33,0.139-0.71-0.015-0.849-0.346 c-0.123-0.292-0.014-0.625,0.241-0.794c1.583-1.045,3.21-2.026,4.881-2.955l0.003-0.002c0.566-0.315,1.282-0.114,1.598,0.454 c0.316,0.568,0.109,1.288-0.46,1.604C165.14,348.185,165.069,348.215,165.003,348.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M165.572,347.792c-1.802,2.94-3.56,5.888-5.197,8.979c-0.169,0.324-0.563,0.456-0.879,0.291 c-0.296-0.153-0.417-0.522-0.292-0.836c1.344-3.289,2.806-6.423,4.316-9.558c0.281-0.581,0.979-0.827,1.563-0.548 c0.584,0.279,0.829,0.981,0.546,1.567C165.612,347.722,165.592,347.759,165.572,347.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M166.589,349.12c-1.586,2.989-3.128,6.012-4.478,9.112c-0.139,0.328-0.518,0.484-0.849,0.349 c-0.309-0.126-0.461-0.474-0.364-0.794c1.051-3.295,2.284-6.483,3.573-9.66c0.245-0.601,0.927-0.892,1.527-0.651 c0.6,0.241,0.889,0.929,0.643,1.533C166.626,349.046,166.608,349.084,166.589,349.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M167.727,350.05l-3.499,8.134c-0.138,0.326-0.51,0.475-0.842,0.34 c-0.305-0.126-0.465-0.457-0.375-0.768l0.006-0.02l2.496-8.44l0.01-0.035c0.182-0.626,0.835-0.986,1.457-0.808 c0.623,0.179,0.979,0.834,0.795,1.463C167.762,349.961,167.744,350.009,167.727,350.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M169.238,349.262l-1.993,6.708c-0.103,0.344-0.463,0.538-0.806,0.437 c-0.311-0.092-0.5-0.398-0.456-0.71l0.001-0.009l0.959-6.886l0.002-0.015c0.086-0.648,0.677-1.106,1.321-1.026 c0.644,0.08,1.096,0.673,1.008,1.325C169.268,349.144,169.254,349.207,169.238,349.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M163.738,347.49c1.019-0.239,1.809-0.89,2.889-0.324c1.276,0.668,0.945,2.064,0.572,3.192 c-0.289,0.875,0.845,1.342,1.291,0.549c0.729-1.296,1.22-2.814,0.193-4.089c-0.917-1.137-2.48-1.279-3.73-0.662 c-0.52,0.258-0.64,1.117-0.007,1.342c0.599,0.212,1.033,0.472,1.447,0.961l0.473-1.126l-0.143,0.363l-0.433,0.564 l0.261,0.246l0.276-0.475l0.568,0.365l-0.147,0.531l-0.441,0.019l0.102-0.705c-0.13,0.216-0.229,0.38-0.245,0.636 c-0.019,0.307,0.162,0.589,0.482,0.634l0.129,0.018c0.219,0.03,0.522-0.062,0.644-0.265c0.461-0.763-0.036-1.704-0.982-1.665 c-0.863,0.036-1.257,1.119-0.567,1.662c0.739,0.581,1.718-0.138,1.617-1.025c-0.11-0.975-1.36-1.697-2.226-1.281 c-0.207,0.099-0.432,0.31-0.432,0.562c-0.002,0.956,0.822,1.382,1.716,1.216c0.486-0.091,0.834-0.704,0.474-1.128 c-0.563-0.663-1.2-1.139-2.012-1.449l-0.007,1.343c0.75-0.356,1.851-0.391,2.273,0.503c0.368,0.778-0.205,1.692-0.576,2.355 l1.291,0.549c0.563-1.726,0.807-3.673-0.911-4.794c-1.211-0.788-3.616-0.668-4.233,0.863 C163.25,347.215,163.451,347.557,163.738,347.49z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M135.356,306.139c-0.438,0.565-0.687,0.999-0.994,1.475c-0.305,0.476-0.521,0.896-0.784,1.347 c-0.481,0.878-0.926,1.737-1.338,2.591c-0.829,1.709-1.592,3.402-2.303,5.114c-0.712,1.713-1.388,3.434-2.02,5.207 l-0.464,1.349l-0.444,1.403l-0.212,0.749l-0.105,0.374l-0.103,0.427c-0.061,0.287-0.146,0.576-0.206,0.952 c-0.058,0.378-0.107,0.758-0.147,1.135c-0.027,1.736,0.167,2.866,0.383,4.039c0.119,0.557,0.229,1.129,0.36,1.668l0.413,1.589 c0.587,2.076,1.222,4.088,1.928,6.049c1.388,3.938,2.94,7.754,4.629,11.541l5.047-1.987 c-1.264-3.776-2.409-7.614-3.359-11.456c-0.489-1.919-0.894-3.841-1.239-5.733l-0.224-1.406 c-0.067-0.464-0.104-0.91-0.159-1.364c-0.092-0.866-0.092-1.785-0.034-2.229c0.023-0.094,0.059-0.186,0.077-0.278l0.139-0.399 c0.044-0.143,0.113-0.321,0.187-0.504l0.21-0.536l0.478-1.121l0.521-1.141c0.716-1.527,1.493-3.056,2.298-4.563 c0.803-1.509,1.654-2.991,2.524-4.418c0.434-0.715,0.882-1.404,1.328-2.06c0.223-0.307,0.45-0.66,0.667-0.927 c0.214-0.267,0.446-0.59,0.612-0.739L135.356,306.139z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M135.728,305.454l7.661,6.762c-0.105,0.157-0.211,0.295-0.329,0.454l-0.416,0.641 c-0.141,0.219-0.287,0.483-0.431,0.721c-0.146,0.238-0.29,0.494-0.433,0.76c-0.581,1.028-1.137,2.149-1.684,3.261l-9.839-4.692 c0.688-1.29,1.408-2.553,2.257-3.828c0.405-0.628,0.883-1.284,1.362-1.928l0.815-1.015 C135.008,306.221,135.379,305.822,135.728,305.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M136.567,348.553c1.709,0.632,3.407,1.297,5.068,1.996c0.321,0.133,0.705-0.013,0.858-0.323 c0.138-0.276,0.05-0.591-0.193-0.753c-1.512-1.001-3.068-1.997-4.665-2.962l-0.003-0.002 c-0.542-0.328-1.268-0.165-1.618,0.373c-0.35,0.538-0.195,1.252,0.358,1.578 C136.434,348.497,136.503,348.529,136.567,348.553z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M136.025,348.099c1.623,2.915,3.226,5.869,4.884,8.658c0.177,0.279,0.566,0.351,0.869,0.163 c0.284-0.175,0.397-0.508,0.272-0.764c-1.318-2.899-2.613-6.002-3.917-9.067c-0.238-0.573-0.917-0.84-1.515-0.595 s-0.887,0.917-0.646,1.5C135.988,348.03,136.006,348.066,136.025,348.099z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M134.939,349.353c0.709,1.492,1.418,2.985,2.128,4.48c0.711,1.494,1.418,2.989,2.199,4.465 c0.166,0.314,0.552,0.426,0.863,0.25c0.291-0.164,0.417-0.513,0.305-0.8c-0.599-1.496-1.143-3.055-1.69-4.608 c-0.547-1.557-1.095-3.116-1.642-4.676c-0.212-0.589-0.871-0.9-1.482-0.691c-0.613,0.21-0.943,0.869-0.727,1.469 C134.906,349.28,134.922,349.318,134.939,349.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M133.757,350.222c1.029,2.736,2.1,5.436,3.382,8.154c0.159,0.333,0.564,0.478,0.879,0.315 c0.296-0.15,0.422-0.498,0.314-0.803l-0.007-0.02c-0.922-2.763-1.647-5.524-2.324-8.302l-0.008-0.034 c-0.147-0.616-0.777-0.992-1.408-0.844c-0.631,0.149-1.02,0.775-0.869,1.401 C133.727,350.132,133.742,350.181,133.757,350.222z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M132.288,349.383c0.536,2.245,1.107,4.486,1.762,6.746c0.106,0.352,0.47,0.555,0.813,0.453 c0.311-0.092,0.498-0.401,0.453-0.715l-0.001-0.009c-0.306-2.3-0.538-4.565-0.713-6.829l-0.001-0.015 c-0.057-0.634-0.605-1.112-1.254-1.063c-0.646,0.048-1.133,0.608-1.086,1.256 C132.266,349.265,132.275,349.328,132.288,349.383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M137.868,347.873c-1.006-0.264-1.739-0.935-2.852-0.43c-1.317,0.596-1.066,1.979-0.751,3.101 c0.242,0.871-0.908,1.296-1.313,0.493c-0.667-1.309-1.064-2.833,0.038-4.029c0.982-1.065,2.553-1.124,3.755-0.474 c0.502,0.272,0.559,1.11-0.082,1.303c-0.609,0.182-1.056,0.418-1.494,0.878l-0.402-1.119l0.119,0.361l0.396,0.569 l-0.273,0.229l-0.249-0.475l-0.588,0.333l0.118,0.525l0.438,0.036l-0.064-0.692c0.118,0.216,0.209,0.38,0.211,0.631 c0.003,0.3-0.193,0.57-0.514,0.601l-0.129,0.012c-0.22,0.022-0.517-0.082-0.629-0.286c-0.424-0.768,0.14-1.671,1.075-1.588 c0.851,0.075,1.186,1.141,0.469,1.647c-0.763,0.542-1.71-0.202-1.554-1.069c0.171-0.953,1.461-1.596,2.295-1.155 c0.199,0.106,0.408,0.32,0.392,0.566c-0.053,0.927-0.896,1.314-1.777,1.116c-0.484-0.107-0.789-0.725-0.404-1.124 c0.601-0.622,1.266-1.057,2.094-1.323l-0.081,1.306c-0.721-0.377-1.813-0.464-2.291,0.393 c-0.42,0.748,0.113,1.667,0.444,2.334l-1.313,0.493c-0.482-1.729-0.597-3.657,1.182-4.664 c1.256-0.707,3.645-0.48,4.154,1.018C138.37,347.625,138.15,347.948,137.868,347.873z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M138.545,303.904c-3.479,0.714-5.551,4.184-4.885,7.523c0,0,1.309,6.382,1.839,8.487 c0.798,3.163,3.613,12.54,3.613,12.54h12.026h12.026c0,0,2.816-9.376,3.614-12.54c0.531-2.105,1.839-8.487,1.839-8.487 c0.666-3.339-1.406-6.809-4.885-7.523c-3.114-0.639-12.594-1.831-12.594-1.831S141.659,303.265,138.545,303.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M136.637,335.314c-2.01,3.542-5.757,9.131-5.757,19.092h20.26h20.26 c0-9.961-3.748-15.55-5.757-19.092c-0.815-1.437-2.476-2.859-2.476-2.859H151.14h-12.026 C139.113,332.455,137.452,333.877,136.637,335.314z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1136_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M152.026,332.752c-0.054,4.222-0.108,8.445-0.162,12.667c0.228-0.062,0.456-0.124,0.684-0.185 c-0.361-0.562-0.79-1.036-1.17-1.573c-0.857-1.213-1.112-2.184-1.121-3.668c-0.014-2.52,0.156-5.025,0.451-7.526 c0.055-0.468-0.68-0.464-0.734,0c-0.345,2.927-0.717,6.085-0.425,9.035c0.189,1.912,1.346,2.514,2.365,4.102 c0.194,0.303,0.679,0.188,0.684-0.185c0.054-4.222,0.108-8.445,0.162-12.667C152.766,332.279,152.032,332.279,152.026,332.752 L152.026,332.752z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1135_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M157.758,332.658c0.91,5.204,5.14,9.856,10.793,8.252c0.454-0.129,0.261-0.837-0.195-0.708 c-5.289,1.501-9.055-2.961-9.89-7.739C158.385,331.998,157.677,332.195,157.758,332.658L157.758,332.658z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1134_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M143.893,332.463c-0.835,4.777-4.597,9.241-9.89,7.739c-0.455-0.129-0.65,0.579-0.195,0.708 c5.651,1.604,9.883-3.047,10.793-8.252C144.682,332.196,143.975,331.997,143.893,332.463L143.893,332.463z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 6.8216,
      strokeMiterlimit: 10
    },
    points: "139.376,435.345  139.424,430.137 139.445,425.466  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M144.932,430.688l0.03-0.517c0.84-13.221,1.543-26.4,2.233-39.596l0.254-4.949l0.063-1.162 c0.005-0.086,0.014-0.13,0.021-0.197l0.023-0.298l0.047-0.603l0.194-2.426c0.268-3.24,0.56-6.481,0.882-9.703 c0.323-3.22,0.672-6.432,1.08-9.578c0.206-1.57,0.421-3.129,0.662-4.643c0.11-0.775,0.254-1.482,0.377-2.224 c0.126-0.74,0.282-1.381,0.417-2.074l-19.976-3.13c-0.08,0.941-0.182,1.922-0.236,2.827c-0.048,0.896-0.118,1.821-0.145,2.691 c-0.076,1.765-0.116,3.491-0.144,5.207c-0.052,3.427-0.032,6.795,0.014,10.158c0.048,3.36,0.127,6.705,0.232,10.05 l0.085,2.514l0.047,1.368l0.078,1.316l0.309,4.932c0.81,13.154,1.606,26.325,2.267,39.451l0.025,0.625L144.932,430.688z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M135.835,433.045c2.409,0.1,4.821,0.145,7.232,0.135c0.943,1.804,1.551,3.783,1.755,5.845 c0.053,0.522-0.349,0.975-0.864,0.961l-9.062-0.234c-0.517-0.014-0.915-0.475-0.821-0.974 C134.448,436.833,135.029,434.891,135.835,433.045z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M142.716,435.765l-0.234-1.957c-0.077-0.631-0.179-1.309-0.623-1.76 c-0.318-0.324-0.768-0.479-1.21-0.578c-0.821-0.184-1.717-0.2-2.468,0.18c-0.791,0.4-1.323,1.195-1.598,2.035 c-0.279,0.839-0.331,1.731-0.382,2.612"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 6.8216,
      strokeMiterlimit: 10
    },
    d: "M158.008,435.26 c0.048-1.76,0.144-3.498,0.217-5.247l0.251-4.689"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M163.706,430.793l0.049-0.508c1.449-13.057,3.202-26.134,4.993-39.184l0.34-2.446l0.171-1.222 c0.055-0.399,0.12-0.828,0.173-1.316c0.204-1.693,0.386-3.356,0.56-5.031c0.343-3.344,0.636-6.694,0.871-10.066 c0.231-3.373,0.402-6.766,0.474-10.211c0.064-3.452,0.06-6.925-0.235-10.61l-20.044,2.643c0.53,2.588,0.904,5.577,1.196,8.6 c0.29,3.037,0.496,6.163,0.643,9.317c0.142,3.157,0.23,6.344,0.271,9.532c0.018,1.588,0.027,3.196,0.02,4.742 c0.007,0.292-0.001,0.614-0.013,1.062l-0.032,1.247l-0.061,2.489c-0.304,13.275-0.565,26.5-0.531,39.902l0,0.643 L163.706,430.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M161.711,433.214c0,0,1.691,0.845,3.904,1.95c2.183,1.114,4.879,2.489,6.948,3.545 c0.41,0.217,0.87,0.685,0.545,1.002c-0.149,0.146-0.393,0.157-0.611,0.157h-14.081c-0.063-1.27-0.702-2.514-1.656-3.287 c-0.35,0.817-0.669,1.671-1.005,2.516c-0.193,0.502-0.297,0.771-0.297,0.771h-2.81c0,0-0.047-0.419-0.068-1.026 c-0.018-0.603-0.018-1.412,0.099-2.143c0.166-0.99,1.064-3.537,1.394-3.708c0.205-0.117,0.454-0.092,0.685-0.061 C156.811,433.203,161.711,433.214,161.711,433.214"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M134.639,311.4c-0.444,3.241-0.188,6.391,0.807,9.509c0.143,0.448,0.852,0.257,0.708-0.195 c-0.951-2.979-1.231-6.018-0.807-9.118C135.41,311.133,134.703,310.933,134.639,311.4L134.639,311.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M167.347,310.624c0.655,3.969-0.405,7.774-1.541,11.549c-0.136,0.453,0.572,0.647,0.708,0.195 c1.183-3.93,2.222-7.819,1.541-11.939C167.978,309.964,167.271,310.161,167.347,310.624L167.347,310.624z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1052_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M142.19,293.549c0.252,0.748,0.337,1.445,0.346,2.115c0.024,0.68-0.055,1.316-0.183,1.929 c-0.266,1.218-0.742,2.329-1.406,3.257c-0.665,0.931-1.631,1.566-2.576,2.168c-0.474,0.301-0.933,0.609-1.481,0.818 c-0.541,0.216-1.153,0.35-1.746,0.497c-1.216,0.261-2.218,0.73-2.831,1.612c-0.629,0.864-0.654,2.372-1.131,3.411 c-0.228,0.53-0.594,0.913-1.028,1.223c-0.426,0.318-0.899,0.585-1.416,0.803c-1.044,0.425-2.223,0.699-3.844,0.467 l-0.45-0.499c-0.089-1.662,0.265-2.819,0.755-3.825c0.25-0.497,0.544-0.946,0.884-1.343c0.333-0.406,0.733-0.738,1.272-0.923 c1.056-0.392,2.563-0.314,3.468-0.881c0.917-0.552,1.458-1.504,1.761-2.688c0.161-0.583,0.299-1.181,0.504-1.701 c0.198-0.528,0.48-0.962,0.739-1.411c0.521-0.897,0.989-1.793,1.702-2.444c0.714-0.653,1.557-1.175,2.522-1.655 c0.485-0.238,0.997-0.468,1.591-0.668c0.572-0.215,1.194-0.419,1.96-0.585L142.19,293.549z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M159.349,295.196c0.787,0.222,1.431,0.509,2.018,0.822c0.615,0.297,1.141,0.635,1.633,0.989 c0.499,0.35,0.954,0.719,1.362,1.114c0.427,0.384,0.806,0.793,1.133,1.233c0.673,0.868,1.036,1.93,1.434,2.987 c0.203,0.525,0.424,1.039,0.54,1.63c0.133,0.579,0.182,1.222,0.254,1.856c0.126,1.28,0.536,2.388,1.397,3.14 c0.851,0.765,2.396,0.957,3.429,1.527c0.534,0.273,0.911,0.672,1.213,1.138c0.318,0.452,0.583,0.95,0.802,1.494 c0.227,0.537,0.403,1.123,0.51,1.781c0.102,0.663,0.176,1.359,0.08,2.23l-0.487,0.463c-1.707,0.052-2.941-0.397-4.016-0.997 c-1.026-0.643-2.007-1.354-2.417-2.53c-0.41-1.18-0.283-2.757-0.824-3.783c-0.521-1.046-1.468-1.756-2.673-2.312 c-0.583-0.292-1.189-0.574-1.711-0.921c-0.523-0.346-0.941-0.768-1.377-1.18c-0.86-0.831-1.726-1.675-2.256-2.73 c-0.525-1.057-0.848-2.235-0.998-3.492c-0.124-1.271-0.107-2.608,0.36-4.144L159.349,295.196z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1066_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1067_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M150.083,302.257h2.147c8.063,0,14.599-6.536,14.599-14.599v-2.759 c0-8.656-7.017-15.672-15.672-15.672l0,0c-8.656,0-15.672,7.017-15.672,15.672v2.759 C135.485,295.72,142.021,302.257,150.083,302.257z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1065_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 10.3418,
      strokeMiterlimit: 10
    },
    x1: 151.157,
    y1: 298.931,
    x2: 151.157,
    y2: 304.529
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M151.157,305.55c2.865,0,5.188-0.457,5.188-1.02c0-0.563-2.323-1.02-5.188-1.02 c-2.865,0-5.188,0.457-5.188,1.02C145.969,305.093,148.291,305.55,151.157,305.55z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 10.3418,
      strokeMiterlimit: 10
    },
    x1: 151.157,
    y1: 298.931,
    x2: 151.157,
    y2: 304.529
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M151.157,305.55c2.865,0,5.188-0.457,5.188-1.02c0-0.563-2.323-1.02-5.188-1.02 c-2.865,0-5.188,0.457-5.188,1.02C145.969,305.093,148.291,305.55,151.157,305.55z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1063_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M149.204,301.763h3.906c5.432,0,9.835-4.403,9.835-9.835v-9.068 c0-6.51-5.278-11.788-11.788-11.788l0,0c-6.51,0-11.788,5.278-11.788,11.788v9.068 C139.369,297.36,143.772,301.763,149.204,301.763z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1060_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1062_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M160.265,290.778c-0.001,0.021-0.001,0.043-0.002,0.065c-0.02,0.534,0.091,1.032,0.334,1.494 c0.157,0.481,0.424,0.897,0.802,1.248c0.351,0.378,0.767,0.646,1.248,0.802c0.462,0.243,0.96,0.354,1.494,0.334 c1.003-0.045,2.044-0.374,2.743-1.136c0.707-0.77,1.108-1.683,1.136-2.743c0.001-0.022,0.001-0.043,0.002-0.065 c0.02-0.534-0.091-1.032-0.334-1.494c-0.156-0.481-0.424-0.897-0.802-1.248c-0.351-0.378-0.767-0.646-1.248-0.802 c-0.462-0.243-0.96-0.354-1.494-0.334c-1.003,0.045-2.044,0.374-2.743,1.136 C160.694,288.806,160.293,289.719,160.265,290.778L160.265,290.778z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1061_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M166.428,290.376c-0.183-1.743-3.104-2.31-3.616-0.497c-0.059,0.208,0.113,0.493,0.354,0.465 c0.571-0.068,0.897,0.357,0.832,0.869c-0.068,0.541-0.499,0.736-0.992,0.81c-0.466,0.069-0.268,0.777,0.195,0.708 c0.862-0.128,1.527-0.714,1.538-1.623c0.01-0.862-0.677-1.604-1.574-1.498c0.118,0.155,0.236,0.31,0.354,0.465 c0.275-0.974,2.076-0.628,2.174,0.302C165.742,290.841,166.477,290.846,166.428,290.376L166.428,290.376z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1057_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1059_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M134.256,290.778c0.001,0.021,0.001,0.043,0.002,0.065c0.026,1.011,0.414,2.021,1.136,2.743 c0.351,0.378,0.767,0.646,1.248,0.802c0.462,0.243,0.96,0.354,1.494,0.334c1.003-0.045,2.043-0.374,2.743-1.136 c0.686-0.747,1.163-1.702,1.136-2.743c-0.001-0.022-0.001-0.043-0.002-0.065c-0.026-1.011-0.415-2.021-1.136-2.743 c-0.351-0.378-0.767-0.646-1.248-0.802c-0.462-0.243-0.96-0.354-1.494-0.334c-1.003,0.045-2.044,0.374-2.743,1.136 C134.706,288.783,134.229,289.737,134.256,290.778L134.256,290.778z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1058_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M136.585,290.376c0.098-0.933,1.899-1.275,2.174-0.302c0.118-0.155,0.236-0.31,0.354-0.465 c-0.893-0.106-1.589,0.635-1.574,1.498c0.016,0.909,0.673,1.495,1.538,1.623c0.462,0.069,0.662-0.639,0.195-0.708 c-0.492-0.073-0.923-0.268-0.992-0.81c-0.065-0.513,0.267-0.936,0.832-0.869c0.241,0.029,0.413-0.257,0.354-0.465 c-0.512-1.813-3.433-1.245-3.616,0.497C135.801,290.845,136.536,290.842,136.585,290.376L136.585,290.376z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1039_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1040_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1056_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M151.127,290.131c0.193,0.974-1.423,1.501-0.924,2.557c0.283,0.599,1.45,0.841,1.896,0.335 c0.274-0.311-0.182-0.77-0.457-0.457c-0.148,0.168-0.751,0.049-0.861-0.165c-0.147-0.288,0.274-0.655,0.423-0.831 c0.419-0.494,0.677-0.949,0.546-1.611C151.669,289.551,151.046,289.724,151.127,290.131L151.127,290.131z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1055_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M152.548,294.501c-0.656,1.096-2.131,1.106-2.794,0.008 c-0.215-0.355-0.774-0.031-0.558,0.326c0.913,1.509,3.004,1.508,3.911-0.008 C153.32,294.47,152.762,294.144,152.548,294.501L152.548,294.501z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M158.43,295.522c1.087,0,2.128-0.956,2.078-2.078c-0.05-1.126-0.913-2.078-2.078-2.078 c-1.087,0-2.128,0.956-2.078,2.078C156.402,294.57,157.265,295.522,158.43,295.522L158.43,295.522z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1050_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M143.904,295.522c1.087,0,2.128-0.956,2.078-2.078c-0.05-1.126-0.913-2.078-2.078-2.078 c-1.087,0-2.128,0.956-2.078,2.078C141.876,294.57,142.739,295.522,143.904,295.522L143.904,295.522z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1049_",
    style: {
      fill: "#5D3338"
    },
    d: "M145.186,291.248c-0.554,0-1.004-0.606-1.004-1.354 c0-0.748,0.449-1.354,1.004-1.354c0.554,0,1.004,0.606,1.004,1.354C146.189,290.642,145.74,291.248,145.186,291.248z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1048_",
    style: {
      fill: "#5D3338"
    },
    d: "M157.116,291.249c0.554,0,1.004-0.606,1.004-1.354 c0-0.748-0.449-1.354-1.004-1.354c-0.554,0-1.004,0.606-1.004,1.354C156.113,290.642,156.562,291.249,157.116,291.249z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1043_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M160.5,288.149c-0.295-1.155-1.516-1.788-2.621-1.934 c-0.949-0.126-2.473-0.007-2.856,1.026c-0.11,0.296,0.168,0.537,0.429,0.564c0.706,0.071,1.328-0.439,2.073-0.415 c0.952,0.03,1.642,0.533,2.325,1.138C160.137,288.78,160.6,288.538,160.5,288.149L160.5,288.149z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1041_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M147.69,287.875c-0.581-1.018-1.43-1.63-2.653-1.554c-0.971,0.06-2.218,0.628-2.035,1.755 c0.023,0.139,0.179,0.231,0.308,0.235c0.673,0.019,1.05-0.417,1.677-0.582c0.725-0.191,1.714-0.019,2.307,0.451 C147.507,288.347,147.842,288.141,147.69,287.875L147.69,287.875z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M162.945,279.194c-0.12-0.783-0.696-1.856-0.974-2.598c-0.808-2.154-2.791-3.606-4.672-4.93 c-0.632-0.445-1.274-0.895-2.003-1.153c-0.639-0.226-1.323-0.295-2-0.324c-3.031-0.134-6.092,0.498-8.823,1.82 c-0.771,0.373-1.52,0.803-2.183,1.347c-1.727,1.418-2.758,3.522-3.405,5.661c-0.67,2.213-0.975,4.572-0.652,6.853 c0.959,0.129,1.959,0.044,2.926-0.081c3.094-0.399,6.173-1.124,8.975-2.496c2.238-1.096,4.287-2.632,5.845-4.564 c0.717,1.737,1.83,3.314,3.132,4.678c0.862,0.902,1.825,1.732,2.95,2.271c0.455,0.218,0.941,0.382,1.436,0.482 C163.48,283.845,163.311,281.573,162.945,279.194z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 72.77,
    cy: 354.865,
    rx: 37.042,
    ry: 9.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 72.77,
    cy: 357.038,
    rx: 53.158,
    ry: 14.012
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1078_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M87.435,252.653c0.167,0.161,0.331,0.327,0.491,0.496l0.117,0.126l0.089,0.108l0.176,0.218 c0.252,0.305,0.421,0.561,0.6,0.826c0.344,0.521,0.609,0.998,0.855,1.464c0.481,0.927,0.86,1.801,1.213,2.668 c0.698,1.729,1.264,3.412,1.791,5.099c0.524,1.686,0.997,3.367,1.434,5.064c0.218,0.849,0.427,1.7,0.625,2.569l0.3,1.385 c0.08,0.358,0.138,0.704,0.202,1.056c0.049,0.351,0.076,0.701,0.088,1.051c-0.042,0.547-0.131,1.087-0.306,1.609 c-0.089,0.261-0.17,0.522-0.273,0.778c-0.095,0.249-0.216,0.544-0.281,0.681c-0.305,0.684-0.615,1.316-0.931,1.934 c-0.632,1.235-1.285,2.419-1.952,3.594c-1.339,2.342-2.727,4.631-4.203,6.892l-3.952-2.307 c1.184-2.298,2.298-4.651,3.344-7.014c0.519-1.181,1.023-2.369,1.48-3.546c0.229-0.588,0.443-1.174,0.627-1.733 c0.057-0.165,0.064-0.211,0.085-0.295l0.053-0.231c0.027-0.154,0.063-0.307,0.038-0.462 c-0.045-0.196-0.118-0.388-0.184-0.564l-0.359-1.094c-0.259-0.766-0.535-1.539-0.82-2.309 c-0.57-1.539-1.177-3.07-1.818-4.569c-0.641-1.496-1.317-2.973-2.042-4.342c-0.362-0.68-0.738-1.34-1.114-1.909 c-0.187-0.279-0.376-0.542-0.542-0.737c-0.081-0.092-0.165-0.195-0.217-0.229l-0.042-0.04l-0.02-0.021 c-0.004-0.001-0.005,0.003-0.007,0.003c-0.007,0.005-0.011,0.008-0.011,0.008L87.435,252.653z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M86.902,252.085l-5.137,6.908c-0.07-0.1,0.384,0.5,0.759,1.24 c0.388,0.741,0.77,1.596,1.131,2.476c2.834-1.167,5.673-2.32,8.518-3.461c-0.491-1.087-1.043-2.17-1.75-3.301 c-0.167-0.276-0.38-0.58-0.571-0.864l-0.333-0.455l-0.17-0.226l-0.198-0.244c-0.14-0.167-0.255-0.313-0.419-0.492 c-0.166-0.18-0.335-0.358-0.507-0.531c-0.21-0.201-0.446-0.409-0.676-0.601C87.327,252.36,87.121,252.231,86.902,252.085z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M85.795,286.257c-1.478,0.249-2.945,0.534-4.389,0.838c-0.277,0.06-0.578-0.112-0.673-0.381 c-0.085-0.238,0.021-0.472,0.239-0.563c1.348-0.572,2.737-1.133,4.159-1.664l0.003-0.001c0.482-0.18,1.064,0.054,1.295,0.53 c0.232,0.477,0.022,1.014-0.464,1.195C85.911,286.232,85.851,286.247,85.795,286.257z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M86.289,285.976c-1.647,2.066-3.27,4.184-4.923,6.13c-0.173,0.198-0.498,0.198-0.728,0.003 c-0.215-0.182-0.274-0.466-0.145-0.655c0.688-1.026,1.381-2.129,2.073-3.235c0.696-1.116,1.393-2.232,2.09-3.349 c0.261-0.416,0.848-0.53,1.316-0.248c0.467,0.281,0.635,0.854,0.369,1.278C86.326,285.926,86.307,285.952,86.289,285.976z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M87.054,287.127c-1.498,2.148-2.928,4.334-4.5,6.456c-0.173,0.223-0.503,0.252-0.739,0.064 c-0.22-0.176-0.285-0.47-0.162-0.678c1.281-2.214,2.465-4.56,3.71-6.859c0.235-0.436,0.811-0.586,1.294-0.331 c0.482,0.255,0.684,0.824,0.445,1.268C87.089,287.073,87.071,287.101,87.054,287.127z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M87.938,287.986c-1.138,2.014-2.297,3.999-3.65,5.977c-0.169,0.242-0.508,0.295-0.751,0.118 c-0.226-0.164-0.297-0.46-0.176-0.687l0.008-0.014c1.057-2.059,1.937-4.14,2.788-6.239l0.01-0.026 c0.187-0.466,0.745-0.672,1.248-0.464c0.504,0.209,0.762,0.762,0.571,1.235C87.972,287.919,87.954,287.955,87.938,287.986z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M89.234,287.534c-0.675,1.699-1.381,3.388-2.163,5.092c-0.123,0.264-0.443,0.373-0.714,0.242 c-0.246-0.119-0.369-0.391-0.3-0.635l0.002-0.007c0.5-1.782,0.918-3.544,1.307-5.307l0.002-0.012 c0.107-0.496,0.621-0.789,1.148-0.657c0.527,0.132,0.871,0.646,0.759,1.149C89.266,287.445,89.25,287.493,89.234,287.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M84.794,285.531c0.851-0.066,1.538-0.484,2.399,0.075c1.02,0.661,0.668,1.718,0.29,2.56 c-0.294,0.653,0.61,1.156,1.031,0.581c0.687-0.939,1.179-2.083,0.397-3.189c-0.7-0.987-1.985-1.26-3.047-0.922 c-0.442,0.142-0.584,0.794-0.075,1.04c0.483,0.233,0.827,0.484,1.141,0.912l0.452-0.825l-0.138,0.267l-0.388,0.391 l0.202,0.222l0.254-0.34l0.449,0.349l-0.151,0.399l-0.365-0.035l0.123-0.539c-0.119,0.154-0.21,0.272-0.238,0.47 c-0.034,0.237,0.1,0.479,0.36,0.55l0.106,0.029c0.179,0.049,0.435,0.01,0.548-0.135c0.425-0.548,0.066-1.339-0.718-1.411 c-0.715-0.068-1.098,0.73-0.562,1.233c0.575,0.541,1.428,0.087,1.394-0.62c-0.037-0.777-1.034-1.473-1.769-1.246 c-0.175,0.055-0.373,0.193-0.386,0.389c-0.051,0.742,0.602,1.171,1.349,1.142c0.406-0.016,0.73-0.457,0.454-0.829 c-0.43-0.579-0.931-1.019-1.586-1.35l-0.075,1.043c0.638-0.191,1.548-0.101,1.85,0.645c0.261,0.649-0.266,1.303-0.614,1.78 l1.031,0.581c0.579-1.298,0.884-2.801-0.48-3.859c-0.962-0.743-2.952-0.909-3.536,0.2 C84.407,285.262,84.554,285.549,84.794,285.531z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1077_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M58.936,252.541c-1.069,0.832-1.84,1.703-2.506,2.557c-0.665,0.857-1.203,1.706-1.682,2.55 c-0.963,1.688-1.699,3.357-2.35,5.025c-0.649,1.668-1.197,3.335-1.685,5.011c-0.485,1.681-0.909,3.353-1.264,5.11 l-0.176,0.898c-0.071,0.343-0.115,0.688-0.168,1.03l-0.05,0.512c-0.009,0.17-0.004,0.339-0.007,0.508l0.016,0.251 l0.004,0.063l0.002,0.031l0.001,0.016c0.094-0.006,0.027,0.007,0.049,0.01l0.018,0.126c0.02,0.169,0.054,0.334,0.088,0.499 c0.161,0.654,0.498,1.266,0.839,1.862c0.175,0.287,0.357,0.613,0.526,0.864l0.378,0.56c1.003,1.449,2.014,2.782,3.037,4.112 c2.044,2.65,4.125,5.226,6.221,7.791l3.673-2.729c-1.83-2.725-3.644-5.463-5.383-8.217c-0.866-1.374-1.723-2.761-2.487-4.121 l-0.275-0.503c-0.062-0.117-0.089-0.189-0.134-0.285c-0.08-0.18-0.156-0.358-0.205-0.543 c-0.063-0.187,0.03-0.385,0.076-0.566l0.088-0.272l0.045-0.133c0.014-0.036,0.046-0.148,0.072-0.235 c0.901-2.953,2.075-5.949,3.439-8.689c0.685-1.369,1.432-2.686,2.244-3.836c0.403-0.577,0.824-1.11,1.246-1.552 c0.417-0.444,0.843-0.805,1.179-0.999L58.936,252.541z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M59.477,252.022l4.602,7.29c-0.345,0.256-0.883,0.786-1.38,1.479 c-0.504,0.695-0.995,1.517-1.451,2.391c-2.718-1.416-5.447-2.811-8.188-4.183c0.672-1.202,1.45-2.397,2.435-3.579 C56.477,254.25,57.694,253.04,59.477,252.022z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M61.273,287.55c1.555,0.135,3.108,0.329,4.656,0.583c0.298,0.049,0.58-0.152,0.63-0.45 c0.044-0.263-0.109-0.514-0.351-0.602c-1.5-0.547-3.029-1.039-4.583-1.475l-0.003-0.001 c-0.527-0.148-1.075,0.158-1.222,0.686c-0.148,0.528,0.163,1.078,0.691,1.227C61.15,287.534,61.214,287.545,61.273,287.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M60.719,287.295c2.054,2.055,4.063,4.158,6.021,6.311c0.203,0.224,0.549,0.24,0.771,0.037 c0.208-0.19,0.234-0.506,0.071-0.728c-1.741-2.353-3.544-4.669-5.398-6.942c-0.345-0.423-0.966-0.489-1.391-0.145 c-0.424,0.343-0.488,0.968-0.141,1.393C60.672,287.246,60.696,287.272,60.719,287.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M60.143,288.583c1.889,2.141,3.721,4.335,5.492,6.584c0.188,0.238,0.532,0.28,0.768,0.093 c0.221-0.175,0.268-0.488,0.121-0.722c-1.542-2.435-3.156-4.832-4.837-7.183c-0.318-0.446-0.935-0.552-1.38-0.236 c-0.445,0.316-0.548,0.935-0.229,1.383C60.098,288.53,60.12,288.558,60.143,288.583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M59.39,289.568c1.488,2.013,2.988,4.013,4.501,6.006c0.184,0.242,0.528,0.291,0.767,0.108 c0.222-0.169,0.277-0.477,0.138-0.713l-0.009-0.015c-1.257-2.139-2.499-4.283-3.726-6.435l-0.015-0.027 c-0.272-0.477-0.877-0.647-1.353-0.379c-0.476,0.268-0.642,0.875-0.368,1.355C59.344,289.502,59.368,289.538,59.39,289.568z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M57.997,289.218c0.974,1.715,1.959,3.421,2.952,5.124c0.153,0.264,0.49,0.354,0.751,0.203 c0.236-0.138,0.33-0.427,0.231-0.676l-0.003-0.007c-0.723-1.821-1.436-3.644-2.137-5.469l-0.005-0.012 c-0.197-0.514-0.772-0.775-1.283-0.583c-0.512,0.192-0.768,0.767-0.57,1.283C57.95,289.127,57.973,289.176,57.997,289.218z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M62.165,286.69c-0.883,0.002-1.659-0.378-2.434,0.298c-0.917,0.799-0.373,1.877,0.152,2.731 c0.408,0.662-0.432,1.266-0.952,0.702c-0.85-0.921-1.547-2.067-0.954-3.313c0.53-1.112,1.782-1.538,2.93-1.276 c0.478,0.11,0.744,0.793,0.268,1.1c-0.451,0.291-0.756,0.59-1,1.071l-0.608-0.831l0.189,0.27l0.465,0.378l-0.166,0.253 l-0.32-0.336l-0.395,0.411l0.224,0.407l0.365-0.07l-0.22-0.559c0.149,0.151,0.262,0.267,0.325,0.474 c0.076,0.248-0.018,0.515-0.272,0.614l-0.102,0.04c-0.174,0.068-0.44,0.051-0.581-0.092 c-0.526-0.536-0.302-1.404,0.482-1.557c0.716-0.141,1.25,0.673,0.789,1.252c-0.493,0.621-1.436,0.222-1.527-0.524 c-0.099-0.821,0.784-1.658,1.576-1.487c0.189,0.041,0.415,0.17,0.465,0.377c0.188,0.784-0.407,1.295-1.171,1.333 c-0.417,0.02-0.822-0.413-0.609-0.832c0.333-0.653,0.762-1.169,1.367-1.583l0.268,1.101 c-0.686-0.145-1.594,0.041-1.767,0.857c-0.15,0.709,0.498,1.347,0.931,1.819l-0.952,0.702 c-0.797-1.307-1.376-2.851-0.187-4.109c0.838-0.885,2.836-1.259,3.643-0.12C62.512,286.369,62.413,286.689,62.165,286.69z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M62.097,251.01c-3.633,0.74-5.267,2.3-4.489,7.021l3.71,26.206h11.826H84.97l3.71-26.206 c0.778-4.721-0.856-6.281-4.489-7.021l-11.047-1.821L62.097,251.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M58.81,297.438h14.334h14.334c0-4.305-1.286-9.337-2.53-13.201H73.144H61.34 C60.096,288.101,58.81,293.133,58.81,297.438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1076_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M64.227,286.558c-0.162,2.831-2.296,5.171-5.078,5.654c-0.4,0.07-0.23,0.678,0.168,0.609 c3.069-0.534,5.365-3.167,5.541-6.264C64.882,286.152,64.25,286.153,64.227,286.558L64.227,286.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1075_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M72.849,284.284c-0.042,2.918-0.085,5.836-0.127,8.754c-0.004,0.295,0.339,0.388,0.539,0.223 c1.078-0.884,1.987-1.28,2.076-2.691c0.129-2.039,0.007-4.127-0.101-6.165c-0.021-0.404-0.653-0.407-0.632,0 c0.074,1.405,0.121,2.81,0.123,4.217c0.001,0.784,0.071,1.544-0.212,2.29c-0.35,0.924-0.933,1.271-1.701,1.901 c0.18,0.074,0.36,0.149,0.539,0.223c0.042-2.918,0.085-5.836,0.127-8.754C73.486,283.877,72.854,283.877,72.849,284.284 L72.849,284.284z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1074_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M81.533,286.558c0.177,3.096,2.473,5.73,5.542,6.264c0.398,0.069,0.568-0.54,0.168-0.609 c-2.781-0.484-4.916-2.823-5.077-5.654C82.142,286.154,81.51,286.151,81.533,286.558L81.533,286.558z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 4.7766,
      strokeMiterlimit: 10
    },
    points: "64.499,342.043  64.601,347.878 64.658,351.11  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M60.592,348.627l-0.055-0.732l-2.078-26.661l-0.26-3.329l-0.13-1.664l-0.04-0.775 c-0.009-0.254,0.03-0.507,0.043-0.761l0.014-0.184l0.005-0.105l0.01-0.209l0.019-0.418l0.314-6.695l0.629-13.39l14.486,1.556 l-2.23,13.219l-1.115,6.609l-0.07,0.413l-0.035,0.207l-0.018,0.103c-0.004,0.02-0.005,0.015-0.008,0.024 c-0.024,0.045-0.04,0.1-0.056,0.133l-0.071,1.681l-0.142,3.36l-1.14,26.855l-0.029,0.736L60.592,348.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M67.226,349.939c-1.687,0.06-3.375,0.08-5.064,0.062c-0.653,1.249-1.067,2.621-1.218,4.026 c-0.038,0.357,0.243,0.674,0.603,0.674l6.347-0.001c0.362,0,0.642-0.323,0.576-0.681 C68.216,352.618,67.798,351.245,67.226,349.939z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M62.418,351.8l0.157-1.359c0.05-0.439,0.117-0.911,0.425-1.225 c0.221-0.225,0.535-0.332,0.844-0.4c0.574-0.126,1.201-0.135,1.73,0.134c0.557,0.283,0.935,0.844,1.133,1.436 c0.198,0.592,0.238,1.222,0.277,1.844"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 4.7766,
      strokeMiterlimit: 10
    },
    points: "80.544,342.176  80.373,348.285 80.311,351.244  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M82.917,350.298c0,0,1.196,0.559,2.761,1.289c1.556,0.744,3.471,1.676,4.898,2.434 c0.288,0.155,0.612,0.497,0.387,0.729c-0.104,0.107-0.275,0.115-0.427,0.115h-9.86c-0.052-0.863-0.5-1.695-1.181-2.212 l-0.686,1.697c-0.133,0.336-0.204,0.515-0.204,0.515h-1.968c0,0-0.14-1.106,0.003-2.096c0.104-0.666,0.706-2.388,0.928-2.516 c0.142-0.083,0.317-0.069,0.479-0.051C79.486,350.359,82.917,350.298,82.917,350.298"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M84.384,348.83l0.036-0.448c0.763-8.91,1.647-17.835,2.542-26.751l0.339-3.343l0.171-1.671 l0.048-0.526c0.021-0.206,0.034-0.412,0.023-0.618c-0.011-0.472-0.007-0.672-0.007-0.97l0.003-6.73l0.007-13.459 l-14.543,0.868l1.609,13.363l0.804,6.681c0.032,0.246,0.073,0.671,0.086,0.601c0.011,0.019,0.017,0.039,0.025,0.059 l0.013,0.03l0.005,0.196l0.031,1.688l0.065,3.373c0.183,8.996,0.375,17.972,0.688,27.014l0.015,0.456L84.384,348.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M57.806,258.07c0.059,5.135,1.013,10.181,1.567,15.272c0.039,0.356,0.602,0.36,0.563,0 c-0.554-5.09-1.509-10.138-1.567-15.272C58.365,257.708,57.802,257.707,57.806,258.07L57.806,258.07z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M87.541,256.747c0.312,5.367-0.296,10.708-1.225,15.989c-0.062,0.354,0.48,0.507,0.543,0.15 c0.937-5.329,1.56-10.721,1.245-16.139C88.083,256.387,87.52,256.385,87.541,256.747L87.541,256.747z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1014_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1038_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 73.18,
    y1: 246.779,
    x2: 73.18,
    y2: 251.072
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M73.18,251.855c2.198,0,3.979-0.35,3.979-0.782c0-0.432-1.781-0.783-3.979-0.783 c-2.198,0-3.979,0.35-3.979,0.783C69.201,251.505,70.983,251.855,73.18,251.855z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D1A043",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 73.18,
    y1: 246.779,
    x2: 73.18,
    y2: 251.072
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M73.18,251.855c2.198,0,3.979-0.35,3.979-0.782c0-0.432-1.781-0.783-3.979-0.783 c-2.198,0-3.979,0.35-3.979,0.783C69.201,251.505,70.983,251.855,73.18,251.855z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1036_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M69.304,248.951h7.752c2.852,0,5.164-2.312,5.164-5.164v-10.054 c0-4.594-3.724-8.318-8.318-8.318h-1.444c-4.594,0-8.318,3.724-8.318,8.318v10.054 C64.14,246.639,66.452,248.951,69.304,248.951z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1034_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M76.05,246.372c0.132,0.271-0.035,0.587-0.197,0.841c-0.337,0.531-0.701,1.087-1.263,1.371 c-0.377,0.19-0.81,0.238-1.232,0.243c-0.706,0.008-1.435-0.101-2.04-0.466c-0.605-0.365-1.065-1.021-1.057-1.727"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M76.137,246.33c0.262,0.115,0.393,0.478,0.407,0.747c0.035,0.281-0.021,0.536-0.007,0.733 c-0.038,0.404-0.116,0.851-0.393,1.298c-0.232,0.46-0.777,0.936-1.362,1.169c-0.572,0.235-1.088,0.279-1.518,0.286 c-0.869,0-1.933-0.263-2.715-1.06c-0.408-0.387-0.659-0.893-0.761-1.41c-0.073-0.527,0.002-1.09,0.376-1.461l0.193,0.002 c0.031,0.655,0.469,1.231,1.009,1.567c0.558,0.337,1.236,0.441,1.902,0.433c0.674,0.026,1.324-0.102,1.775-0.592 c0.231-0.231,0.425-0.509,0.616-0.793c0.194-0.271,0.407-0.57,0.302-0.835L76.137,246.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1033_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M80.179,240.527c-0.001,0.016-0.001,0.033-0.001,0.05c-0.016,0.41,0.07,0.792,0.256,1.146 c0.12,0.369,0.325,0.688,0.615,0.957c0.269,0.29,0.588,0.495,0.957,0.615c0.354,0.186,0.736,0.272,1.146,0.256 c0.769-0.035,1.567-0.287,2.103-0.871c0.542-0.591,0.85-1.291,0.871-2.103c0-0.017,0.001-0.033,0.001-0.05 c0.016-0.41-0.07-0.792-0.256-1.146c-0.12-0.369-0.325-0.688-0.615-0.957c-0.269-0.29-0.588-0.495-0.957-0.615 c-0.354-0.186-0.736-0.272-1.146-0.256c-0.769,0.034-1.567,0.287-2.103,0.871C80.508,239.014,80.2,239.714,80.179,240.527 L80.179,240.527z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1032_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M84.905,240.218c-0.14-1.337-2.38-1.771-2.773-0.382c-0.045,0.159,0.087,0.379,0.271,0.357 c0.438-0.052,0.688,0.274,0.638,0.667c-0.052,0.415-0.383,0.565-0.761,0.621c-0.357,0.053-0.205,0.596,0.15,0.543 c0.661-0.098,1.172-0.548,1.18-1.245c0.008-0.661-0.519-1.23-1.207-1.149c0.09,0.119,0.181,0.238,0.271,0.356 c0.211-0.747,1.592-0.482,1.667,0.232C84.379,240.575,84.943,240.579,84.905,240.218L84.905,240.218z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1028_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1030_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M60.232,240.527c0,0.016,0.001,0.033,0.001,0.05c0.02,0.775,0.318,1.55,0.871,2.103 c0.269,0.29,0.588,0.495,0.957,0.615c0.354,0.186,0.736,0.272,1.146,0.256c0.769-0.035,1.567-0.287,2.103-0.871 c0.526-0.573,0.892-1.305,0.871-2.103c-0.001-0.017-0.001-0.033-0.001-0.05c-0.02-0.775-0.318-1.55-0.871-2.103 c-0.269-0.29-0.588-0.495-0.957-0.615c-0.354-0.186-0.736-0.272-1.146-0.256c-0.769,0.034-1.567,0.287-2.103,0.871 C60.577,238.996,60.211,239.728,60.232,240.527L60.232,240.527z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1029_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M62.018,240.218c0.075-0.716,1.456-0.978,1.667-0.232c0.091-0.119,0.181-0.238,0.272-0.356 c-0.685-0.081-1.218,0.487-1.207,1.149c0.012,0.697,0.516,1.146,1.18,1.245c0.354,0.053,0.507-0.49,0.15-0.543 c-0.377-0.056-0.708-0.205-0.761-0.621c-0.05-0.393,0.205-0.718,0.638-0.667c0.185,0.022,0.316-0.197,0.271-0.357 c-0.393-1.39-2.633-0.955-2.773,0.382C61.417,240.578,61.981,240.575,62.018,240.218L62.018,240.218z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1007_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1008_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1027_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M73.162,240.03c0.148,0.747-1.091,1.151-0.709,1.961c0.217,0.46,1.112,0.645,1.454,0.257 c0.21-0.239-0.139-0.59-0.351-0.35c-0.114,0.129-0.576,0.038-0.66-0.127c-0.113-0.221,0.21-0.502,0.325-0.637 c0.321-0.379,0.519-0.728,0.419-1.236C73.578,239.585,73.1,239.718,73.162,240.03L73.162,240.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1026_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M74.252,243.382c-0.503,0.841-1.634,0.848-2.143,0.006 c-0.165-0.273-0.594-0.024-0.428,0.25c0.7,1.158,2.304,1.156,2.999-0.006C74.844,243.357,74.416,243.108,74.252,243.382 L74.252,243.382z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1024_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M78.762,244.165c0.834,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.833,0-1.632,0.733-1.593,1.594C77.207,243.434,77.869,244.165,78.762,244.165L78.762,244.165z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1022_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M67.622,244.165c0.834,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.593,1.594C66.067,243.434,66.729,244.165,67.622,244.165L67.622,244.165z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1021_",
    style: {
      fill: "#5D3338"
    },
    d: "M68.605,240.887c-0.425,0-0.77-0.465-0.77-1.039 c0-0.574,0.345-1.039,0.77-1.039c0.425,0,0.77,0.465,0.77,1.039C69.375,240.422,69.031,240.887,68.605,240.887z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1020_",
    style: {
      fill: "#5D3338"
    },
    d: "M77.755,240.887c0.425,0,0.77-0.465,0.77-1.039 c0-0.574-0.345-1.039-0.77-1.039c-0.425,0-0.77,0.465-0.77,1.039C76.985,240.422,77.33,240.887,77.755,240.887z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1018_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M80.35,238.51c-0.226-0.886-1.163-1.371-2.01-1.483c-0.728-0.097-1.896-0.005-2.19,0.786 c-0.084,0.227,0.129,0.412,0.329,0.432c0.542,0.054,1.019-0.336,1.59-0.319c0.73,0.023,1.259,0.408,1.783,0.873 C80.072,238.994,80.426,238.808,80.35,238.51L80.35,238.51z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1010_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M70.526,238.3c-0.445-0.781-1.097-1.25-2.034-1.192c-0.745,0.046-1.701,0.481-1.561,1.346 c0.017,0.107,0.137,0.177,0.236,0.18c0.516,0.015,0.805-0.319,1.286-0.446c0.556-0.146,1.314-0.014,1.77,0.346 C70.386,238.662,70.642,238.503,70.526,238.3L70.526,238.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M81.632,238.621c-0.527-3.467-1.056-7.181-2.029-10.55c-0.114-0.393-0.222-0.848,0.008-1.186 c0.318-0.467,1.047-0.374,1.533-0.086c0.765,0.452,1.298,1.231,1.59,2.07s0.362,1.739,0.363,2.628 C83.102,233.938,82.6,236.379,81.632,238.621"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M81.822,238.621c-0.183-1.523-0.413-3.037-0.673-4.549c-0.165-0.96-0.34-1.918-0.542-2.87 c-0.15-0.704-0.641-1.728-0.571-2.407c-0.526-0.956-0.197-1.153,0.987-0.591c1.085-0.192,1.626,0.268,1.621,1.379 c0.205,0.88,0.191,1.827,0.151,2.727c-0.097,2.206-0.692,4.176-1.348,6.26c-0.065,0.205,0.253,0.345,0.352,0.148 c1.232-2.464,1.791-5.47,1.538-8.222c-0.136-1.486-0.852-3.903-2.667-4.153c-1.334-0.183-1.391,0.768-1.278,1.785 c0.177,1.591,0.807,3.243,1.1,4.829c0.351,1.899,0.61,3.814,0.959,5.713C81.488,238.879,81.847,238.834,81.822,238.621 L81.822,238.621z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M64.055,238.023c-0.08-1.089-0.15-2.18-0.212-3.27c-0.108-1.921-0.175-3.918,0.575-5.69 c0.097-0.229,0.266-0.489,0.514-0.47c0.23,0.017,0.363,0.265,0.432,0.485c0.286,0.906,0.227,1.882,0.119,2.826 C65.249,233.956,64.719,236.068,64.055,238.023"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M64.163,238.023c0.043-1.307-0.063-2.607-0.111-3.913c-0.025-0.672-0.275-4.167,0.381-4.384 c1.524-0.503,0.506,3.907,0.456,4.168c-0.263,1.382-0.749,2.706-1.005,4.083c-0.034,0.182,0.228,0.327,0.321,0.135 c0.499-1.029,3.207-9.524,0.76-9.77c-2.339-0.235-1.216,8.586-1.017,9.71C63.972,238.177,64.159,238.141,64.163,238.023 L64.163,238.023z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M80.402,228.643c-0.673-0.265-1.422-0.077-2.11,0.128c-2.197,0.656-4.348,1.473-6.432,2.444 c-1.388,0.647-2.765,1.368-4.26,1.672c-1.495,0.304-3.163,0.134-4.362-0.858c-0.625-0.517-1.084-1.223-1.442-1.965 c-0.304-0.63-0.544-1.299-0.66-1.992c-0.419-2.508,1.005-5.206,3.256-6.166c0.685-0.292,1.459-0.434,2.173-0.215 c1.297,0.399,2.055,1.951,1.912,3.348c0.816-0.861,1.957-1.334,3.112-1.489c1.155-0.155,2.332-0.013,3.479,0.217 c0.802,0.161,1.605,0.368,2.338,0.75c1.395,0.727,2.471,2.095,2.879,3.661"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M80.402,228.414c-2.521-0.318-5.147,1.022-7.426,1.995c-2.031,0.867-4.24,2.381-6.52,2.323 c-3.414-0.902-5.116-2.815-5.103-5.741c0.471-4.589,2.752-5.24,6.842-1.952c0.013,0.259,0.292,0.351,0.481,0.199 c3.902-3.144,9.602-1.055,11.42,3.05c0.102,0.23,0.46,0.064,0.397-0.168c-1.184-4.419-6.173-5.411-10.151-4.561 c-2.404,0.513-1.05-0.164-2.721-1.564c-1.274-1.068-3.011-0.684-4.28,0.186c-3.255,2.23-3.365,7.571-0.308,10.053 c5.01,4.067,12.153-3.823,17.369-3.362C80.699,228.897,80.687,228.45,80.402,228.414L80.402,228.414z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 427.23,
    cy: 336.988,
    rx: 37.042,
    ry: 9.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 427.23,
    cy: 339.161,
    rx: 53.158,
    ry: 14.012
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M418.533,232.716c-2.668,0.548-4.257,3.209-3.746,5.77c0,0,1.004,4.894,1.411,6.509 c0.612,2.426,2.771,9.617,2.771,9.617h9.223h9.223c0,0,2.16-7.191,2.771-9.617c0.407-1.615,1.411-6.509,1.411-6.509 c0.511-2.561-1.078-5.222-3.746-5.77c-2.388-0.49-9.659-1.404-9.659-1.404S420.92,232.225,418.533,232.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M417.069,256.804c-1.541,2.716-4.415,7.003-4.415,14.642h15.537h15.537 c0-7.639-2.874-11.926-4.415-14.642c-0.625-1.102-1.899-2.192-1.899-2.192h-9.223h-9.223 C418.968,254.611,417.694,255.702,417.069,256.804z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M428.871,254.839c-0.042,3.238-0.083,6.476-0.125,9.714c0.175-0.047,0.35-0.095,0.525-0.142 c-0.277-0.431-0.606-0.794-0.897-1.206c-0.657-0.931-0.853-1.675-0.86-2.813c-0.011-1.933,0.12-3.853,0.346-5.772 c0.042-0.359-0.521-0.356-0.563,0c-0.264,2.245-0.55,4.666-0.326,6.929c0.145,1.466,1.032,1.928,1.814,3.146 c0.149,0.232,0.521,0.144,0.525-0.142c0.042-3.238,0.083-6.476,0.125-9.714C429.439,254.477,428.875,254.477,428.871,254.839 L428.871,254.839z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1046_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M433.267,254.767c0.698,3.991,3.942,7.559,8.278,6.329c0.348-0.099,0.2-0.642-0.15-0.543 c-4.056,1.151-6.944-2.271-7.585-5.935C433.747,254.261,433.205,254.412,433.267,254.767L433.267,254.767z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1045_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M422.634,254.617c-0.641,3.664-3.526,7.087-7.585,5.935c-0.349-0.099-0.498,0.444-0.15,0.543 c4.334,1.23,7.58-2.337,8.277-6.329C423.239,254.413,422.696,254.261,422.634,254.617L422.634,254.617z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 5.2315,
      strokeMiterlimit: 10
    },
    points: "419.17,333.519  419.207,329.525 419.223,325.942  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M423.43,329.947l0.023-0.396c0.644-10.139,1.184-20.247,1.713-30.366l0.195-3.795l0.048-0.891 c0.004-0.066,0.011-0.1,0.016-0.151l0.018-0.229l0.036-0.462l0.149-1.861c0.205-2.485,0.43-4.971,0.676-7.441 c0.248-2.47,0.515-4.932,0.829-7.345c0.158-1.204,0.323-2.4,0.507-3.561c0.085-0.595,0.195-1.136,0.289-1.706 c0.097-0.567,0.216-1.059,0.32-1.591l-15.319-2.4c-0.061,0.722-0.14,1.474-0.181,2.168c-0.037,0.687-0.091,1.397-0.111,2.064 c-0.058,1.354-0.089,2.678-0.111,3.994c-0.04,2.628-0.024,5.211,0.011,7.79c0.036,2.577,0.098,5.142,0.178,7.708l0.065,1.928 l0.036,1.049l0.06,1.009l0.237,3.782c0.621,10.088,1.232,20.189,1.738,30.256l0.019,0.48L423.43,329.947z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M416.454,331.755c1.848,0.077,3.697,0.111,5.546,0.104c0.723,1.384,1.19,2.902,1.346,4.483 c0.041,0.401-0.268,0.748-0.663,0.737l-6.949-0.179c-0.396-0.01-0.702-0.365-0.63-0.747 C415.39,334.66,415.836,333.171,416.454,331.755z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M421.731,333.841l-0.18-1.501c-0.059-0.484-0.138-1.004-0.478-1.35 c-0.244-0.248-0.589-0.368-0.928-0.444c-0.63-0.141-1.317-0.153-1.893,0.138c-0.607,0.307-1.014,0.917-1.226,1.561 c-0.214,0.643-0.254,1.328-0.293,2.003"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 5.2315,
      strokeMiterlimit: 10
    },
    d: "M433.635,333.519 c0.036-1.332,0.109-2.661,0.165-3.992l0.192-3.581"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M438.004,330.122l0.037-0.388c1.109-9.969,2.453-19.997,3.826-29.992l0.26-1.873l0.131-0.935 c0.042-0.303,0.093-0.639,0.135-1.041c0.158-1.318,0.298-2.601,0.432-3.897c0.264-2.585,0.489-5.174,0.67-7.785 c0.177-2.612,0.308-5.243,0.363-7.925c0.047-2.69,0.042-5.4-0.197-8.328l-15.372,2.025c0.42,2.087,0.708,4.427,0.933,6.788 c0.224,2.37,0.382,4.796,0.494,7.24c0.109,2.445,0.176,4.91,0.206,7.375c0.013,1.229,0.02,2.47,0.013,3.675 c0.004,0.246-0.004,0.51-0.012,0.847l-0.024,0.955l-0.047,1.907c-0.232,10.168-0.432,20.309-0.403,30.543l0,0.49 L438.004,330.122z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M430.966,331.667c1.844,0.138,3.691,0.23,5.54,0.282c0.335,0.695,0.624,1.406,0.835,2.138 c0.207,0.738,0.365,1.467,0.453,2.198c0.044,0.372-0.263,0.702-0.658,0.703l-6.951-0.001c-0.397,0.001-0.704-0.37-0.634-0.78 c0.135-0.804,0.317-1.592,0.562-2.34C430.353,333.114,430.629,332.373,430.966,331.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M436.19,333.886l-0.149-1.477c-0.043-0.479-0.101-0.996-0.429-1.351 c-0.235-0.255-0.575-0.386-0.911-0.475c-0.624-0.165-1.31-0.204-1.897,0.067c-0.618,0.286-1.048,0.886-1.283,1.531 c-0.23,0.647-0.283,1.346-0.336,2.034"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M440.346,234.424c1.561,2.759,2.852,5.516,4.032,8.339c0.292,0.707,0.58,1.414,0.854,2.131 l0.612,1.581c0.23,0.601,0.442,1.199,0.645,1.794c0.395,1.185,0.74,2.36,0.917,3.442c0.179,1.085,0.145,2.034-0.055,2.825 c-0.141,0.372-0.276,0.727-0.447,1.114c-0.04,0.095-0.094,0.2-0.144,0.303l-0.112,0.146c-0.061-0.013-0.062,0.03-0.094,0.037 l-0.072,0.042c-0.184,0.098-0.352,0.169-0.523,0.243c-0.344,0.141-0.678,0.293-1.06,0.427 c-0.394,0.118-0.872,0.165-1.379,0.183c-1.042,0.013-2.258-0.207-3.435-0.426c-1.184-0.223-2.361-0.474-3.519-0.725 l-2.204-0.53l-2.146-0.533l-4.277-1.091l0.849-4.072l4.329,0.671l2.163,0.321l2.124,0.3c0.785,0.076,1.506,0.134,2.164,0.163 c0.329,0.012,0.643,0.022,0.942,0.002c0.075-0.007,0.149-0.013,0.221-0.037c0.085-0.024,0.07-0.156,0.065-0.239 c-0.021-0.187-0.078-0.368-0.135-0.543c-0.247-0.698-0.559-1.308-0.848-1.852c-0.159-0.299-0.252-0.434-0.514-0.943 c-0.313-0.631-0.641-1.257-0.972-1.882c-1.332-2.489-2.786-4.937-4.354-7.174L440.346,234.424z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M440.212,234.007l-6.596,4.232c0.973,1.6,1.883,3.309,2.734,5.049l7.534-3.62 C442.84,237.701,441.636,235.812,440.212,234.007z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M431.095,251.184c-0.683-1.228-1.416-2.432-2.197-3.608 c-0.151-0.226-0.092-0.535,0.131-0.691c0.197-0.138,0.457-0.108,0.619,0.057c1.001,1.024,1.966,2.094,2.893,3.206 l0.002,0.002c0.315,0.377,0.268,0.946-0.105,1.27c-0.374,0.324-0.934,0.279-1.249-0.099 C431.154,251.279,431.121,251.231,431.095,251.184z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M431.505,251.543c-2.422-0.903-4.87-1.745-7.34-2.519c-0.257-0.081-0.398-0.358-0.317-0.619 c0.076-0.245,0.322-0.388,0.563-0.34c2.553,0.52,5.098,1.11,7.626,1.766c0.47,0.122,0.753,0.609,0.631,1.09 c-0.122,0.481-0.604,0.772-1.077,0.65C431.563,251.563,431.533,251.553,431.505,251.543z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M430.675,252.512c-2.429-0.733-4.883-1.393-7.36-1.976c-0.263-0.062-0.424-0.328-0.361-0.594 c0.059-0.249,0.295-0.41,0.539-0.38c2.544,0.323,5.082,0.726,7.608,1.207c0.479,0.091,0.792,0.559,0.701,1.046 c-0.092,0.488-0.555,0.81-1.035,0.719C430.734,252.528,430.703,252.52,430.675,252.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M430.155,253.509l-6.521-1.384c-0.264-0.057-0.431-0.321-0.372-0.588 c0.054-0.248,0.282-0.412,0.525-0.389l0.016,0.002l6.585,0.581l0.027,0.002c0.487,0.041,0.847,0.474,0.806,0.968 c-0.042,0.495-0.472,0.864-0.961,0.823C430.226,253.521,430.188,253.516,430.155,253.509z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M430.952,254.521l-5.23-0.455c-0.27-0.024-0.468-0.266-0.442-0.538 c0.023-0.247,0.222-0.436,0.46-0.451l0.007,0l5.213-0.348l0.012-0.001c0.489-0.035,0.911,0.338,0.944,0.833 c0.033,0.495-0.338,0.926-0.829,0.961C431.043,254.525,430.994,254.525,430.952,254.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M431.463,250.12c0.325,0.728,0.919,1.222,0.657,2.119c-0.31,1.06-1.383,1.026-2.266,0.923 c-0.686-0.081-0.864,0.842-0.217,1.053c1.058,0.345,2.24,0.48,3.031-0.485c0.706-0.861,0.591-2.057-0.044-2.901 c-0.265-0.352-0.917-0.309-0.991,0.2c-0.069,0.482-0.199,0.848-0.499,1.234l0.897,0.182l-0.288-0.052l-0.478-0.238 l-0.144,0.233l0.389,0.135l-0.187,0.483l-0.411-0.029l-0.078-0.328l0.533-0.033c-0.177-0.064-0.313-0.113-0.503-0.086 c-0.229,0.033-0.41,0.213-0.397,0.46l0.006,0.1c0.009,0.169,0.121,0.382,0.288,0.442c0.627,0.228,1.248-0.29,1.083-0.994 c-0.15-0.643-1.006-0.771-1.305-0.169c-0.321,0.644,0.35,1.267,0.987,1.056c0.701-0.233,1.054-1.281,0.624-1.868 c-0.103-0.14-0.291-0.276-0.477-0.238c-0.705,0.145-0.899,0.831-0.648,1.475c0.137,0.351,0.637,0.518,0.898,0.182 c0.406-0.524,0.667-1.075,0.779-1.732l-0.991,0.201c0.371,0.509,0.554,1.329-0.043,1.784 c-0.519,0.395-1.273,0.107-1.815-0.068l-0.217,1.053c1.35,0.153,2.811,0.039,3.394-1.422 c0.409-1.028-0.022-2.819-1.244-3.047C431.594,249.711,431.371,249.915,431.463,250.12z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M416.038,234.503l-0.274,0.384c-0.098,0.136-0.136,0.219-0.206,0.332l-0.372,0.635 c-0.237,0.417-0.412,0.79-0.619,1.188c-0.369,0.766-0.712,1.519-1.023,2.261c-0.628,1.488-1.201,2.958-1.732,4.438 c-0.532,1.48-1.037,2.962-1.508,4.473c-0.233,0.759-0.461,1.523-0.677,2.313c-0.109,0.396-0.21,0.816-0.314,1.23 l-0.148,0.698l-0.036,0.174l-0.039,0.243l-0.067,0.511c-0.009,0.081-0.021,0.18-0.025,0.245l-0.003,0.167l-0.005,0.333 l-0.006,0.664l0.034,1.212c0.036,0.789,0.069,1.575,0.121,2.343c0.091,1.548,0.209,3.073,0.329,4.6 c0.243,3.05,0.517,6.085,0.805,9.118l4.155-0.201c-0.006-3.031,0.001-6.063,0.041-9.083c0.022-1.509,0.045-3.02,0.095-4.514 c0.019-0.751,0.057-1.489,0.091-2.224l0.069-1.08l0.051-0.494l0.025-0.245l0.012-0.123l0.001-0.008 c-0.278-0.025,0.624,0.046-0.624-0.058l0.211,0.009l0.42,0.023c0.007-0.008,0.008-0.017,0.012-0.025l0.22-0.706 c0.115-0.323,0.224-0.644,0.349-0.977c0.25-0.667,0.522-1.344,0.801-2.021c0.564-1.356,1.17-2.708,1.795-4.045 c0.624-1.337,1.284-2.653,1.964-3.923c0.339-0.637,0.691-1.248,1.043-1.835c0.177-0.271,0.356-0.576,0.528-0.819l0.254-0.35 c0.039-0.05,0.089-0.136,0.118-0.158l0.092-0.094L416.038,234.503z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M416.372,233.904l5.876,5.186c-0.058,0.104-0.115,0.179-0.193,0.289l-0.299,0.503 c-0.102,0.17-0.21,0.391-0.315,0.583c-0.106,0.196-0.212,0.397-0.316,0.618c-0.21,0.427-0.42,0.858-0.622,1.313 c-0.207,0.444-0.405,0.903-0.602,1.363l-7.712-3.227c0.25-0.526,0.493-1.044,0.774-1.568l0.416-0.781l0.455-0.788 c0.151-0.26,0.307-0.522,0.487-0.796c0.177-0.272,0.342-0.532,0.533-0.81l0.635-0.865c0.045-0.063,0.131-0.164,0.202-0.249 l0.224-0.262L416.372,233.904z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M413.273,269.249c1.109,0.9,2.184,1.848,3.226,2.842c0.2,0.191,0.515,0.182,0.703-0.02 c0.167-0.179,0.178-0.451,0.039-0.644c-0.857-1.194-1.766-2.358-2.723-3.49l-0.002-0.002 c-0.325-0.384-0.894-0.429-1.271-0.099c-0.377,0.33-0.419,0.911-0.094,1.295 C413.188,269.173,413.231,269.215,413.273,269.249z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M412.982,268.77c0.519,2.628,0.971,5.273,1.353,7.931c0.039,0.276,0.291,0.467,0.562,0.427 c0.253-0.037,0.434-0.266,0.424-0.52c-0.117-2.701-0.305-5.405-0.564-8.103c-0.048-0.502-0.487-0.871-0.98-0.824 c-0.494,0.047-0.855,0.494-0.807,0.997C412.972,268.708,412.977,268.74,412.982,268.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M411.897,269.463c0.35,2.607,0.622,5.227,0.812,7.859c0.02,0.279,0.258,0.489,0.531,0.468 c0.255-0.019,0.451-0.234,0.459-0.488c0.077-2.658,0.072-5.323-0.014-7.989c-0.015-0.505-0.43-0.902-0.925-0.888 c-0.496,0.015-0.885,0.437-0.87,0.943C411.89,269.399,411.893,269.432,411.897,269.463z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M410.831,269.832l0.357,6.9c0.016,0.279,0.25,0.494,0.523,0.478 c0.253-0.014,0.451-0.221,0.466-0.473l0.001-0.016l0.446-6.837l0.002-0.028c0.034-0.505-0.337-0.945-0.833-0.983 c-0.495-0.038-0.927,0.343-0.962,0.849C410.83,269.757,410.83,269.797,410.831,269.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M409.954,268.852l-0.36,5.424c-0.018,0.28,0.19,0.522,0.463,0.541 c0.248,0.017,0.465-0.156,0.517-0.397l0.001-0.007l1.151-5.278l0.003-0.012c0.11-0.495-0.194-0.988-0.678-1.102 c-0.485-0.114-0.967,0.195-1.077,0.692C409.964,268.758,409.957,268.808,409.954,268.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M414.381,269.046c-0.669-0.452-1.066-1.14-1.993-1.018c-1.095,0.145-1.228,1.249-1.261,2.169 c-0.026,0.715-0.966,0.747-1.074,0.05c-0.177-1.139-0.129-2.369,0.946-3.022c0.96-0.583,2.123-0.273,2.86,0.516 c0.308,0.329,0.165,0.99-0.35,0.983c-0.487-0.008-0.869,0.065-1.296,0.31l-0.042-0.948l0.007,0.303l0.162,0.528 l-0.253,0.109l-0.073-0.421l-0.506,0.113l-0.036,0.426l0.312,0.133l0.115-0.54c0.036,0.192,0.064,0.338,0.007,0.529 c-0.069,0.229-0.274,0.385-0.516,0.331l-0.097-0.022c-0.166-0.037-0.358-0.186-0.392-0.367 c-0.128-0.678,0.478-1.23,1.149-0.947c0.613,0.258,0.607,1.155-0.034,1.364c-0.686,0.223-1.198-0.565-0.891-1.182 c0.337-0.679,1.427-0.871,1.941-0.335c0.123,0.128,0.228,0.343,0.162,0.527c-0.253,0.698-0.96,0.785-1.558,0.423 c-0.326-0.197-0.414-0.736-0.042-0.948c0.58-0.331,1.164-0.508,1.831-0.517l-0.35,0.983 c-0.445-0.463-1.228-0.783-1.769-0.246c-0.47,0.467-0.303,1.285-0.212,1.868l-1.074,0.05 c0.058-1.407,0.394-2.881,1.927-3.242c1.079-0.253,2.782,0.48,2.82,1.77C414.806,268.978,414.57,269.173,414.381,269.046z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_972_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M432.841,231.382c4.571,1.588,11.12,2.382,12.689-3.597c0.55-2.095,0.458-4.764-0.053-6.845 c-0.563-2.293-2.199-3.818-3.32-5.817c-2.3-4.103-2.516-8.807-7.324-10.971c-3.319-1.493-9.517-1.613-11.422,2.233 l0.194,0.068c-3.606-2.405-8.082,2.312-8.875,5.527c-0.518,2.098-0.31,4.312-1.054,6.366 c-0.823,2.271-2.657,3.969-3.088,6.413c-0.704,3.99,2.095,8.089,6.32,8.144c2.428,0.032,5.056-1.113,7.35-1.828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_998_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1005_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M427.381,231.452h1.646c6.183,0,11.196-5.013,11.196-11.196v-2.116 c0-6.638-5.381-12.019-12.019-12.019l0,0c-6.638,0-12.019,5.381-12.019,12.019v2.116 C416.185,226.439,421.198,231.452,427.381,231.452z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_997_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 428.204,
    y1: 228.902,
    x2: 428.204,
    y2: 233.195
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M428.204,233.978c2.197,0,3.979-0.35,3.979-0.783c0-0.432-1.782-0.782-3.979-0.782 c-2.198,0-3.979,0.35-3.979,0.782C424.225,233.627,426.007,233.978,428.204,233.978z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 428.204,
    y1: 228.902,
    x2: 428.204,
    y2: 233.195
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M428.204,233.978c2.197,0,3.979-0.35,3.979-0.783c0-0.432-1.782-0.782-3.979-0.782 c-2.198,0-3.979,0.35-3.979,0.782C424.225,233.627,426.007,233.978,428.204,233.978z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_993_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M426.707,231.074h2.995c4.166,0,7.543-3.377,7.543-7.543v-6.954 c0-4.993-4.047-9.04-9.04-9.04l0,0c-4.993,0-9.04,4.047-9.04,9.04v6.954C419.164,227.697,422.541,231.074,426.707,231.074z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_990_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_992_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M435.19,222.649c0,0.016-0.001,0.033-0.001,0.049c-0.015,0.41,0.07,0.792,0.256,1.146 c0.12,0.369,0.325,0.688,0.615,0.957c0.269,0.29,0.589,0.495,0.957,0.615c0.354,0.186,0.736,0.272,1.146,0.256 c0.769-0.034,1.567-0.287,2.103-0.871c0.542-0.591,0.85-1.291,0.871-2.103c0-0.016,0.001-0.033,0.001-0.049 c0.015-0.41-0.07-0.792-0.256-1.146c-0.12-0.369-0.325-0.688-0.615-0.957c-0.269-0.29-0.589-0.495-0.957-0.615 c-0.355-0.186-0.737-0.272-1.146-0.256c-0.769,0.034-1.567,0.287-2.103,0.871 C435.519,221.137,435.211,221.837,435.19,222.649L435.19,222.649z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_991_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M439.916,222.341c-0.14-1.337-2.38-1.771-2.773-0.382c-0.045,0.159,0.086,0.378,0.271,0.356 c0.438-0.052,0.688,0.274,0.638,0.667c-0.052,0.415-0.383,0.565-0.761,0.621c-0.357,0.053-0.205,0.596,0.15,0.543 c0.661-0.098,1.171-0.548,1.18-1.245c0.008-0.661-0.519-1.23-1.207-1.148c0.091,0.119,0.181,0.238,0.272,0.356 c0.211-0.747,1.592-0.482,1.667,0.232C439.39,222.698,439.953,222.702,439.916,222.341L439.916,222.341z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_987_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_989_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M415.243,222.649c0,0.016,0.001,0.033,0.001,0.049c0.02,0.775,0.318,1.55,0.871,2.103 c0.269,0.29,0.589,0.495,0.957,0.615c0.354,0.186,0.737,0.272,1.146,0.256c0.769-0.034,1.567-0.287,2.103-0.871 c0.526-0.573,0.892-1.305,0.871-2.103c0-0.016-0.001-0.033-0.001-0.049c-0.02-0.775-0.318-1.55-0.871-2.103 c-0.269-0.29-0.589-0.495-0.957-0.615c-0.354-0.186-0.737-0.272-1.146-0.256c-0.769,0.034-1.567,0.287-2.103,0.871 C415.588,221.119,415.222,221.851,415.243,222.649L415.243,222.649z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_988_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M417.029,222.341c0.075-0.716,1.456-0.978,1.667-0.232c0.091-0.119,0.181-0.238,0.272-0.356 c-0.685-0.081-1.218,0.487-1.207,1.148c0.012,0.697,0.516,1.147,1.18,1.245c0.355,0.053,0.508-0.49,0.15-0.543 c-0.377-0.056-0.708-0.206-0.761-0.621c-0.05-0.393,0.205-0.718,0.638-0.667c0.185,0.022,0.316-0.197,0.271-0.356 c-0.393-1.39-2.633-0.955-2.773,0.382C416.428,222.701,416.991,222.698,417.029,222.341L417.029,222.341z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_978_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_982_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_983_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_985_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M437.624,218.912v0.026c-5.945-0.125-10.729-4.974-10.729-10.949h0.52 C433.116,208.377,437.624,213.112,437.624,218.912z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_984_",
    style: {
      fill: "#638A89"
    },
    d: "M422.246,207.989h4.849v9.002c-3.745,0-6.954-2.288-8.311-5.541 L422.246,207.989z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_981_",
    style: {
      fill: "#638A89"
    },
    d: "M437.624,218.912c0,0-5.215-5.17-5.365-5.477 c-0.149-0.307-5.165-5.446-5.165-5.446l-2.016,1.36l-0.68-1.812l3.889-0.898l5.579,0.898l2.311,3.291l1.906,3.368 L437.624,218.912z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_953_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_955_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_977_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M428.181,222.153c0.148,0.747-1.091,1.151-0.708,1.961c0.217,0.46,1.112,0.645,1.454,0.257 c0.21-0.239-0.139-0.59-0.35-0.35c-0.114,0.129-0.576,0.038-0.66-0.127c-0.113-0.221,0.21-0.502,0.325-0.637 c0.321-0.379,0.519-0.728,0.418-1.236C428.598,221.708,428.12,221.841,428.181,222.153L428.181,222.153z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_976_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M429.272,225.505c-0.503,0.841-1.634,0.848-2.143,0.006 c-0.165-0.273-0.594-0.024-0.428,0.25c0.7,1.158,2.304,1.156,2.999-0.006C429.864,225.48,429.435,225.231,429.272,225.505 L429.272,225.505z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_974_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M433.782,226.287c0.833,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.594,1.594C432.227,225.557,432.889,226.287,433.782,226.287L433.782,226.287z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_971_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M422.642,226.287c0.834,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.594,1.594C421.087,225.557,421.749,226.287,422.642,226.287L422.642,226.287z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_969_",
    style: {
      fill: "#5D3338"
    },
    d: "M423.625,223.01c-0.425,0-0.77-0.465-0.77-1.039 c0-0.574,0.345-1.039,0.77-1.039c0.425,0,0.77,0.465,0.77,1.039C424.395,222.545,424.05,223.01,423.625,223.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_968_",
    style: {
      fill: "#5D3338"
    },
    d: "M432.775,223.01c0.425,0,0.77-0.465,0.77-1.039 c0-0.574-0.345-1.039-0.77-1.039c-0.425,0-0.77,0.465-0.77,1.039C432.005,222.545,432.35,223.01,432.775,223.01z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_963_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M435.37,220.633c-0.226-0.886-1.163-1.371-2.01-1.483 c-0.728-0.097-1.896-0.005-2.19,0.786c-0.084,0.227,0.129,0.412,0.329,0.432c0.542,0.054,1.019-0.336,1.59-0.319 c0.73,0.023,1.259,0.408,1.783,0.873C435.091,221.117,435.446,220.931,435.37,220.633L435.37,220.633z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_957_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M425.546,220.423c-0.445-0.781-1.097-1.25-2.034-1.192 c-0.745,0.046-1.701,0.481-1.561,1.346c0.017,0.107,0.137,0.177,0.236,0.18c0.516,0.015,0.805-0.319,1.286-0.446 c0.556-0.146,1.314-0.014,1.77,0.346C425.406,220.785,425.662,220.626,425.546,220.423L425.546,220.423z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 354.907,
    cy: 279.136,
    rx: 37.042,
    ry: 9.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 354.907,
    cy: 281.309,
    rx: 53.158,
    ry: 14.012
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M367.539,176.165c1.559,2.697,3.027,5.593,4.195,8.581c0.587,1.489,1.096,2.979,1.568,4.444 l0.685,2.184l0.33,1.082l0.164,0.539l0.248,0.776c0.181,0.608,0.277,1.241,0.242,1.875c-0.011,0.317-0.043,0.631-0.094,0.944 c-0.024,0.156-0.047,0.314-0.078,0.467l-0.09,0.401c-0.22,0.909-0.481,1.689-0.751,2.458 c-0.546,1.521-1.143,2.948-1.758,4.356c-1.231,2.813-2.541,5.536-3.855,8.243l-3.822-1.642 c1.048-2.8,2.082-5.597,3.005-8.394c0.461-1.396,0.894-2.796,1.244-4.161c0.17-0.677,0.323-1.356,0.407-1.957 c0.022-0.165,0.026-0.213,0.028-0.311c0.005-0.087,0.005-0.173-0.001-0.258c-0.005-0.171-0.055-0.338-0.138-0.488 l-1.64-3.924c-0.577-1.346-1.168-2.656-1.808-3.918c-1.272-2.523-2.765-4.897-4.44-7.257L367.539,176.165z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M367.408,175.753l-6.596,4.232c1.043,1.706,2.008,3.415,2.862,5.144 c2.506-1.219,5.016-2.426,7.532-3.622C370.105,179.428,368.804,177.514,367.408,175.753z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M366.5,208.863c-1.346,0.446-2.68,0.942-3.997,1.496c-0.253,0.107-0.545-0.012-0.651-0.265 c-0.094-0.224-0.011-0.479,0.184-0.609c1.214-0.802,2.462-1.554,3.743-2.266l0.003-0.002 c0.434-0.241,0.983-0.087,1.225,0.348c0.242,0.436,0.083,0.988-0.353,1.23C366.605,208.823,366.551,208.846,366.5,208.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M366.936,208.522c-1.382,2.254-2.73,4.515-3.986,6.886c-0.13,0.248-0.431,0.35-0.674,0.223 c-0.227-0.117-0.32-0.4-0.224-0.641c1.031-2.522,2.152-4.926,3.31-7.33c0.216-0.446,0.751-0.634,1.198-0.42 c0.448,0.214,0.636,0.752,0.419,1.201C366.967,208.468,366.952,208.496,366.936,208.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M367.716,209.54c-1.217,2.292-2.399,4.611-3.434,6.988c-0.107,0.251-0.397,0.371-0.651,0.268 c-0.237-0.097-0.354-0.363-0.279-0.609c0.806-2.527,1.752-4.972,2.74-7.408c0.188-0.461,0.711-0.684,1.171-0.499 c0.46,0.185,0.682,0.712,0.493,1.175C367.745,209.483,367.731,209.513,367.716,209.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M368.589,210.253l-2.684,6.238c-0.106,0.25-0.391,0.364-0.645,0.26 c-0.234-0.097-0.357-0.351-0.288-0.589l0.004-0.015l1.914-6.472l0.008-0.027c0.14-0.48,0.64-0.757,1.117-0.62 c0.478,0.137,0.751,0.639,0.609,1.122C368.616,210.185,368.602,210.222,368.589,210.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M369.748,209.649l-1.528,5.145c-0.079,0.264-0.355,0.413-0.618,0.335 c-0.238-0.071-0.383-0.305-0.35-0.544l0.001-0.007l0.735-5.281l0.002-0.012c0.066-0.497,0.519-0.848,1.013-0.787 c0.494,0.061,0.841,0.516,0.773,1.016C369.771,209.558,369.76,209.607,369.748,209.649z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M365.53,208.29c0.782-0.183,1.388-0.683,2.216-0.249c0.978,0.512,0.724,1.583,0.439,2.448 c-0.221,0.671,0.648,1.029,0.99,0.421c0.559-0.994,0.935-2.158,0.148-3.135c-0.703-0.872-1.902-0.981-2.86-0.508 c-0.399,0.197-0.491,0.857-0.005,1.029c0.46,0.162,0.793,0.362,1.11,0.737l0.363-0.863l-0.11,0.278l-0.332,0.433l0.2,0.189 l0.212-0.364l0.436,0.28l-0.113,0.407l-0.338,0.014l0.078-0.54c-0.1,0.166-0.176,0.292-0.188,0.488 c-0.015,0.235,0.124,0.452,0.369,0.486l0.099,0.014c0.168,0.023,0.4-0.048,0.494-0.204c0.353-0.585-0.028-1.307-0.753-1.277 c-0.662,0.027-0.964,0.858-0.435,1.275c0.566,0.446,1.318-0.106,1.24-0.786c-0.084-0.748-1.043-1.301-1.707-0.983 c-0.159,0.076-0.331,0.238-0.331,0.431c-0.001,0.733,0.631,1.06,1.316,0.933c0.373-0.07,0.64-0.54,0.363-0.865 c-0.432-0.508-0.921-0.874-1.543-1.112l-0.005,1.03c0.575-0.273,1.419-0.3,1.743,0.386c0.282,0.596-0.157,1.297-0.442,1.806 l0.99,0.421c0.432-1.324,0.619-2.817-0.699-3.677c-0.929-0.604-2.773-0.513-3.246,0.662 C365.156,208.079,365.31,208.342,365.53,208.29z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M343.763,176.577c-0.336,0.433-0.527,0.766-0.762,1.132c-0.234,0.365-0.4,0.688-0.601,1.033 c-0.369,0.673-0.71,1.332-1.026,1.987c-0.636,1.311-1.221,2.609-1.766,3.922c-0.546,1.314-1.064,2.633-1.549,3.994 l-0.356,1.034l-0.341,1.076l-0.163,0.574l-0.081,0.287l-0.079,0.327c-0.047,0.22-0.112,0.441-0.158,0.73 c-0.044,0.29-0.082,0.581-0.112,0.87c-0.021,1.331,0.128,2.198,0.294,3.097c0.092,0.427,0.175,0.866,0.276,1.28l0.317,1.219 c0.45,1.592,0.937,3.135,1.478,4.639c1.064,3.02,2.255,5.946,3.55,8.851l3.871-1.523c-0.97-2.896-1.847-5.839-2.576-8.786 c-0.375-1.472-0.686-2.946-0.95-4.397l-0.172-1.079c-0.051-0.355-0.08-0.698-0.122-1.046c-0.07-0.664-0.07-1.369-0.026-1.71 c0.017-0.072,0.045-0.142,0.059-0.214l0.107-0.306c0.034-0.11,0.087-0.246,0.143-0.387l0.161-0.411l0.367-0.86l0.399-0.875 c0.549-1.171,1.145-2.344,1.762-3.499c0.616-1.157,1.268-2.294,1.936-3.388c0.333-0.549,0.677-1.077,1.019-1.58 c0.171-0.235,0.345-0.507,0.512-0.711c0.164-0.204,0.342-0.452,0.469-0.567L343.763,176.577z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M344.049,176.052l5.876,5.186c-0.081,0.12-0.161,0.226-0.253,0.348l-0.319,0.492 c-0.108,0.168-0.22,0.37-0.331,0.553c-0.112,0.182-0.222,0.379-0.332,0.583c-0.445,0.789-0.872,1.649-1.292,2.501 l-7.546-3.598c0.528-0.989,1.08-1.958,1.731-2.936c0.31-0.482,0.677-0.985,1.044-1.479l0.625-0.779 C343.496,176.64,343.781,176.334,344.049,176.052z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M344.693,209.105c1.311,0.484,2.613,0.995,3.887,1.531c0.246,0.102,0.54-0.01,0.658-0.247 c0.106-0.212,0.038-0.453-0.148-0.578c-1.159-0.768-2.353-1.532-3.578-2.271l-0.003-0.002 c-0.415-0.251-0.972-0.127-1.241,0.286c-0.268,0.412-0.15,0.96,0.275,1.21C344.59,209.062,344.643,209.087,344.693,209.105z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M344.276,208.757c1.245,2.235,2.474,4.501,3.746,6.64c0.136,0.214,0.434,0.269,0.667,0.125 c0.218-0.135,0.305-0.39,0.209-0.586c-1.011-2.223-2.004-4.603-3.004-6.954c-0.183-0.439-0.703-0.644-1.162-0.456 c-0.459,0.188-0.681,0.703-0.495,1.151C344.248,208.704,344.263,208.732,344.276,208.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M343.444,209.719c0.543,1.144,1.087,2.29,1.632,3.436c0.545,1.146,1.088,2.293,1.687,3.424 c0.127,0.241,0.424,0.326,0.662,0.191c0.223-0.126,0.32-0.393,0.234-0.614c-0.459-1.147-0.877-2.343-1.296-3.534 c-0.42-1.195-0.839-2.39-1.259-3.587c-0.162-0.452-0.668-0.69-1.136-0.53c-0.47,0.161-0.723,0.667-0.558,1.127 C343.419,209.663,343.431,209.692,343.444,209.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M342.537,210.385c0.789,2.098,1.611,4.169,2.593,6.253c0.122,0.255,0.432,0.366,0.674,0.241 c0.227-0.115,0.324-0.382,0.241-0.616l-0.005-0.015c-0.707-2.119-1.263-4.236-1.782-6.367l-0.006-0.027 c-0.113-0.472-0.596-0.761-1.08-0.647c-0.484,0.114-0.782,0.594-0.667,1.075 C342.514,210.316,342.526,210.354,342.537,210.385z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M341.411,209.742c0.411,1.722,0.849,3.44,1.351,5.174c0.081,0.27,0.361,0.426,0.624,0.348 c0.238-0.071,0.382-0.308,0.348-0.549l-0.001-0.007c-0.234-1.764-0.412-3.501-0.547-5.237l-0.001-0.012 c-0.043-0.486-0.464-0.853-0.961-0.815c-0.495,0.037-0.869,0.466-0.833,0.963 C341.394,209.651,341.401,209.7,341.411,209.742z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M345.69,208.584c-0.771-0.202-1.334-0.717-2.187-0.33c-1.01,0.457-0.818,1.518-0.576,2.378 c0.185,0.668-0.697,0.994-1.007,0.378c-0.512-1.004-0.816-2.172,0.029-3.09c0.753-0.817,1.958-0.862,2.88-0.364 c0.385,0.208,0.429,0.851-0.063,0.999c-0.467,0.14-0.81,0.32-1.146,0.674l-0.308-0.858l0.091,0.277l0.304,0.436 l-0.209,0.176l-0.191-0.364l-0.451,0.256l0.091,0.402l0.336,0.028l-0.049-0.531c0.091,0.165,0.16,0.291,0.161,0.484 c0.002,0.23-0.148,0.437-0.394,0.461l-0.099,0.01c-0.169,0.016-0.396-0.063-0.482-0.22 c-0.325-0.589,0.107-1.281,0.824-1.218c0.653,0.057,0.91,0.875,0.36,1.263c-0.586,0.415-1.311-0.155-1.192-0.82 c0.131-0.731,1.12-1.224,1.76-0.885c0.153,0.081,0.313,0.245,0.3,0.434c-0.04,0.711-0.687,1.008-1.363,0.856 c-0.371-0.082-0.605-0.557-0.31-0.862c0.461-0.477,0.971-0.811,1.606-1.014l-0.062,1.002 c-0.553-0.289-1.391-0.355-1.757,0.302c-0.322,0.573,0.087,1.279,0.341,1.79l-1.007,0.378 c-0.37-1.326-0.458-2.804,0.906-3.577c0.964-0.542,2.796-0.369,3.186,0.781C346.075,208.394,345.906,208.642,345.69,208.584 z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M346.21,174.864c-2.668,0.548-4.257,3.209-3.746,5.77c0,0,1.004,4.894,1.411,6.509 c0.612,2.426,2.771,9.617,2.771,9.617h9.223h9.223c0,0,2.16-7.191,2.771-9.617c0.407-1.615,1.411-6.509,1.411-6.509 c0.511-2.561-1.078-5.222-3.746-5.77c-2.388-0.49-9.659-1.404-9.659-1.404S348.598,174.374,346.21,174.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M344.746,198.952c-1.541,2.717-4.415,7.003-4.415,14.642h15.537h15.537 c0-7.639-2.874-11.925-4.415-14.642c-0.625-1.102-1.899-2.192-1.899-2.192h-9.223h-9.223 C346.645,196.76,345.371,197.85,344.746,198.952z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1003_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M356.548,196.987c-0.042,3.238-0.083,6.476-0.124,9.714c0.175-0.047,0.35-0.095,0.525-0.142 c-0.277-0.431-0.606-0.794-0.897-1.206c-0.657-0.93-0.853-1.675-0.86-2.813c-0.011-1.933,0.12-3.853,0.346-5.772 c0.042-0.359-0.521-0.356-0.563,0c-0.264,2.245-0.55,4.666-0.326,6.929c0.145,1.466,1.032,1.928,1.813,3.146 c0.149,0.232,0.521,0.144,0.525-0.142c0.042-3.238,0.083-6.476,0.125-9.714C357.116,196.625,356.552,196.625,356.548,196.987 L356.548,196.987z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1002_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M360.944,196.915c0.698,3.991,3.942,7.559,8.277,6.329c0.348-0.099,0.2-0.642-0.15-0.543 c-4.056,1.151-6.944-2.271-7.585-5.935C361.424,196.409,360.882,196.56,360.944,196.915L360.944,196.915z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1000_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M350.311,196.766c-0.641,3.664-3.526,7.087-7.585,5.935c-0.349-0.099-0.498,0.444-0.15,0.543 c4.334,1.23,7.58-2.337,8.278-6.329C350.916,196.561,350.373,196.409,350.311,196.766L350.311,196.766z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 5.2315,
      strokeMiterlimit: 10
    },
    points: "346.847,275.667  346.884,271.673 346.9,268.091  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M351.107,272.095l0.023-0.396c0.644-10.139,1.184-20.247,1.713-30.366l0.195-3.795 l0.048-0.891c0.004-0.066,0.011-0.1,0.016-0.151l0.018-0.229l0.036-0.462l0.149-1.861c0.205-2.485,0.43-4.97,0.676-7.441 c0.248-2.47,0.515-4.932,0.828-7.345c0.158-1.204,0.323-2.4,0.507-3.561c0.085-0.595,0.195-1.137,0.29-1.706 c0.097-0.567,0.216-1.059,0.32-1.591l-15.32-2.4c-0.061,0.722-0.14,1.474-0.181,2.168c-0.037,0.687-0.091,1.397-0.111,2.064 c-0.058,1.354-0.089,2.678-0.111,3.994c-0.04,2.628-0.024,5.212,0.011,7.79c0.036,2.577,0.098,5.141,0.178,7.707l0.065,1.928 l0.036,1.049l0.06,1.009l0.237,3.783c0.621,10.088,1.232,20.189,1.738,30.255l0.019,0.48L351.107,272.095z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M344.131,273.903c1.848,0.077,3.697,0.111,5.546,0.104c0.723,1.384,1.19,2.902,1.346,4.482 c0.041,0.4-0.268,0.748-0.663,0.737l-6.949-0.179c-0.396-0.011-0.702-0.365-0.63-0.747 C343.067,276.808,343.513,275.319,344.131,273.903z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M349.408,275.989l-0.18-1.501c-0.059-0.484-0.138-1.003-0.478-1.35 c-0.244-0.248-0.589-0.367-0.928-0.444c-0.63-0.141-1.317-0.153-1.893,0.138c-0.607,0.307-1.014,0.917-1.226,1.561 c-0.214,0.643-0.254,1.328-0.293,2.003"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 5.2315,
      strokeMiterlimit: 10
    },
    d: "M361.135,275.602 c0.037-1.35,0.11-2.683,0.166-4.024l0.193-3.596"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M365.506,272.176l0.037-0.39c1.111-10.013,2.456-20.042,3.829-30.051l0.261-1.876l0.131-0.937 c0.042-0.306,0.092-0.635,0.133-1.009c0.156-1.298,0.296-2.574,0.429-3.859c0.263-2.565,0.488-5.134,0.668-7.72 c0.177-2.587,0.308-5.189,0.363-7.831c0.049-2.647,0.046-5.311-0.18-8.137l-15.372,2.027 c0.406,1.985,0.693,4.277,0.917,6.595c0.223,2.329,0.38,4.727,0.493,7.146c0.109,2.421,0.177,4.866,0.208,7.31 c0.013,1.218,0.02,2.451,0.015,3.637c0.005,0.224-0.001,0.471-0.01,0.814l-0.025,0.956l-0.047,1.909 c-0.233,10.181-0.434,20.323-0.407,30.602l0,0.493L365.506,272.176z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M363.976,274.033c0,0,1.297,0.648,2.994,1.496c1.674,0.854,3.741,1.909,5.329,2.719 c0.315,0.166,0.667,0.525,0.418,0.768c-0.114,0.112-0.302,0.12-0.468,0.12h-10.799c-0.048-0.974-0.539-1.928-1.27-2.521 c-0.268,0.627-0.513,1.282-0.771,1.93c-0.148,0.385-0.227,0.591-0.227,0.591h-2.155c0,0-0.036-0.321-0.052-0.787 c-0.014-0.462-0.014-1.083,0.076-1.643c0.127-0.759,0.816-2.713,1.069-2.843c0.157-0.09,0.348-0.07,0.525-0.047 C360.218,274.024,363.976,274.033,363.976,274.033"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M343.214,180.612c-0.34,2.485-0.144,4.901,0.619,7.292c0.11,0.344,0.654,0.197,0.543-0.15 c-0.729-2.285-0.944-4.615-0.619-6.993C343.805,180.408,343.263,180.254,343.214,180.612L343.214,180.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M368.298,180.017c0.503,3.044-0.31,5.962-1.182,8.857c-0.105,0.348,0.439,0.496,0.543,0.15 c0.908-3.014,1.704-5.996,1.182-9.156C368.782,179.511,368.239,179.662,368.298,180.017L368.298,180.017z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_910_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_938_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_941_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M355.058,173.6h1.646c6.183,0,11.196-5.013,11.196-11.196v-2.116 c0-6.638-5.381-12.019-12.019-12.019l0,0c-6.638,0-12.019,5.381-12.019,12.019v2.116 C343.862,168.588,348.875,173.6,355.058,173.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_936_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 355.882,
    y1: 171.05,
    x2: 355.882,
    y2: 175.343
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M355.882,176.126c2.198,0,3.979-0.35,3.979-0.783c0-0.432-1.781-0.782-3.979-0.782 c-2.198,0-3.979,0.35-3.979,0.782C351.902,175.775,353.684,176.126,355.882,176.126z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 355.882,
    y1: 171.05,
    x2: 355.882,
    y2: 175.343
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M355.882,176.126c2.198,0,3.979-0.35,3.979-0.783c0-0.432-1.781-0.782-3.979-0.782 c-2.198,0-3.979,0.35-3.979,0.782C351.902,175.775,353.684,176.126,355.882,176.126z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_931_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M354.384,173.222h2.996c4.166,0,7.543-3.377,7.543-7.542v-6.954 c0-4.993-4.048-9.04-9.04-9.04l0,0c-4.993,0-9.04,4.047-9.04,9.04v6.954C346.841,169.845,350.218,173.222,354.384,173.222z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_926_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_929_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M362.867,164.798c0,0.016-0.001,0.033-0.001,0.049c-0.015,0.41,0.07,0.792,0.256,1.146 c0.12,0.369,0.325,0.688,0.615,0.957c0.27,0.29,0.589,0.495,0.957,0.615c0.354,0.186,0.736,0.272,1.146,0.256 c0.769-0.035,1.567-0.287,2.103-0.871c0.542-0.591,0.85-1.291,0.871-2.103c0-0.016,0.001-0.033,0.001-0.049 c0.015-0.41-0.07-0.792-0.256-1.146c-0.12-0.369-0.325-0.688-0.615-0.957c-0.27-0.29-0.589-0.495-0.957-0.615 c-0.354-0.186-0.737-0.272-1.146-0.256c-0.769,0.035-1.567,0.287-2.103,0.871 C363.196,163.285,362.888,163.985,362.867,164.798L362.867,164.798z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_928_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M367.593,164.489c-0.14-1.337-2.38-1.771-2.773-0.382c-0.045,0.159,0.086,0.378,0.271,0.356 c0.438-0.052,0.688,0.274,0.638,0.667c-0.052,0.415-0.383,0.565-0.761,0.621c-0.357,0.053-0.205,0.596,0.15,0.543 c0.661-0.098,1.172-0.548,1.18-1.245c0.008-0.661-0.52-1.23-1.207-1.148c0.091,0.119,0.181,0.238,0.272,0.356 c0.211-0.747,1.592-0.482,1.667,0.232C367.067,164.846,367.631,164.85,367.593,164.489L367.593,164.489z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_923_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_925_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M342.92,164.798c0,0.016,0.001,0.033,0.001,0.049c0.02,0.775,0.318,1.55,0.871,2.103 c0.269,0.29,0.589,0.495,0.957,0.615c0.354,0.186,0.737,0.272,1.146,0.256c0.769-0.035,1.567-0.287,2.103-0.871 c0.526-0.573,0.892-1.305,0.871-2.103c0-0.016-0.001-0.033-0.001-0.049c-0.02-0.775-0.318-1.55-0.871-2.103 c-0.269-0.29-0.589-0.495-0.957-0.615c-0.354-0.186-0.737-0.272-1.146-0.256c-0.769,0.035-1.567,0.287-2.103,0.871 C343.265,163.267,342.899,163.999,342.92,164.798L342.92,164.798z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_924_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M344.706,164.489c0.075-0.716,1.456-0.978,1.667-0.232c0.09-0.119,0.181-0.238,0.271-0.356 c-0.685-0.081-1.218,0.487-1.207,1.148c0.012,0.697,0.516,1.146,1.18,1.245c0.354,0.053,0.507-0.49,0.15-0.543 c-0.377-0.056-0.708-0.206-0.761-0.621c-0.05-0.394,0.205-0.718,0.638-0.667c0.185,0.022,0.316-0.197,0.272-0.356 c-0.393-1.39-2.633-0.955-2.773,0.382C344.105,164.849,344.669,164.846,344.706,164.489L344.706,164.489z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_907_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_908_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_922_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M355.858,164.301c0.148,0.747-1.091,1.151-0.708,1.961c0.217,0.46,1.112,0.645,1.454,0.257 c0.21-0.239-0.139-0.59-0.351-0.35c-0.114,0.129-0.576,0.038-0.66-0.127c-0.112-0.221,0.21-0.502,0.325-0.637 c0.321-0.379,0.519-0.728,0.418-1.236C356.275,163.857,355.797,163.989,355.858,164.301L355.858,164.301z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_921_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M356.949,167.653c-0.503,0.841-1.634,0.848-2.143,0.006 c-0.165-0.273-0.594-0.024-0.428,0.25c0.7,1.158,2.304,1.156,2.999-0.006 C357.541,167.628,357.112,167.379,356.949,167.653L356.949,167.653z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_919_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M361.459,168.436c0.833,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.594,1.594C359.904,167.705,360.566,168.436,361.459,168.436L361.459,168.436z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_917_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M350.319,168.436c0.833,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.594,1.594C348.764,167.705,349.426,168.436,350.319,168.436L350.319,168.436z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_916_",
    style: {
      fill: "#5D3338"
    },
    d: "M351.302,165.158c-0.425,0-0.77-0.465-0.77-1.039 c0-0.574,0.345-1.039,0.77-1.039c0.425,0,0.77,0.465,0.77,1.039C352.072,164.693,351.727,165.158,351.302,165.158z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_915_",
    style: {
      fill: "#5D3338"
    },
    d: "M360.452,165.158c0.425,0,0.77-0.465,0.77-1.039 c0-0.574-0.344-1.039-0.77-1.039c-0.425,0-0.77,0.465-0.77,1.039C359.682,164.693,360.027,165.158,360.452,165.158z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_913_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M363.047,162.781c-0.226-0.886-1.163-1.371-2.01-1.483 c-0.728-0.097-1.896-0.005-2.19,0.786c-0.084,0.227,0.129,0.412,0.329,0.432c0.542,0.054,1.019-0.336,1.59-0.319 c0.73,0.023,1.259,0.408,1.783,0.873C362.768,163.265,363.123,163.079,363.047,162.781L363.047,162.781z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_909_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M353.223,162.571c-0.445-0.781-1.097-1.25-2.034-1.192 c-0.745,0.046-1.701,0.481-1.561,1.346c0.017,0.107,0.137,0.177,0.236,0.18c0.516,0.015,0.805-0.319,1.286-0.446 c0.556-0.146,1.314-0.014,1.77,0.346C353.083,162.933,353.339,162.775,353.223,162.571L353.223,162.571z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M357.302,148.427c-0.092-1.689,0.468-3.406,1.538-4.716c1.07-1.311,2.639-2.203,4.313-2.451 c0.891-0.132,1.823-0.084,2.661,0.249c1.55,0.616,2.587,2.123,3.145,3.696c0.558,1.572,0.724,3.252,1.088,4.88 c0.364,1.628,0.971,3.28,2.202,4.406c0.704,0.644,1.595,1.102,2.138,1.886c-2.667,0.112-5.357-1.119-7.016-3.212 c-0.509-0.643-0.923-1.355-1.41-2.015c-0.901-1.219-2.11-2.282-3.577-2.661c-1.467-0.379-3.206,0.064-4.057,1.318"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M357.375,148.427c0.213-4.279,3.921-8.287,8.296-6.372c3.49,1.528,3.361,4.889,4.136,8.094 c0.317,1.31,0.722,2.646,1.555,3.734c0.785,1.026,3.581,2.563,0.63,1.928c-4.287-0.923-4.965-5.651-8.613-7.269 c-1.905-0.845-3.909-0.531-5.196,1.118c-0.158,0.202,0.089,0.468,0.288,0.288c1.279-0.394,2.558-0.788,3.836-1.182 c0.741,0.411,1.483,0.821,2.224,1.232c0.762,0.646,1.283,1.52,1.878,2.309c0.699,0.927,1.268,1.751,2.209,2.481 c1.679,1.303,3.67,1.849,5.768,1.853c0.237,0,0.343-0.288,0.188-0.454c-1.598-1.723-3.263-2.769-4.036-5.195 c-0.608-1.909-0.644-3.968-1.358-5.85c-0.674-1.777-1.855-3.389-3.755-3.916c-4.545-1.261-8.223,3.009-8.196,7.201 C357.231,148.521,357.37,148.52,357.375,148.427L357.375,148.427z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M364.922,155.913c-0.092-0.601-0.534-1.423-0.747-1.992c-0.62-1.652-2.14-2.765-3.583-3.781 c-0.485-0.341-0.977-0.687-1.536-0.884c-0.49-0.173-1.014-0.226-1.534-0.249c-2.325-0.102-4.672,0.382-6.767,1.395 c-0.592,0.286-1.166,0.616-1.674,1.033c-1.325,1.088-2.115,2.701-2.611,4.342c-0.514,1.698-0.748,3.507-0.5,5.256 c0.735,0.099,1.502,0.034,2.244-0.062c2.372-0.306,4.734-0.862,6.883-1.914c1.716-0.84,3.288-2.018,4.483-3.5 c0.549,1.332,1.403,2.542,2.402,3.587c0.661,0.692,1.399,1.328,2.263,1.741c0.349,0.167,0.721,0.292,1.102,0.37 C365.332,159.48,365.203,157.738,364.922,155.913z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 295.034,
    cy: 211.826,
    rx: 29.866,
    ry: 7.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 295.034,
    cy: 213.577,
    rx: 42.86,
    ry: 11.297
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M288.022,127.754c-2.151,0.442-3.432,2.587-3.021,4.652c0,0,0.809,3.946,1.137,5.248 c0.493,1.956,2.234,7.754,2.234,7.754h7.436h7.436c0,0,1.741-5.798,2.234-7.754c0.328-1.302,1.137-5.248,1.137-5.248 c0.412-2.065-0.869-4.21-3.021-4.652c-1.925-0.395-7.787-1.132-7.787-1.132S289.947,127.359,288.022,127.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M286.842,147.176c-1.243,2.19-3.56,5.646-3.56,11.805h12.527h12.527 c0-6.159-2.317-9.615-3.56-11.805c-0.504-0.889-1.531-1.768-1.531-1.768h-7.436h-7.436 C288.373,145.408,287.346,146.287,286.842,147.176z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_966_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M296.357,145.592c-0.033,2.611-0.067,5.222-0.1,7.832c0.141-0.038,0.282-0.076,0.423-0.115 c-0.223-0.347-0.489-0.64-0.723-0.972c-0.53-0.75-0.688-1.351-0.693-2.268c-0.009-1.558,0.097-3.107,0.279-4.654 c0.034-0.29-0.42-0.287-0.454,0c-0.213,1.81-0.443,3.762-0.263,5.587c0.117,1.182,0.832,1.555,1.462,2.537 c0.12,0.187,0.42,0.116,0.423-0.115c0.034-2.611,0.067-5.222,0.101-7.832C296.815,145.299,296.361,145.299,296.357,145.592 L296.357,145.592z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_965_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M299.901,145.533c0.563,3.218,3.178,6.095,6.674,5.103c0.281-0.08,0.161-0.518-0.121-0.438 c-3.27,0.928-5.599-1.831-6.116-4.785C300.289,145.125,299.851,145.247,299.901,145.533L299.901,145.533z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_964_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M291.328,145.413c-0.517,2.954-2.843,5.714-6.116,4.785c-0.281-0.08-0.402,0.358-0.121,0.438 c3.494,0.992,6.111-1.884,6.674-5.103C291.816,145.248,291.379,145.125,291.328,145.413L291.328,145.413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 4.218,
      strokeMiterlimit: 10
    },
    points: "288.535,209.029  288.565,205.808 288.578,202.92  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M291.97,206.149l0.018-0.32c0.519-8.175,0.954-16.324,1.381-24.483l0.157-3.06l0.039-0.718 c0.003-0.053,0.009-0.08,0.013-0.122l0.014-0.184l0.029-0.373l0.12-1.5c0.165-2.004,0.346-4.008,0.545-6 c0.2-1.991,0.415-3.977,0.668-5.922c0.127-0.971,0.26-1.935,0.409-2.871c0.068-0.479,0.157-0.916,0.233-1.375 c0.078-0.457,0.174-0.854,0.258-1.283l-12.352-1.935c-0.049,0.582-0.113,1.189-0.146,1.748 c-0.03,0.554-0.073,1.126-0.09,1.664c-0.047,1.092-0.072,2.159-0.089,3.22c-0.032,2.119-0.02,4.202,0.009,6.281 c0.029,2.078,0.079,4.146,0.143,6.214l0.053,1.554l0.029,0.846l0.048,0.814l0.191,3.05 c0.501,8.133,0.993,16.278,1.402,24.394l0.015,0.387L291.97,206.149z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M286.345,207.606c1.49,0.062,2.981,0.09,4.472,0.084c0.583,1.116,0.959,2.34,1.085,3.614 c0.033,0.323-0.216,0.603-0.534,0.594l-5.603-0.145c-0.32-0.008-0.566-0.294-0.508-0.603 C285.488,209.949,285.847,208.748,286.345,207.606z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M290.6,209.288l-0.145-1.21c-0.047-0.39-0.111-0.809-0.385-1.089 c-0.197-0.2-0.475-0.297-0.748-0.358c-0.508-0.114-1.062-0.124-1.526,0.111c-0.49,0.248-0.818,0.739-0.988,1.259 c-0.172,0.519-0.205,1.07-0.236,1.615"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 4.218,
      strokeMiterlimit: 10
    },
    d: "M300.198,209.028 c0.029-1.074,0.088-2.146,0.133-3.219l0.155-2.887"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M303.721,206.29l0.03-0.312c0.894-8.037,1.978-16.123,3.085-24.182l0.21-1.51l0.105-0.754 c0.034-0.244,0.075-0.515,0.109-0.839c0.127-1.063,0.24-2.097,0.348-3.142c0.213-2.085,0.394-4.172,0.54-6.277 c0.143-2.106,0.249-4.227,0.292-6.389c0.038-2.169,0.034-4.354-0.158-6.715l-12.394,1.633 c0.338,1.683,0.571,3.569,0.753,5.473c0.181,1.911,0.308,3.867,0.398,5.838c0.088,1.971,0.142,3.959,0.166,5.946 c0.01,0.991,0.016,1.992,0.01,2.963c0.003,0.199-0.003,0.411-0.01,0.683l-0.02,0.77l-0.038,1.537 c-0.187,8.198-0.348,16.375-0.325,24.626l0,0.395L303.721,206.29z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M298.046,207.535c1.487,0.111,2.976,0.185,4.467,0.227c0.27,0.56,0.503,1.133,0.673,1.724 c0.167,0.595,0.295,1.183,0.365,1.772c0.035,0.3-0.212,0.566-0.53,0.567l-5.605-0.001c-0.32,0.001-0.568-0.298-0.511-0.629 c0.109-0.648,0.256-1.284,0.453-1.886C297.552,208.702,297.774,208.104,298.046,207.535z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M302.258,209.324l-0.12-1.19c-0.034-0.386-0.082-0.803-0.346-1.089 c-0.189-0.205-0.464-0.312-0.734-0.383c-0.503-0.133-1.057-0.165-1.529,0.054c-0.498,0.23-0.845,0.714-1.035,1.234 c-0.186,0.522-0.228,1.085-0.271,1.64"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M305.609,129.131c1.259,2.224,2.299,4.448,3.251,6.723c0.236,0.57,0.468,1.14,0.689,1.718 l0.494,1.275c0.185,0.484,0.356,0.967,0.52,1.446c0.319,0.956,0.597,1.903,0.74,2.776c0.144,0.875,0.117,1.64-0.044,2.277 c-0.113,0.3-0.223,0.586-0.36,0.898c-0.032,0.076-0.076,0.161-0.117,0.244l-0.09,0.118c-0.049-0.011-0.05,0.024-0.076,0.03 l-0.058,0.034c-0.149,0.079-0.284,0.136-0.422,0.196c-0.277,0.114-0.547,0.236-0.855,0.344 c-0.318,0.095-0.703,0.133-1.112,0.148c-0.84,0.011-1.82-0.167-2.77-0.344c-0.954-0.18-1.904-0.382-2.837-0.584l-1.777-0.427 l-1.731-0.429l-3.448-0.88l0.685-3.284l3.49,0.541l1.744,0.258l1.713,0.242c0.633,0.061,1.214,0.108,1.745,0.131 c0.266,0.01,0.518,0.018,0.76,0.002c0.06-0.006,0.12-0.011,0.178-0.03c0.068-0.02,0.057-0.126,0.052-0.192 c-0.017-0.151-0.063-0.297-0.109-0.438c-0.199-0.563-0.45-1.055-0.684-1.493c-0.128-0.241-0.203-0.35-0.414-0.76 c-0.253-0.509-0.517-1.014-0.784-1.517c-1.074-2.007-2.246-3.981-3.511-5.784L305.609,129.131z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M305.501,128.795l-5.318,3.412c0.784,1.29,1.518,2.668,2.204,4.071l6.075-2.919 C307.62,131.773,306.649,130.251,305.501,128.795z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M298.15,142.645c-0.551-0.99-1.141-1.961-1.771-2.909c-0.121-0.182-0.074-0.432,0.105-0.557 c0.159-0.111,0.369-0.087,0.499,0.046c0.807,0.826,1.585,1.689,2.332,2.585l0.002,0.002 c0.254,0.304,0.216,0.762-0.085,1.023c-0.301,0.261-0.753,0.225-1.007-0.08C298.197,142.721,298.171,142.682,298.15,142.645 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M298.481,142.934c-1.953-0.728-3.926-1.407-5.918-2.031 c-0.207-0.065-0.321-0.288-0.256-0.499c0.061-0.197,0.26-0.313,0.454-0.274c2.058,0.419,4.11,0.895,6.149,1.424 c0.379,0.098,0.607,0.491,0.508,0.879c-0.098,0.387-0.487,0.622-0.868,0.524 C298.527,142.949,298.503,142.942,298.481,142.934z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M297.811,143.715c-1.958-0.591-3.937-1.123-5.934-1.593c-0.212-0.05-0.342-0.264-0.291-0.479 c0.048-0.201,0.238-0.33,0.434-0.306c2.051,0.26,4.097,0.585,6.134,0.973c0.386,0.073,0.639,0.45,0.565,0.843 c-0.074,0.393-0.448,0.653-0.835,0.579C297.86,143.728,297.835,143.721,297.811,143.715z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M297.392,144.519l-5.257-1.116c-0.213-0.046-0.347-0.259-0.3-0.474 c0.044-0.2,0.228-0.332,0.423-0.314l0.013,0.001l5.309,0.469l0.022,0.002c0.393,0.033,0.683,0.382,0.649,0.781 c-0.034,0.399-0.381,0.696-0.775,0.663C297.45,144.529,297.419,144.524,297.392,144.519z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M298.035,145.335l-4.217-0.367c-0.218-0.02-0.377-0.214-0.356-0.434 c0.019-0.2,0.179-0.352,0.371-0.363l0.006,0l4.203-0.281l0.009-0.001c0.394-0.028,0.735,0.272,0.761,0.672 c0.026,0.399-0.273,0.747-0.668,0.775C298.108,145.338,298.069,145.338,298.035,145.335z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M298.447,141.787c0.262,0.587,0.741,0.985,0.529,1.709c-0.25,0.855-1.115,0.828-1.827,0.744 c-0.553-0.065-0.697,0.679-0.175,0.849c0.853,0.278,1.806,0.387,2.444-0.391c0.569-0.694,0.477-1.658-0.036-2.339 c-0.214-0.284-0.739-0.249-0.799,0.161c-0.056,0.389-0.161,0.684-0.402,0.995l0.723,0.147l-0.232-0.042l-0.385-0.192 l-0.116,0.188l0.314,0.108l-0.151,0.389l-0.332-0.023l-0.063-0.264l0.43-0.026c-0.143-0.052-0.252-0.091-0.406-0.069 c-0.184,0.027-0.331,0.172-0.32,0.37l0.005,0.08c0.008,0.136,0.098,0.308,0.232,0.357c0.505,0.184,1.006-0.234,0.873-0.801 c-0.121-0.518-0.811-0.622-1.052-0.137c-0.258,0.52,0.282,1.022,0.796,0.851c0.565-0.188,0.85-1.033,0.503-1.506 c-0.083-0.113-0.235-0.223-0.384-0.192c-0.568,0.117-0.725,0.67-0.522,1.189c0.11,0.283,0.514,0.418,0.724,0.147 c0.328-0.422,0.538-0.867,0.628-1.397l-0.799,0.162c0.299,0.41,0.447,1.071-0.035,1.438 c-0.418,0.319-1.026,0.086-1.463-0.055l-0.175,0.849c1.089,0.124,2.266,0.031,2.736-1.146 c0.33-0.829-0.018-2.273-1.003-2.456C298.553,141.457,298.373,141.621,298.447,141.787z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M286.01,129.195l-0.221,0.31c-0.079,0.11-0.109,0.177-0.166,0.268l-0.3,0.512 c-0.191,0.337-0.332,0.637-0.499,0.958c-0.298,0.618-0.574,1.224-0.825,1.823c-0.506,1.199-0.968,2.385-1.396,3.578 c-0.429,1.194-0.836,2.389-1.216,3.606c-0.188,0.612-0.372,1.228-0.546,1.865c-0.088,0.319-0.169,0.658-0.253,0.992 l-0.119,0.563l-0.029,0.141l-0.031,0.196l-0.054,0.412c-0.007,0.065-0.017,0.145-0.02,0.198l-0.002,0.135l-0.004,0.269 l-0.005,0.535l0.027,0.977c0.029,0.636,0.055,1.27,0.097,1.889c0.074,1.248,0.169,2.478,0.265,3.709 c0.196,2.459,0.417,4.906,0.649,7.351l3.35-0.162c-0.005-2.444,0.001-4.888,0.033-7.324c0.017-1.217,0.036-2.435,0.077-3.639 c0.015-0.605,0.046-1.2,0.073-1.793l0.056-0.871l0.041-0.398l0.02-0.198l0.01-0.099l0.001-0.006 c-0.224-0.02,0.503,0.037-0.503-0.047l0.17,0.007l0.339,0.019c0.005-0.007,0.006-0.014,0.009-0.02l0.177-0.569 c0.093-0.26,0.18-0.519,0.281-0.787c0.202-0.538,0.421-1.083,0.645-1.629c0.455-1.093,0.943-2.184,1.447-3.261 c0.503-1.078,1.035-2.139,1.584-3.163c0.274-0.514,0.558-1.006,0.841-1.48c0.143-0.219,0.287-0.465,0.426-0.66l0.204-0.283 c0.031-0.041,0.072-0.109,0.096-0.127l0.074-0.076L286.01,129.195z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M286.28,128.712l4.737,4.181c-0.047,0.084-0.093,0.145-0.156,0.233l-0.241,0.405 c-0.082,0.137-0.169,0.315-0.254,0.47c-0.086,0.158-0.171,0.32-0.255,0.498c-0.17,0.345-0.339,0.692-0.502,1.059 c-0.167,0.358-0.327,0.728-0.485,1.099l-6.218-2.602c0.202-0.424,0.398-0.842,0.624-1.264l0.335-0.629l0.367-0.636 c0.122-0.21,0.248-0.421,0.393-0.641c0.143-0.22,0.275-0.429,0.43-0.653l0.512-0.697c0.036-0.051,0.105-0.132,0.163-0.201 l0.18-0.211L286.28,128.712z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M283.781,157.21c0.894,0.726,1.761,1.49,2.601,2.291c0.161,0.154,0.415,0.147,0.567-0.016 c0.134-0.145,0.143-0.364,0.032-0.519c-0.691-0.963-1.424-1.902-2.195-2.814l-0.001-0.002 c-0.262-0.31-0.721-0.346-1.025-0.079c-0.304,0.266-0.338,0.734-0.076,1.044 C283.712,157.149,283.747,157.182,283.781,157.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M283.547,156.823c0.419,2.119,0.783,4.252,1.091,6.394c0.032,0.223,0.235,0.376,0.453,0.344 c0.204-0.03,0.35-0.214,0.342-0.42c-0.094-2.177-0.246-4.358-0.455-6.534c-0.038-0.405-0.392-0.702-0.79-0.664 c-0.398,0.038-0.69,0.398-0.651,0.804C283.538,156.774,283.542,156.799,283.547,156.823z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M282.671,157.382c0.282,2.102,0.501,4.214,0.654,6.337c0.016,0.225,0.208,0.394,0.428,0.377 c0.206-0.015,0.363-0.188,0.37-0.394c0.062-2.143,0.058-4.292-0.011-6.441c-0.012-0.407-0.346-0.728-0.746-0.716 c-0.4,0.012-0.714,0.352-0.702,0.761C282.666,157.331,282.668,157.357,282.671,157.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M281.812,157.68l0.288,5.563c0.013,0.225,0.201,0.398,0.422,0.385 c0.204-0.012,0.364-0.178,0.376-0.381l0.001-0.013l0.36-5.512l0.002-0.023c0.027-0.407-0.272-0.762-0.671-0.792 c-0.399-0.03-0.747,0.276-0.775,0.685C281.811,157.619,281.811,157.652,281.812,157.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M281.105,156.889l-0.29,4.373c-0.014,0.226,0.153,0.421,0.373,0.436 c0.2,0.014,0.375-0.126,0.417-0.32l0.001-0.005l0.928-4.255l0.002-0.009c0.089-0.399-0.156-0.796-0.547-0.888 c-0.391-0.092-0.78,0.158-0.868,0.558C281.113,156.814,281.108,156.854,281.105,156.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M284.675,157.046c-0.54-0.364-0.859-0.919-1.607-0.821c-0.882,0.117-0.99,1.007-1.016,1.749 c-0.021,0.576-0.779,0.602-0.866,0.04c-0.143-0.918-0.104-1.91,0.762-2.437c0.774-0.47,1.712-0.22,2.306,0.416 c0.248,0.265,0.133,0.798-0.282,0.792c-0.393-0.006-0.701,0.053-1.045,0.25l-0.034-0.764l0.006,0.244l0.13,0.426 l-0.204,0.088l-0.059-0.339l-0.408,0.091l-0.029,0.343l0.251,0.107l0.093-0.436c0.029,0.155,0.051,0.273,0.005,0.427 c-0.055,0.184-0.221,0.311-0.416,0.267l-0.079-0.018c-0.134-0.03-0.289-0.15-0.316-0.296 c-0.103-0.547,0.386-0.991,0.926-0.764c0.494,0.208,0.489,0.932-0.028,1.099c-0.553,0.18-0.966-0.455-0.718-0.953 c0.272-0.548,1.151-0.703,1.565-0.27c0.099,0.103,0.184,0.276,0.13,0.425c-0.204,0.563-0.774,0.633-1.256,0.341 c-0.262-0.159-0.333-0.594-0.034-0.765c0.468-0.267,0.939-0.41,1.476-0.417l-0.282,0.793 c-0.359-0.373-0.99-0.631-1.427-0.198c-0.379,0.376-0.244,1.036-0.171,1.507l-0.866,0.04 c0.047-1.134,0.317-2.323,1.554-2.614c0.87-0.204,2.243,0.387,2.273,1.427C285.017,156.991,284.827,157.148,284.675,157.046 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_881_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M307.967,119.005c-0.907-1.557-1.245-3.369-1.81-5.08c-1.125-3.409-3.324-6.601-6.533-8.21 c-3.209-1.609-7.483-1.303-9.983,1.273c-0.734,0.756-1.308,1.727-1.414,2.764c0.184,0.042,0.357,0.123,0.508,0.255 l-0.524,0.215c-0.006-0.158,0-0.314,0.016-0.47c-0.647-0.148-1.431,0.216-1.917,0.736c-1.243,1.328-1.41,3.296-1.78,5.077 c-0.339,1.63-0.9,3.214-1.664,4.694c-0.193,0.374-0.51,0.783-0.872,0.92c0.925,1.899,2.539,3.442,4.397,4.466 c2.111,1.164,4.521,1.703,6.925,1.886c5.746,0.439,11.626-1.142,16.377-4.403c0.668-0.458,1.316-0.954,1.915-1.501 C310.106,121.488,308.748,120.346,307.967,119.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M288.736,110.006c-0.152-0.133-0.325-0.213-0.508-0.255c-0.016,0.155-0.022,0.312-0.016,0.47 L288.736,110.006z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1227_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1228_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M295.156,126.735h1.327c4.986,0,9.027-4.042,9.027-9.027v-1.706 c0-5.352-4.339-9.691-9.691-9.691l0,0c-5.352,0-9.691,4.339-9.691,9.691v1.706 C286.129,122.693,290.17,126.735,295.156,126.735z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1226_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 295.82,
    y1: 124.679,
    x2: 295.82,
    y2: 128.14
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M295.82,128.771c1.772,0,3.208-0.283,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.283-3.208,0.631C292.612,128.489,294.048,128.771,295.82,128.771z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 295.82,
    y1: 124.679,
    x2: 295.82,
    y2: 128.14
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M295.82,128.771c1.772,0,3.208-0.283,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.283-3.208,0.631C292.612,128.489,294.048,128.771,295.82,128.771z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1224_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M294.612,126.43h2.415c3.359,0,6.081-2.723,6.081-6.081v-5.607 c0-4.025-3.263-7.289-7.289-7.289l0,0c-4.026,0-7.289,3.263-7.289,7.289v5.607 C288.531,123.707,291.253,126.43,294.612,126.43z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_906_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1223_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M301.452,119.638c0,0.013-0.001,0.027-0.001,0.04c-0.012,0.33,0.056,0.638,0.207,0.924 c0.097,0.297,0.262,0.555,0.496,0.772c0.217,0.234,0.474,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.206 c0.62-0.028,1.264-0.231,1.696-0.702c0.437-0.476,0.685-1.041,0.702-1.696c0-0.013,0.001-0.027,0.001-0.04 c0.012-0.33-0.056-0.638-0.207-0.924c-0.097-0.297-0.262-0.555-0.496-0.772c-0.217-0.234-0.474-0.399-0.772-0.496 c-0.286-0.15-0.594-0.219-0.924-0.206c-0.62,0.028-1.264,0.231-1.696,0.702 C301.717,118.418,301.469,118.982,301.452,119.638L301.452,119.638z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_912_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M305.262,119.389c-0.113-1.077-1.919-1.428-2.236-0.308 c-0.036,0.128,0.07,0.305,0.219,0.287c0.353-0.042,0.555,0.221,0.515,0.537c-0.042,0.334-0.309,0.455-0.614,0.501 c-0.288,0.043-0.166,0.48,0.121,0.438c0.533-0.079,0.944-0.442,0.951-1.004c0.007-0.533-0.419-0.992-0.973-0.926 c0.073,0.096,0.146,0.192,0.219,0.287c0.17-0.602,1.284-0.389,1.344,0.187C304.838,119.677,305.293,119.68,305.262,119.389 L305.262,119.389z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_898_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_900_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M285.369,119.638c0,0.013,0.001,0.027,0.001,0.04c0.016,0.625,0.256,1.25,0.703,1.696 c0.217,0.234,0.474,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.206c0.62-0.028,1.264-0.231,1.696-0.702 c0.424-0.462,0.719-1.052,0.702-1.696c0-0.013-0.001-0.027-0.001-0.04c-0.016-0.625-0.256-1.25-0.702-1.696 c-0.217-0.234-0.474-0.399-0.772-0.496c-0.286-0.15-0.594-0.219-0.924-0.206c-0.62,0.028-1.264,0.231-1.696,0.702 C285.647,118.404,285.352,118.994,285.369,119.638L285.369,119.638z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_899_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M286.809,119.389c0.06-0.577,1.174-0.788,1.344-0.187c0.073-0.096,0.146-0.192,0.219-0.287 c-0.552-0.066-0.982,0.393-0.973,0.926c0.01,0.562,0.416,0.924,0.951,1.004c0.286,0.042,0.409-0.395,0.121-0.438 c-0.304-0.045-0.571-0.166-0.613-0.501c-0.04-0.317,0.165-0.579,0.514-0.537c0.149,0.018,0.255-0.159,0.219-0.287 c-0.317-1.121-2.123-0.77-2.236,0.308C286.325,119.679,286.779,119.677,286.809,119.389L286.809,119.389z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_893_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_894_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_896_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M303.415,116.624v0.021c-4.794-0.101-8.651-4.01-8.651-8.828h0.419 C299.78,108.13,303.415,111.948,303.415,116.624z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_895_",
    style: {
      fill: "#D1A043"
    },
    d: "M291.015,107.817h3.91v7.258c-3.02,0-5.607-1.844-6.701-4.468 L291.015,107.817z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_892_",
    style: {
      fill: "#D1A043"
    },
    d: "M303.415,116.624c0,0-4.205-4.168-4.325-4.416 c-0.12-0.248-4.164-4.391-4.164-4.391l-1.625,1.097l-0.548-1.461l3.136-0.724l4.498,0.724l1.863,2.653l1.537,2.715 L303.415,116.624z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_602_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_874_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_890_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M295.801,119.237c0.119,0.602-0.88,0.928-0.571,1.581c0.175,0.37,0.897,0.52,1.172,0.207 c0.169-0.192-0.112-0.476-0.283-0.283c-0.092,0.104-0.465,0.03-0.532-0.102c-0.091-0.178,0.169-0.405,0.262-0.514 c0.259-0.305,0.418-0.587,0.337-0.996C296.137,118.879,295.751,118.986,295.801,119.237L295.801,119.237z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M296.68,121.94c-0.405,0.678-1.317,0.684-1.728,0.005c-0.133-0.22-0.479-0.019-0.345,0.202 c0.564,0.933,1.858,0.932,2.418-0.005C297.158,121.92,296.812,121.719,296.68,121.94L296.68,121.94z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_887_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M300.317,122.571c1.654,0,1.656-2.57,0-2.57 C298.663,120.001,298.66,122.571,300.317,122.571L300.317,122.571z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_885_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M291.335,122.571c1.653,0,1.656-2.57,0-2.57 C289.681,120.001,289.678,122.571,291.335,122.571L291.335,122.571z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_884_",
    style: {
      fill: "#5D3338"
    },
    d: "M292.128,119.928c-0.343,0-0.621-0.375-0.621-0.838 c0-0.463,0.278-0.837,0.621-0.837c0.343,0,0.621,0.375,0.621,0.837C292.748,119.553,292.47,119.928,292.128,119.928z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_883_",
    style: {
      fill: "#5D3338"
    },
    d: "M299.504,119.928c0.343,0,0.621-0.375,0.621-0.838 c0-0.462-0.278-0.837-0.621-0.837c-0.343,0-0.621,0.375-0.621,0.837C298.884,119.553,299.162,119.928,299.504,119.928z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_880_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M301.597,118.012c-0.182-0.714-0.938-1.105-1.621-1.196 c-0.587-0.078-1.529-0.004-1.766,0.634c-0.068,0.183,0.104,0.332,0.266,0.348c0.437,0.044,0.821-0.271,1.282-0.257 c0.589,0.018,1.015,0.329,1.438,0.704C301.372,118.402,301.658,118.252,301.597,118.012L301.597,118.012z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_878_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M293.676,117.842c-0.359-0.63-0.884-1.008-1.64-0.961 c-0.601,0.037-1.371,0.388-1.258,1.085c0.014,0.086,0.11,0.143,0.191,0.145c0.416,0.012,0.649-0.258,1.037-0.36 c0.448-0.118,1.06-0.012,1.427,0.279C293.563,118.134,293.77,118.007,293.676,117.842L293.676,117.842z"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 184.4,
    cy: 253.191,
    rx: 29.866,
    ry: 7.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 184.4,
    cy: 254.943,
    rx: 42.86,
    ry: 11.297
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_905_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M177.048,175.794l0.015-0.02l0.003-0.005l0.002-0.003c0.3,0.281-0.411-0.39-0.321-0.304 l0.142,0.138l0.145,0.135l0.033,0.03h0l-0.001,0l-0.004-0.001c-0.012,0.01-0.031,0.026-0.055,0.051 c-0.051,0.056-0.117,0.132-0.189,0.23c-0.145,0.191-0.307,0.433-0.469,0.691c-0.327,0.522-0.657,1.11-0.98,1.715 c-0.647,1.215-1.274,2.502-1.892,3.805l-0.922,1.97l-0.464,1.006l-0.776,1.768c-0.516,1.167-1.028,2.327-1.558,3.413 c-0.264,0.544-0.537,1.055-0.817,1.523c-0.284,0.452-0.578,0.836-0.873,1.147c-0.296,0.305-0.584,0.548-0.865,0.744 c-0.28,0.206-0.557,0.299-0.828,0.433c-0.136,0.063-0.273,0.126-0.423,0.188c-0.075,0.031-0.156,0.062-0.249,0.091 c-0.049,0.017-0.102,0.022-0.162,0.042c-0.06-0.005-0.114-0.02-0.165-0.038c-0.375-0.144-0.626-0.306-0.911-0.471 c-0.555-0.301-1.112-0.855-1.671-1.59c-0.277-0.382-0.546-0.829-0.803-1.314c-0.254-0.498-0.501-1.012-0.737-1.553 c-0.474-1.07-0.917-2.18-1.344-3.274l-0.596-1.563l-0.374-1.049c-0.495-1.398-0.975-2.796-1.447-4.195l3.443-1.326 c0.583,1.341,1.174,2.678,1.775,4.006l0.453,0.994l0.162,0.335l0.138,0.274c0.184,0.361,0.363,0.706,0.54,1.034 c0.356,0.654,0.687,1.249,1.056,1.748c0.097,0.12,0.186,0.248,0.325,0.323c0.035,0.021,0.087,0.013,0.12-0.029 c0.033-0.037,0.062-0.079,0.087-0.123c0.051-0.087,0.095-0.179,0.136-0.27c0.162-0.367,0.29-0.732,0.41-1.082 c0.238-0.701,0.434-1.348,0.607-1.931l0.124-0.426l0.373-1.031l0.768-2.087c0.522-1.396,1.059-2.794,1.666-4.214 c0.305-0.711,0.626-1.426,1.003-2.167c0.191-0.372,0.395-0.75,0.641-1.153c0.122-0.2,0.261-0.411,0.419-0.633 c0.168-0.228,0.34-0.458,0.619-0.744L177.048,175.794z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M177.112,175.868l-4.326-5.428c-0.089,0.069-0.181,0.134-0.267,0.209 c-0.086,0.073-0.168,0.14-0.274,0.246c-0.102,0.098-0.199,0.197-0.272,0.279c-0.08,0.088-0.161,0.178-0.223,0.255 c-0.275,0.327-0.476,0.612-0.662,0.887c-0.371,0.55-0.662,1.052-0.941,1.551c-0.55,0.994-1.022,1.953-1.478,2.911l6.661,3.255 c0.4-0.921,0.79-1.836,1.164-2.668c0.185-0.41,0.371-0.812,0.525-1.12c0.076-0.158,0.144-0.283,0.165-0.346l0.007-0.024 l-0.003-0.001l-0.002-0.001c-0.008-0.007,0.019,0.018-0.032-0.028c-0.141-0.125-0.279-0.254-0.414-0.387l-0.006-0.006 c-0.399-0.376,0.537,0.505,0.441,0.415l-0.001,0.001l-0.002,0.001l-0.004,0.003l-0.008,0.006l-0.017,0.011 c-0.009,0.005-0.029,0.017-0.031,0.015v-0.011C177.111,175.883,177.112,175.876,177.112,175.868z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M161.014,180.939c0.544-1.2,1.048-2.427,1.508-3.679c0.088-0.241,0.347-0.347,0.577-0.236 c0.204,0.098,0.317,0.333,0.28,0.553c-0.234,1.362-0.517,2.717-0.845,4.064l-0.001,0.003 c-0.111,0.457-0.553,0.706-0.987,0.554c-0.435-0.152-0.696-0.65-0.584-1.108 C160.975,181.036,160.993,180.984,161.014,180.939z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M160.966,181.468c-0.61-2.51-1.262-5.016-1.964-7.51c-0.073-0.259,0.059-0.518,0.294-0.579 c0.22-0.057,0.453,0.081,0.542,0.31c0.933,2.434,1.82,4.894,2.666,7.364c0.158,0.459-0.051,0.944-0.468,1.085 c-0.417,0.14-0.885-0.121-1.044-0.583C160.982,181.527,160.973,181.497,160.966,181.468z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M159.818,181.253c-0.737-2.435-1.526-4.857-2.373-7.265c-0.09-0.255,0.024-0.527,0.254-0.605 c0.214-0.074,0.455,0.047,0.558,0.27c1.073,2.332,2.094,4.696,3.065,7.08c0.184,0.451,0.006,0.953-0.4,1.123 c-0.406,0.169-0.887-0.062-1.072-0.516C159.837,181.311,159.827,181.281,159.818,181.253z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M158.811,181.314c-0.812-2.081-1.602-4.166-2.377-6.258 c-0.094-0.254,0.014-0.529,0.242-0.613c0.211-0.078,0.45,0.035,0.559,0.254l0.007,0.014 c0.984,1.978,1.982,3.946,2.998,5.903l0.013,0.024c0.225,0.434,0.097,0.959-0.289,1.174 c-0.385,0.215-0.883,0.036-1.11-0.401C158.84,181.381,158.824,181.346,158.811,181.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M158.487,182.505c-0.814-1.559-1.613-3.122-2.403-4.691 c-0.122-0.243-0.047-0.533,0.167-0.648c0.195-0.104,0.437-0.029,0.572,0.167l0.004,0.006 c0.985,1.43,1.978,2.853,2.981,4.266l0.007,0.009c0.283,0.398,0.231,0.945-0.115,1.224 c-0.346,0.279-0.858,0.182-1.143-0.218C158.532,182.584,158.507,182.543,158.487,182.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M161.989,180.713c-0.365,0.643-0.415,1.396-1.211,1.628c-0.941,0.275-1.483-0.655-1.87-1.459 c-0.3-0.624-1.073-0.311-0.889,0.347c0.302,1.076,0.828,2.152,1.954,2.333c1.005,0.161,1.82-0.545,2.105-1.509 c0.119-0.402-0.255-0.932-0.668-0.737c-0.391,0.185-0.728,0.26-1.169,0.201l0.339,0.853l-0.114-0.27l-0.076-0.526 l-0.247-0.004l0.106,0.399l-0.453,0.085l-0.196-0.364l0.2-0.232l0.304,0.436c-0.046-0.184-0.081-0.323-0.202-0.471 c-0.145-0.177-0.372-0.241-0.546-0.105l-0.07,0.055c-0.119,0.093-0.217,0.296-0.174,0.469 c0.163,0.649,0.87,0.914,1.301,0.417c0.392-0.453,0.038-1.243-0.562-1.194c-0.642,0.053-0.747,0.938-0.256,1.373 c0.541,0.478,1.496,0.245,1.7-0.417c0.049-0.158,0.05-0.386-0.076-0.524c-0.477-0.524-1.083-0.343-1.424,0.196 c-0.186,0.294-0.045,0.804,0.339,0.855c0.599,0.08,1.14,0.021,1.682-0.217l-0.669-0.738 c-0.178,0.571-0.684,1.143-1.332,0.866c-0.564-0.241-0.749-1.028-0.905-1.578l-0.889,0.347 c0.596,1.228,1.454,2.414,2.833,2.165c0.97-0.176,2.053-1.449,1.58-2.596C162.358,180.618,162.092,180.532,161.989,180.713z "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_904_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M195.769,170.69c0.862,0.671,1.484,1.373,2.02,2.062c0.536,0.691,0.97,1.376,1.356,2.056 c0.776,1.361,1.37,2.706,1.895,4.052c0.523,1.345,0.965,2.689,1.359,4.04c0.391,1.355,0.733,2.704,1.019,4.12l0.142,0.724 c0.057,0.277,0.093,0.554,0.135,0.83l0.04,0.413c0.007,0.137,0.004,0.273,0.006,0.409l-0.013,0.203l-0.003,0.051 l-0.002,0.025l-0.001,0.013c-0.076-0.005-0.022,0.006-0.039,0.008l-0.014,0.102c-0.016,0.136-0.044,0.27-0.071,0.402 c-0.13,0.527-0.402,1.021-0.676,1.501c-0.141,0.231-0.288,0.494-0.424,0.696l-0.304,0.452 c-0.809,1.168-1.624,2.243-2.449,3.315c-1.648,2.137-3.326,4.214-5.015,6.282l-2.961-2.201 c1.475-2.197,2.938-4.405,4.34-6.625c0.698-1.108,1.389-2.226,2.005-3.323l0.222-0.406c0.05-0.094,0.072-0.152,0.108-0.23 c0.064-0.145,0.125-0.289,0.165-0.438c0.051-0.15-0.024-0.31-0.061-0.457l-0.071-0.219l-0.036-0.107 c-0.011-0.029-0.037-0.119-0.058-0.19c-0.727-2.381-1.673-4.797-2.773-7.006c-0.552-1.104-1.155-2.166-1.809-3.093 c-0.325-0.465-0.665-0.895-1.005-1.251c-0.337-0.358-0.68-0.649-0.951-0.806L195.769,170.69z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M195.333,170.272l-3.71,5.878c0.278,0.206,0.712,0.634,1.113,1.193 c0.407,0.56,0.802,1.223,1.17,1.928c2.191-1.142,4.392-2.266,6.602-3.373c-0.542-0.969-1.169-1.933-1.963-2.886 C197.752,172.068,196.77,171.093,195.333,170.272z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M193.885,198.917c-1.254,0.109-2.506,0.265-3.754,0.47c-0.24,0.04-0.467-0.123-0.508-0.363 c-0.036-0.212,0.088-0.414,0.283-0.486c1.21-0.441,2.442-0.837,3.695-1.19l0.003-0.001c0.425-0.119,0.867,0.127,0.986,0.553 c0.119,0.426-0.132,0.869-0.557,0.989C193.984,198.904,193.932,198.913,193.885,198.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M194.331,198.712c-1.656,1.657-3.276,3.353-4.854,5.089c-0.164,0.18-0.442,0.193-0.622,0.03 c-0.168-0.153-0.189-0.408-0.057-0.587c1.404-1.897,2.858-3.764,4.352-5.597c0.278-0.341,0.779-0.394,1.121-0.117 c0.342,0.277,0.394,0.78,0.114,1.123C194.369,198.672,194.35,198.693,194.331,198.712z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M194.796,199.75c-1.523,1.726-3,3.495-4.428,5.309c-0.151,0.192-0.429,0.226-0.619,0.075 c-0.178-0.141-0.216-0.394-0.098-0.582c1.243-1.964,2.545-3.896,3.9-5.792c0.256-0.359,0.754-0.445,1.113-0.19 c0.359,0.254,0.442,0.754,0.184,1.115C194.832,199.707,194.814,199.73,194.796,199.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M195.403,200.544c-1.199,1.623-2.409,3.236-3.629,4.842 c-0.148,0.195-0.425,0.234-0.618,0.087c-0.179-0.137-0.223-0.384-0.111-0.575l0.007-0.012 c1.013-1.724,2.015-3.453,3.004-5.188l0.012-0.022c0.219-0.385,0.707-0.521,1.091-0.305 c0.384,0.216,0.517,0.706,0.297,1.092C195.44,200.491,195.421,200.52,195.403,200.544z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M196.526,200.262c-0.786,1.383-1.58,2.758-2.38,4.131c-0.124,0.213-0.395,0.286-0.605,0.164 c-0.191-0.111-0.266-0.344-0.186-0.545l0.002-0.006c0.583-1.468,1.158-2.938,1.723-4.41l0.004-0.01 c0.159-0.415,0.622-0.624,1.035-0.47c0.413,0.155,0.62,0.618,0.459,1.035C196.564,200.188,196.545,200.228,196.526,200.262z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M193.166,198.223c0.712,0.002,1.338-0.305,1.963,0.24c0.739,0.644,0.301,1.514-0.122,2.202 c-0.329,0.533,0.348,1.021,0.768,0.566c0.685-0.743,1.247-1.667,0.77-2.671c-0.427-0.897-1.437-1.24-2.362-1.029 c-0.385,0.088-0.6,0.639-0.216,0.887c0.363,0.234,0.609,0.475,0.806,0.864l0.49-0.67l-0.152,0.218l-0.375,0.305l0.134,0.204 l0.258-0.271l0.318,0.331l-0.18,0.328l-0.295-0.057l0.178-0.45c-0.12,0.122-0.211,0.215-0.262,0.382 c-0.061,0.2,0.015,0.415,0.219,0.495l0.083,0.032c0.14,0.054,0.355,0.041,0.468-0.074c0.424-0.432,0.244-1.132-0.388-1.256 c-0.577-0.113-1.008,0.542-0.637,1.01c0.398,0.501,1.158,0.179,1.231-0.423c0.08-0.662-0.633-1.337-1.271-1.199 c-0.152,0.033-0.334,0.137-0.374,0.304c-0.152,0.632,0.328,1.044,0.944,1.075c0.336,0.017,0.663-0.333,0.491-0.671 c-0.268-0.527-0.614-0.943-1.102-1.277l-0.216,0.888c0.553-0.117,1.285,0.033,1.425,0.691 c0.121,0.572-0.401,1.086-0.751,1.467l0.768,0.566c0.643-1.054,1.109-2.299,0.151-3.313 c-0.675-0.713-2.286-1.015-2.937-0.097C192.886,197.965,192.965,198.223,193.166,198.223z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M175.407,169.456c-2.929,0.596-4.247,1.854-3.62,5.661l2.991,21.129h9.535h9.535l2.991-21.129 c0.627-3.807-0.691-5.064-3.62-5.661l-8.906-1.469L175.407,169.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M172.757,206.889h11.557h11.557c0-3.471-1.037-7.528-2.04-10.644h-9.517h-9.517 C173.793,199.361,172.757,203.418,172.757,206.889z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_903_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M190.994,198.117c0.142,2.497,1.994,4.62,4.468,5.05c0.321,0.056,0.458-0.435,0.135-0.491 c-2.242-0.39-3.964-2.276-4.094-4.559C191.484,197.791,190.975,197.789,190.994,198.117L190.994,198.117z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_902_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M184.042,196.283c0.034,2.353,0.068,4.706,0.103,7.058c0.145-0.06,0.29-0.12,0.435-0.18 c-0.347-0.285-0.956-0.615-1.212-0.995c-0.447-0.662-0.332-1.63-0.331-2.385c0.002-1.135,0.039-2.267,0.099-3.4 c0.017-0.328-0.492-0.327-0.509,0c-0.087,1.643-0.186,3.326-0.081,4.97c0.072,1.133,0.81,1.461,1.674,2.17 c0.162,0.133,0.438,0.057,0.435-0.18c-0.034-2.353-0.068-4.705-0.102-7.058C184.547,195.956,184.038,195.955,184.042,196.283 L184.042,196.283z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M177.04,198.117c-0.13,2.283-1.852,4.169-4.094,4.559c-0.322,0.056-0.186,0.547,0.135,0.491 c2.474-0.43,4.325-2.554,4.468-5.05C177.568,197.79,177.059,197.791,177.04,198.117L177.04,198.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 3.8513,
      strokeMiterlimit: 10
    },
    points: "191.284,242.853  191.202,247.558 191.156,250.164  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M187.949,248.138l-0.023-0.594l-0.919-21.652l-0.115-2.709l-0.057-1.355 c-0.013-0.027-0.026-0.07-0.046-0.107c-0.002-0.007-0.004-0.004-0.007-0.02l-0.014-0.083l-0.028-0.167l-0.056-0.333 l-0.899-5.329l-1.798-10.658l11.679-1.254l0.507,10.796l0.253,5.398l0.016,0.337l0.008,0.169l0.004,0.084l0.011,0.148 c0.01,0.205,0.042,0.409,0.034,0.614l-0.032,0.625l-0.105,1.342l-0.209,2.684l-1.675,21.496l-0.044,0.591L187.949,248.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M193.259,249.231c-1.361,0.041-2.723,0.049-4.084,0.027c-0.562,1.007-0.934,2.117-1.096,3.254 c-0.041,0.289,0.177,0.546,0.467,0.546l5.118-0.001c0.292,0,0.526-0.259,0.484-0.547 C193.983,251.386,193.684,250.284,193.259,249.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M189.331,250.714l0.165-1.098c0.053-0.354,0.12-0.736,0.377-0.988 c0.184-0.18,0.44-0.265,0.691-0.318c0.466-0.099,0.972-0.102,1.391,0.117c0.441,0.231,0.73,0.684,0.873,1.161 c0.143,0.477,0.158,0.984,0.171,1.483"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 3.8513,
      strokeMiterlimit: 10
    },
    points: "178.347,242.959  178.485,247.886 178.535,250.272  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M176.434,249.509c0,0-0.964,0.45-2.226,1.04c-1.255,0.6-2.798,1.351-3.949,1.962 c-0.233,0.125-0.494,0.401-0.312,0.588c0.084,0.086,0.221,0.092,0.344,0.092h7.95c0.042-0.696,0.403-1.366,0.952-1.784 l0.553,1.368c0.107,0.271,0.164,0.416,0.164,0.416h1.587c0,0,0.113-0.892-0.002-1.69c-0.084-0.537-0.569-1.925-0.748-2.028 c-0.115-0.067-0.255-0.055-0.386-0.041C179.2,249.558,176.434,249.509,176.434,249.509"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M175.251,248.325l-0.029-0.361c-0.615-7.185-1.328-14.383-2.049-21.572l-0.274-2.696 l-0.138-1.347l-0.04-0.439c-0.018-0.166-0.027-0.332-0.016-0.498l0.01-0.454l0.003-0.339l0.039-5.427l0.078-10.854 l11.72,0.79l-1.379,10.766l-0.69,5.383l-0.043,0.336l-0.011,0.084c-0.003,0.023-0.004,0.013-0.006,0.021 c-0.003,0.008-0.009,0.015-0.012,0.023c-0.009,0.016-0.015,0.031-0.02,0.048l-0.01,0.024l-0.002,0.005l-0.001,0.039 l-0.001,0.085l-0.025,1.361l-0.052,2.72c-0.147,7.255-0.302,14.493-0.555,21.785l-0.012,0.367L175.251,248.325z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M171.891,174.078c-0.398,3.752,0.617,7.627,1.214,11.315c0.047,0.288,0.484,0.166,0.438-0.121 c-0.592-3.656-1.592-7.481-1.197-11.195C172.376,173.788,171.922,173.79,171.891,174.078L171.891,174.078z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M196.182,175.207c-0.189,3.758-0.558,7.498-1.114,11.22c-0.043,0.286,0.395,0.409,0.438,0.121 c0.561-3.762,0.939-7.542,1.13-11.341C196.65,174.915,196.197,174.916,196.182,175.207L196.182,175.207z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_873_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 184.309,
    y1: 166.044,
    x2: 184.309,
    y2: 169.506
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M184.309,170.137c1.772,0,3.208-0.282,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C181.101,169.855,182.537,170.137,184.309,170.137z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#94533B",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 184.309,
    y1: 166.044,
    x2: 184.309,
    y2: 169.506
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M184.309,170.137c1.772,0,3.208-0.282,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C181.101,169.855,182.537,170.137,184.309,170.137z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M181.184,167.796h6.25c2.3,0,4.164-1.864,4.164-4.164v-8.106 c0-3.704-3.003-6.707-6.707-6.707h-1.164c-3.704,0-6.707,3.003-6.707,6.707v8.106 C177.02,165.932,178.885,167.796,181.184,167.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_867_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_869_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M189.952,161.003c0,0.013-0.001,0.027-0.001,0.04c-0.012,0.33,0.056,0.638,0.207,0.924 c0.097,0.297,0.262,0.555,0.496,0.772c0.217,0.234,0.475,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.206 c0.62-0.028,1.264-0.231,1.696-0.702c0.437-0.476,0.685-1.041,0.702-1.696c0-0.013,0.001-0.027,0.001-0.04 c0.012-0.33-0.056-0.638-0.206-0.924c-0.097-0.297-0.262-0.555-0.496-0.772c-0.217-0.234-0.475-0.399-0.772-0.496 c-0.286-0.15-0.594-0.219-0.924-0.206c-0.62,0.028-1.263,0.232-1.696,0.702 C190.217,159.784,189.969,160.348,189.952,161.003L189.952,161.003z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_868_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M193.763,160.755c-0.113-1.077-1.919-1.428-2.236-0.308 c-0.036,0.128,0.07,0.305,0.219,0.287c0.353-0.042,0.554,0.221,0.514,0.537c-0.042,0.334-0.309,0.455-0.613,0.501 c-0.288,0.043-0.166,0.48,0.121,0.438c0.533-0.079,0.945-0.442,0.951-1.004c0.007-0.533-0.419-0.992-0.973-0.926 c0.073,0.096,0.146,0.192,0.219,0.287c0.17-0.602,1.284-0.389,1.344,0.187 C193.339,161.042,193.793,161.045,193.763,160.755L193.763,160.755z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M173.87,161.003c0,0.013,0.001,0.027,0.001,0.04c0.016,0.625,0.256,1.25,0.702,1.696 c0.217,0.234,0.475,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.206c0.62-0.028,1.263-0.231,1.696-0.702 c0.424-0.462,0.719-1.052,0.702-1.696c0-0.013-0.001-0.027-0.001-0.04c-0.016-0.625-0.256-1.25-0.702-1.696 c-0.217-0.234-0.475-0.399-0.772-0.496c-0.286-0.15-0.594-0.219-0.924-0.206c-0.62,0.028-1.264,0.232-1.696,0.702 C174.148,159.77,173.853,160.36,173.87,161.003L173.87,161.003z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_864_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M175.31,160.755c0.061-0.577,1.174-0.788,1.344-0.187c0.073-0.096,0.146-0.192,0.219-0.287 c-0.552-0.066-0.982,0.393-0.973,0.926c0.01,0.562,0.416,0.924,0.951,1.004c0.286,0.042,0.409-0.395,0.121-0.438 c-0.304-0.045-0.571-0.166-0.614-0.501c-0.04-0.317,0.165-0.579,0.515-0.537c0.149,0.018,0.255-0.159,0.219-0.287 c-0.317-1.121-2.123-0.77-2.236,0.308C174.825,161.045,175.279,161.043,175.31,160.755L175.31,160.755z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_598_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_841_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M184.294,160.603c0.119,0.602-0.88,0.928-0.571,1.581c0.175,0.37,0.897,0.52,1.172,0.207 c0.17-0.192-0.112-0.476-0.283-0.283c-0.092,0.104-0.465,0.03-0.532-0.102c-0.091-0.178,0.169-0.405,0.262-0.514 c0.259-0.305,0.418-0.587,0.337-0.996C184.63,160.245,184.244,160.351,184.294,160.603L184.294,160.603z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M185.173,163.305c-0.406,0.678-1.317,0.684-1.728,0.005 c-0.133-0.22-0.479-0.019-0.345,0.202c0.564,0.933,1.858,0.932,2.418-0.005 C185.65,163.286,185.305,163.085,185.173,163.305L185.173,163.305z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_838_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M188.81,163.936c1.654,0,1.656-2.57,0-2.57 C187.156,161.367,187.154,163.936,188.81,163.936L188.81,163.936z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_764_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M179.828,163.936c1.653,0,1.656-2.57,0-2.57 C178.174,161.367,178.172,163.936,179.828,163.936L179.828,163.936z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_763_",
    style: {
      fill: "#5D3338"
    },
    d: "M180.62,161.294c-0.343,0-0.621-0.375-0.621-0.837 c0-0.463,0.278-0.837,0.621-0.837c0.343,0,0.621,0.375,0.621,0.837C181.241,160.919,180.963,161.294,180.62,161.294z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_762_",
    style: {
      fill: "#5D3338"
    },
    d: "M187.998,161.294c0.343,0,0.621-0.375,0.621-0.838 c0-0.462-0.278-0.837-0.621-0.837c-0.343,0-0.621,0.375-0.621,0.837C187.377,160.919,187.655,161.294,187.998,161.294z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_758_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M190.09,159.378c-0.182-0.714-0.938-1.105-1.62-1.196 c-0.587-0.078-1.529-0.004-1.766,0.634c-0.068,0.183,0.104,0.332,0.266,0.348c0.437,0.044,0.821-0.271,1.282-0.257 c0.589,0.018,1.015,0.329,1.438,0.704C189.865,159.767,190.152,159.618,190.09,159.378L190.09,159.378z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_600_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M182.169,159.208c-0.359-0.63-0.884-1.008-1.64-0.961c-0.6,0.037-1.371,0.388-1.258,1.085 c0.014,0.086,0.111,0.143,0.191,0.145c0.416,0.012,0.649-0.258,1.037-0.36c0.448-0.118,1.06-0.012,1.427,0.279 C182.056,159.5,182.263,159.372,182.169,159.208L182.169,159.208z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M191.352,158.763c-0.898-1.593-1.419-2.757-1.509-4.584c0.168,1.143-0.544,2.355-1.624,2.765 c-0.257,0.098-0.533,0.154-0.806,0.128c-0.569-0.053-1.057-0.455-1.359-0.94c-0.302-0.485-0.447-1.048-0.589-1.601 c0.316,0.643,0.068,1.494-0.518,1.906c-0.586,0.413-1.435,0.376-2.014-0.048c-0.579-0.423-0.87-1.187-0.772-1.897 c-0.085,0.895-0.765,1.703-1.632,1.94c-0.262,0.072-0.547,0.094-0.803,0.003c-0.71-0.251-0.87-1.166-0.914-1.918 c-0.566,0.492-0.813,1.249-1.007,1.973c-0.311,1.159-0.553,1.696-0.724,2.884l-0.19-0.047 c0.024-1.365-0.074-2.762-0.604-4.019c-0.365-0.865-0.926-1.64-1.272-2.513c-0.346-0.873-0.447-1.931,0.087-2.703 c0.233-0.337,0.592-0.602,0.999-0.648c0.407-0.046,0.85,0.165,1.008,0.542c-0.224-1.153,0.544-2.282,1.468-3.006 c0.39-0.306,0.858-0.58,1.351-0.528c0.729,0.077,1.186,0.803,1.531,1.45c0.386-0.628,0.857-1.225,1.486-1.611 c0.629-0.385,1.439-0.531,2.115-0.236c0.676,0.294,1.141,1.09,0.93,1.797c0.592-0.972,1.859-1.541,2.933-1.163 c1.073,0.378,1.7,1.788,1.122,2.768c0.753-0.688,2.048-0.563,2.764,0.162c0.717,0.726,0.863,1.901,0.491,2.851 c-0.192,0.488-0.501,0.92-0.763,1.375c-0.883,1.528-1.24,3.354-0.999,5.102"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M191.445,158.708c-0.739-1.498-1.246-2.837-1.417-4.529c-0.024-0.235-0.363-0.244-0.372,0 c-1.335,0.1-2.671,0.201-4.006,0.301c-0.068-0.24-0.419-0.139-0.371,0.102c-0.965-0.03-1.931-0.059-2.896-0.089 c-0.029-0.239-0.356-0.314-0.437-0.059c-0.969,0.028-1.938,0.056-2.907,0.085c-0.028-0.225-0.285-0.307-0.423-0.115 c-0.721,1.007-0.744,1.974-1.32,3.025c-0.465,0.849,0.158,1.485-0.285-0.151c-0.191-0.706-0.246-1.319-0.517-2.027 c-0.128-0.306-0.273-0.604-0.437-0.894c-1.003-1.32-0.708-2.723,0.888-4.207c0.14,0.147,0.393,0.033,0.395-0.163 c1.309-0.657,2.617-1.314,3.926-1.97c0.093,0.156,0.29,0.133,0.387,0c1.365-0.055,2.731-0.109,4.096-0.164 c-0.001,0.199,0.271,0.332,0.411,0.17c1.216,0.456,2.432,0.913,3.648,1.369c-0.054,0.207,0.173,0.382,0.359,0.276 c0.858,1.128,1.715,2.256,2.573,3.383c-0.136,0.225-0.272,0.45-0.408,0.674c-0.092,0.474-0.498,1.026-0.659,1.507 c-0.418,1.25-0.462,2.4-0.393,3.714c0.017,0.33,0.541,0.327,0.513,0c-0.24-2.764,1.006-4.042,1.732-6.414 c0.313-1.024,0.294-2.213-0.515-3.031c-0.791-0.801-1.976-0.461-2.5-0.905c-0.674-0.571-0.297-1.66-1.462-2.123 c-0.948-0.376-0.952-0.005-1.868,0.067c-0.147,0.012-0.672,0.588-0.878,0.546c-0.167-0.034,0.008-0.322-0.277-0.39 c-0.426-0.102-0.807-0.842-1.504-0.943c-1.347-0.195-1.554,0.893-2.572,1.093c-1.939,0.381,0.499,0.001-1.32-0.339 c-0.978-0.183-1.218-0.346-2.168,0.28c-0.873,0.575-0.941,1.742-1.575,2.285c-0.386,0.33-1.362,0.067-1.98,0.909 c-0.524,0.714-0.422,1.627-0.229,2.415c0.603,2.468,1.981,4.158,1.993,6.932c0.001,0.094,0.068,0.187,0.161,0.211 c0.063,0.016,0.126,0.032,0.19,0.048c0.109,0.028,0.247-0.035,0.27-0.153c0.112-0.567,0.734-4.123,1.392-4.139 c0.116-0.003,0.156,0.798,0.339,0.86c1.236,0.417,1.02,0.372,2.408,0.063c2.789-0.622-1.618-0.726,1.314,0.283 c0.842,0.29,1.437,0.738,2.324,0.096c-0.026,0.019,0.676-1.002,0.624-0.983c1.146-0.408-0.82-0.417-0.169-0.181 c0.768,0.277,0.633,1.709,1.915,1.828c1.525,0.142,1.54-1.364,2.399-1.773c0.661-0.315-0.528-0.725,0.038,0.226 c0.549,0.922,0.814,2.137,1.383,3.105C191.33,158.938,191.506,158.832,191.445,158.708L191.445,158.708z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 119.411,
    cy: 194.899,
    rx: 29.866,
    ry: 7.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 119.411,
    cy: 196.65,
    rx: 42.86,
    ry: 11.297
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M124.808,115.384c0.675,0.963,1.31,2.176,1.898,3.436c0.59,1.266,1.141,2.601,1.687,3.965 l0.823,2.073l0.105,0.263l0.164,0.433l0.346,0.897c0.233,0.593,0.472,1.176,0.728,1.731c0.507,1.114,1.109,2.071,1.787,2.671 c0.338,0.311,0.682,0.553,1.081,0.743c0.2,0.09,0.424,0.179,0.685,0.203l0.097,0.004c0.029,0.017,0.061,0.005,0.088,0.005 c0.056-0.005,0.107-0.013,0.156-0.022c0.1-0.018,0.194-0.043,0.29-0.069l0.603-0.255c0.204-0.096,0.413-0.16,0.627-0.305 c0.426-0.258,0.867-0.643,1.291-1.087c0.85-0.897,1.66-1.893,2.446-2.85l0.276-0.341l0.182-0.234l0.363-0.468l0.72-0.937 l1.425-1.878l-2.575-2.149l-1.588,1.708l-0.798,0.848l-0.4,0.422l-0.2,0.21l-0.073,0.073l-0.06,0.058 c-0.638,0.609-1.203,1.155-1.766,1.565c-0.071,0.037-0.137,0.112-0.23,0.084c-0.09-0.032-0.16-0.112-0.217-0.193 c-0.113-0.167-0.191-0.354-0.26-0.536c-0.137-0.367-0.233-0.727-0.32-1.066l-0.118-0.496l-0.053-0.237 c-0.011-0.046-0.011-0.061-0.031-0.132l-0.076-0.266l-0.614-2.152c-0.417-1.447-0.854-2.911-1.369-4.389 c-0.521-1.479-1.096-2.971-1.939-4.506L124.808,115.384z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M124.61,115.234l5.318-3.412c1.042,1.582,1.76,3.13,2.425,4.665l-6.186,2.674 C125.63,117.755,125.12,116.372,124.61,115.234z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M139.457,123.273c-0.199-1.096-0.359-2.2-0.475-3.308c-0.022-0.213-0.214-0.379-0.429-0.371 c-0.19,0.007-0.334,0.149-0.349,0.329c-0.094,1.118-0.145,2.247-0.154,3.385v0.002c-0.003,0.386,0.311,0.722,0.702,0.748 c0.392,0.026,0.713-0.268,0.716-0.656C139.469,123.36,139.464,123.314,139.457,123.273z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M139.386,123.693c1.031-1.719,2.103-3.414,3.221-5.08c0.116-0.173,0.063-0.414-0.119-0.539 c-0.17-0.117-0.394-0.089-0.516,0.056c-1.297,1.544-2.555,3.128-3.773,4.739c-0.227,0.299-0.155,0.74,0.162,0.984 c0.316,0.244,0.759,0.199,0.987-0.102C139.361,123.733,139.374,123.713,139.386,123.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M140.383,123.907c1.121-1.618,2.29-3.203,3.51-4.753c0.129-0.164,0.094-0.408-0.08-0.545 c-0.162-0.128-0.388-0.115-0.521,0.02c-1.392,1.418-2.741,2.882-4.047,4.385c-0.247,0.284-0.204,0.727,0.097,0.99 c0.301,0.263,0.748,0.245,0.997-0.041C140.354,123.945,140.369,123.926,140.383,123.907z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M141.204,124.286c1.109-1.322,2.207-2.649,3.298-3.984c0.133-0.162,0.101-0.407-0.07-0.547 c-0.159-0.129-0.381-0.123-0.518,0.007l-0.009,0.008c-1.24,1.178-2.486,2.348-3.739,3.508l-0.016,0.015 c-0.278,0.257-0.281,0.701-0.007,0.992c0.275,0.291,0.724,0.318,1.004,0.059 C141.166,124.327,141.187,124.305,141.204,124.286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M141.223,125.302l2.981-2.785c0.153-0.144,0.152-0.39-0.001-0.549 c-0.139-0.144-0.357-0.167-0.51-0.062l-0.004,0.003l-3.372,2.27l-0.007,0.005c-0.318,0.211-0.389,0.646-0.161,0.974 c0.229,0.327,0.673,0.422,0.992,0.209C141.17,125.348,141.199,125.325,141.223,125.302z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M138.696,122.779c0.168,0.612,0.052,1.204,0.663,1.644c0.723,0.52,1.365-0.012,1.855-0.499 c0.38-0.378,0.955,0.116,0.664,0.558c-0.476,0.722-1.136,1.372-2.107,1.14c-0.866-0.207-1.395-1.015-1.43-1.847 c-0.014-0.347,0.407-0.63,0.708-0.344c0.285,0.27,0.549,0.439,0.927,0.538l-0.459,0.541l0.151-0.17l0.174-0.377l0.206,0.078 l-0.171,0.27l0.357,0.214l0.238-0.214l-0.117-0.243l-0.344,0.233c0.077-0.125,0.135-0.22,0.266-0.294 c0.157-0.088,0.359-0.062,0.475,0.1l0.047,0.065c0.079,0.111,0.118,0.298,0.046,0.415c-0.27,0.442-0.912,0.412-1.165-0.109 c-0.231-0.475,0.229-0.963,0.716-0.727c0.521,0.252,0.423,0.963-0.075,1.134c-0.548,0.188-1.291-0.305-1.322-0.878 c-0.007-0.137,0.04-0.312,0.173-0.376c0.505-0.243,0.969,0.094,1.139,0.619c0.093,0.286-0.131,0.629-0.46,0.542 c-0.513-0.136-0.949-0.359-1.349-0.719l0.709-0.345c0.028,0.496,0.328,1.099,0.923,1.101 c0.518,0.002,0.836-0.539,1.08-0.908l0.664,0.558c-0.752,0.741-1.709,1.366-2.8,0.723c-0.767-0.454-1.4-1.784-0.768-2.506 C138.409,122.585,138.649,122.607,138.696,122.779z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M110.426,112.209c-0.271,0.349-0.425,0.618-0.614,0.912c-0.189,0.294-0.322,0.554-0.485,0.833 c-0.298,0.543-0.573,1.074-0.827,1.602c-0.513,1.057-0.984,2.103-1.424,3.162c-0.44,1.059-0.858,2.123-1.249,3.22 l-0.287,0.834l-0.275,0.868l-0.131,0.463l-0.065,0.231l-0.064,0.264c-0.038,0.178-0.09,0.356-0.128,0.589 c-0.036,0.234-0.066,0.468-0.091,0.702c-0.017,1.073,0.104,1.772,0.237,2.497c0.074,0.344,0.141,0.698,0.223,1.031 l0.255,0.983c0.363,1.284,0.756,2.527,1.192,3.74c0.858,2.435,1.818,4.794,2.862,7.136l3.121-1.229 c-0.782-2.335-1.49-4.708-2.077-7.084c-0.303-1.187-0.553-2.375-0.766-3.545l-0.139-0.87 c-0.041-0.287-0.064-0.563-0.099-0.843c-0.057-0.536-0.057-1.104-0.021-1.378c0.014-0.058,0.037-0.115,0.048-0.172 l0.086-0.247c0.028-0.089,0.07-0.198,0.116-0.311l0.13-0.332l0.296-0.693l0.322-0.705c0.443-0.944,0.923-1.89,1.421-2.822 c0.497-0.933,1.023-1.85,1.561-2.731c0.269-0.443,0.546-0.868,0.821-1.274c0.138-0.189,0.278-0.408,0.412-0.573 c0.132-0.165,0.276-0.365,0.378-0.457L110.426,112.209z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M110.656,111.785l4.737,4.181c-0.065,0.097-0.13,0.182-0.204,0.281l-0.257,0.396 c-0.087,0.136-0.178,0.299-0.267,0.446c-0.09,0.147-0.179,0.305-0.268,0.47c-0.359,0.636-0.703,1.329-1.042,2.016 l-6.084-2.901c0.426-0.798,0.871-1.578,1.396-2.367c0.25-0.388,0.546-0.794,0.842-1.192l0.504-0.628 C110.21,112.259,110.44,112.012,110.656,111.785z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M111.175,138.435c1.057,0.39,2.107,0.802,3.134,1.234c0.198,0.083,0.436-0.008,0.531-0.199 c0.085-0.171,0.031-0.365-0.119-0.466c-0.935-0.619-1.897-1.235-2.885-1.832l-0.002-0.001c-0.335-0.203-0.784-0.102-1,0.231 c-0.216,0.333-0.12,0.774,0.222,0.976C111.092,138.4,111.135,138.42,111.175,138.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M110.839,138.154c1.003,1.802,1.995,3.629,3.02,5.354c0.11,0.173,0.35,0.217,0.537,0.101 c0.176-0.108,0.246-0.314,0.168-0.473c-0.815-1.793-1.616-3.711-2.422-5.606c-0.147-0.354-0.567-0.519-0.937-0.368 c-0.37,0.152-0.549,0.567-0.399,0.928C110.816,138.111,110.828,138.134,110.839,138.154z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M110.168,138.93c0.438,0.923,0.877,1.846,1.316,2.77c0.44,0.924,0.877,1.848,1.36,2.761 c0.103,0.194,0.342,0.263,0.534,0.154c0.18-0.101,0.258-0.317,0.188-0.495c-0.37-0.925-0.707-1.889-1.045-2.849 c-0.338-0.963-0.677-1.927-1.016-2.892c-0.131-0.364-0.539-0.556-0.916-0.427c-0.379,0.13-0.583,0.537-0.45,0.908 C110.148,138.884,110.158,138.908,110.168,138.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M109.437,139.467c0.636,1.692,1.299,3.361,2.091,5.042c0.099,0.206,0.349,0.295,0.544,0.195 c0.183-0.093,0.261-0.308,0.194-0.496l-0.004-0.012c-0.57-1.708-1.018-3.416-1.437-5.133l-0.005-0.021 c-0.091-0.381-0.481-0.613-0.871-0.522c-0.39,0.092-0.631,0.479-0.537,0.866 C109.418,139.411,109.428,139.441,109.437,139.467z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M108.529,138.948c0.331,1.388,0.684,2.774,1.09,4.171c0.065,0.217,0.291,0.343,0.503,0.28 c0.192-0.057,0.308-0.248,0.28-0.442l-0.001-0.006c-0.189-1.422-0.332-2.823-0.441-4.223l-0.001-0.009 c-0.035-0.392-0.374-0.688-0.775-0.657c-0.399,0.03-0.7,0.376-0.671,0.777C108.515,138.875,108.521,138.914,108.529,138.948 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M111.979,138.015c-0.622-0.163-1.075-0.578-1.764-0.266 c-0.814,0.368-0.659,1.224-0.464,1.918c0.149,0.539-0.562,0.801-0.812,0.305c-0.412-0.809-0.658-1.751,0.023-2.491 c0.607-0.659,1.579-0.695,2.322-0.293c0.31,0.168,0.346,0.686-0.05,0.806c-0.377,0.113-0.653,0.258-0.924,0.543 l-0.248-0.692l0.074,0.223l0.245,0.352l-0.169,0.142l-0.154-0.294l-0.363,0.206l0.073,0.325l0.271,0.022l-0.04-0.428 c0.073,0.133,0.129,0.235,0.13,0.39c0.002,0.186-0.119,0.353-0.318,0.372l-0.08,0.008c-0.136,0.013-0.32-0.051-0.389-0.177 c-0.262-0.475,0.087-1.033,0.665-0.982c0.526,0.046,0.733,0.705,0.29,1.018c-0.472,0.335-1.057-0.125-0.961-0.661 c0.105-0.589,0.903-0.987,1.419-0.714c0.123,0.065,0.252,0.198,0.242,0.35c-0.032,0.573-0.554,0.813-1.099,0.69 c-0.299-0.066-0.488-0.449-0.25-0.695c0.372-0.385,0.783-0.653,1.295-0.818l-0.05,0.808 c-0.445-0.233-1.121-0.287-1.416,0.243c-0.26,0.462,0.07,1.031,0.275,1.443l-0.812,0.305 c-0.298-1.069-0.369-2.261,0.731-2.884c0.777-0.437,2.254-0.297,2.568,0.63 C112.289,137.861,112.153,138.061,111.979,138.015z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M112.398,110.827c-2.151,0.442-3.432,2.587-3.021,4.652c0,0,0.809,3.946,1.137,5.248 c0.493,1.956,2.234,7.754,2.234,7.754h7.436h7.436c0,0,1.741-5.798,2.234-7.754c0.328-1.302,1.137-5.248,1.137-5.248 c0.412-2.065-0.869-4.211-3.02-4.652c-1.925-0.395-7.787-1.132-7.787-1.132S114.323,110.432,112.398,110.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M111.218,130.249c-1.243,2.19-3.56,5.646-3.56,11.805h12.527h12.527 c0-6.159-2.317-9.615-3.56-11.805c-0.504-0.889-1.531-1.768-1.531-1.768h-7.436h-7.436 C112.749,128.481,111.722,129.36,111.218,130.249z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_877_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M120.733,128.665c-0.034,2.611-0.067,5.222-0.1,7.832c0.141-0.038,0.282-0.076,0.423-0.114 c-0.223-0.348-0.489-0.64-0.723-0.973c-0.53-0.75-0.688-1.351-0.693-2.268c-0.009-1.558,0.097-3.107,0.279-4.654 c0.034-0.29-0.42-0.287-0.454,0c-0.213,1.81-0.443,3.762-0.263,5.587c0.117,1.182,0.832,1.555,1.462,2.537 c0.12,0.187,0.42,0.116,0.423-0.115c0.034-2.611,0.067-5.222,0.1-7.832C121.191,128.372,120.737,128.372,120.733,128.665 L120.733,128.665z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_876_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M124.278,128.607c0.563,3.218,3.178,6.094,6.674,5.102c0.281-0.08,0.161-0.518-0.121-0.438 c-3.27,0.928-5.599-1.831-6.116-4.785C124.665,128.199,124.228,128.32,124.278,128.607L124.278,128.607z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_875_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M115.705,128.486c-0.516,2.954-2.843,5.714-6.115,4.785c-0.282-0.08-0.402,0.358-0.121,0.438 c3.494,0.992,6.111-1.884,6.674-5.102C116.192,128.321,115.755,128.198,115.705,128.486L115.705,128.486z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 4.218,
      strokeMiterlimit: 10
    },
    points: "112.912,192.102  112.942,188.881 112.954,185.993  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M116.347,189.222l0.018-0.32c0.519-8.175,0.954-16.324,1.381-24.483l0.157-3.06l0.039-0.719 c0.003-0.053,0.009-0.08,0.013-0.122l0.014-0.184l0.029-0.373l0.12-1.5c0.166-2.004,0.346-4.008,0.545-6 c0.2-1.991,0.415-3.977,0.668-5.922c0.127-0.971,0.26-1.935,0.409-2.871c0.068-0.479,0.157-0.916,0.233-1.375 c0.078-0.458,0.174-0.854,0.258-1.283l-12.352-1.935c-0.049,0.582-0.113,1.189-0.146,1.748 c-0.03,0.554-0.073,1.126-0.09,1.664c-0.047,1.091-0.071,2.159-0.089,3.22c-0.032,2.119-0.02,4.202,0.009,6.281 c0.029,2.078,0.079,4.146,0.143,6.214l0.053,1.554l0.029,0.846l0.048,0.813l0.191,3.05 c0.501,8.134,0.993,16.278,1.402,24.394l0.015,0.387L116.347,189.222z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M110.722,190.68c1.49,0.062,2.981,0.09,4.472,0.084c0.583,1.116,0.959,2.34,1.085,3.614 c0.033,0.323-0.216,0.603-0.534,0.594l-5.603-0.145c-0.32-0.008-0.566-0.294-0.508-0.602 C109.864,193.022,110.224,191.821,110.722,190.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M114.977,192.361l-0.145-1.21c-0.047-0.39-0.111-0.809-0.385-1.089 c-0.197-0.2-0.475-0.296-0.748-0.358c-0.508-0.114-1.062-0.123-1.526,0.111c-0.49,0.248-0.818,0.739-0.988,1.259 c-0.172,0.519-0.205,1.07-0.236,1.615"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 4.218,
      strokeMiterlimit: 10
    },
    d: "M124.432,192.049 c0.03-1.089,0.089-2.163,0.134-3.244l0.155-2.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M127.956,189.287l0.03-0.314c0.896-8.074,1.98-16.16,3.087-24.229l0.21-1.512l0.106-0.755 c0.034-0.247,0.074-0.512,0.107-0.814c0.126-1.047,0.239-2.075,0.346-3.111c0.212-2.068,0.393-4.139,0.539-6.224 c0.143-2.086,0.248-4.184,0.293-6.314c0.039-2.134,0.037-4.282-0.145-6.56l-12.394,1.634c0.328,1.6,0.559,3.448,0.739,5.318 c0.179,1.878,0.307,3.811,0.398,5.761c0.088,1.952,0.143,3.923,0.167,5.894c0.011,0.982,0.017,1.976,0.012,2.933 c0.004,0.181,0,0.379-0.008,0.656l-0.02,0.771l-0.038,1.539c-0.188,8.209-0.35,16.386-0.328,24.673l0,0.398L127.956,189.287z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M126.722,190.784c0,0,1.045,0.522,2.414,1.206c1.349,0.689,3.017,1.539,4.296,2.192 c0.254,0.134,0.538,0.424,0.337,0.62c-0.092,0.09-0.243,0.097-0.378,0.097h-8.707c-0.039-0.785-0.434-1.555-1.024-2.032 c-0.216,0.505-0.414,1.033-0.621,1.556c-0.119,0.311-0.183,0.477-0.183,0.477h-1.738c0,0-0.029-0.259-0.042-0.634 c-0.011-0.373-0.011-0.873,0.061-1.325c0.102-0.612,0.658-2.187,0.862-2.292c0.127-0.073,0.281-0.057,0.424-0.038 C123.692,190.777,126.722,190.784,126.722,190.784"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M109.74,115.334c-0.185,1.848-0.003,3.642,0.546,5.415c0.086,0.278,0.524,0.16,0.438-0.121 c-0.536-1.733-0.71-3.491-0.53-5.294C110.223,115.044,109.769,115.046,109.74,115.334L109.74,115.334z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M130.014,114.52c0.578,2.225,0.051,4.501-0.621,6.654c-0.087,0.28,0.351,0.399,0.438,0.121 c0.697-2.235,1.22-4.59,0.621-6.895C130.378,114.116,129.941,114.236,130.014,114.52L130.014,114.52z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M112.907,92.693c-1.656,2.224-2.654,4.973-2.952,7.73c-0.318,2.939-0.071,6.465,0.053,9.419 c3.343,0.693,6.806,0.781,10.229,0.703c3.679-0.085,7.442-0.379,10.854-1.7c-0.164-4.996,0-9.622-2.502-14.603 L112.907,92.693z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1220_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1221_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M119.532,109.808h1.327c4.985,0,9.027-4.041,9.027-9.027v-1.706 c0-5.352-4.339-9.691-9.691-9.691l0,0c-5.352,0-9.691,4.339-9.691,9.691v1.706 C110.505,105.767,114.547,109.808,119.532,109.808z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_751_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 120.196,
    y1: 107.752,
    x2: 120.196,
    y2: 111.214
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M120.196,111.844c1.772,0,3.208-0.282,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C116.988,111.562,118.424,111.844,120.196,111.844z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 6.3947,
      strokeMiterlimit: 10
    },
    x1: 120.196,
    y1: 107.752,
    x2: 120.196,
    y2: 111.214
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M120.196,111.844c1.772,0,3.208-0.282,3.208-0.631c0-0.348-1.436-0.631-3.208-0.631 c-1.772,0-3.208,0.282-3.208,0.631C116.988,111.562,118.424,111.844,120.196,111.844z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_97_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M118.988,109.503h2.415c3.359,0,6.081-2.723,6.081-6.081v-5.607 c0-4.026-3.263-7.289-7.289-7.289l0,0c-4.026,0-7.289,3.263-7.289,7.289v5.607 C112.907,106.781,115.63,109.503,118.988,109.503z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M125.828,102.711c0,0.013-0.001,0.027-0.001,0.04c-0.012,0.33,0.056,0.638,0.207,0.924 c0.097,0.297,0.262,0.555,0.496,0.772c0.217,0.234,0.474,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.207 c0.62-0.028,1.264-0.231,1.696-0.702c0.437-0.476,0.685-1.041,0.702-1.696c0-0.013,0.001-0.027,0.001-0.04 c0.012-0.33-0.056-0.638-0.206-0.924c-0.097-0.297-0.262-0.555-0.496-0.772c-0.217-0.234-0.475-0.399-0.772-0.496 c-0.286-0.15-0.594-0.219-0.924-0.207c-0.62,0.028-1.264,0.231-1.696,0.702 C126.093,101.491,125.845,102.055,125.828,102.711L125.828,102.711z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M129.639,102.462c-0.113-1.078-1.919-1.428-2.236-0.308 c-0.036,0.128,0.07,0.305,0.219,0.287c0.353-0.042,0.554,0.221,0.514,0.537c-0.042,0.334-0.309,0.455-0.613,0.501 c-0.288,0.043-0.166,0.48,0.121,0.438c0.533-0.079,0.944-0.442,0.951-1.004c0.007-0.533-0.419-0.992-0.973-0.926 c0.073,0.096,0.146,0.191,0.219,0.287c0.17-0.602,1.284-0.389,1.344,0.187C129.215,102.75,129.669,102.753,129.639,102.462 L129.639,102.462z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_76_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M109.746,102.711c0,0.013,0.001,0.027,0.001,0.04c0.016,0.625,0.256,1.25,0.702,1.696 c0.217,0.234,0.475,0.399,0.772,0.496c0.286,0.15,0.594,0.219,0.924,0.207c0.62-0.028,1.264-0.231,1.696-0.702 c0.424-0.462,0.719-1.052,0.702-1.696c0-0.013-0.001-0.027-0.001-0.04c-0.016-0.625-0.256-1.25-0.702-1.696 c-0.217-0.234-0.475-0.399-0.772-0.496c-0.286-0.15-0.594-0.219-0.924-0.207c-0.62,0.028-1.263,0.231-1.696,0.702 C110.024,101.477,109.729,102.067,109.746,102.711L109.746,102.711z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M111.186,102.462c0.061-0.577,1.174-0.789,1.344-0.187c0.073-0.096,0.146-0.192,0.219-0.287 c-0.552-0.066-0.982,0.393-0.973,0.926c0.01,0.562,0.416,0.924,0.951,1.004c0.286,0.042,0.409-0.395,0.121-0.438 c-0.304-0.045-0.571-0.166-0.614-0.501c-0.04-0.317,0.165-0.579,0.514-0.537c0.149,0.018,0.255-0.159,0.219-0.287 c-0.317-1.121-2.123-0.77-2.236,0.308C110.701,102.752,111.155,102.75,111.186,102.462L111.186,102.462z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M120.177,102.31c0.119,0.602-0.88,0.928-0.571,1.581c0.175,0.37,0.897,0.52,1.172,0.207 c0.169-0.192-0.112-0.476-0.283-0.283c-0.092,0.104-0.465,0.03-0.532-0.102c-0.091-0.178,0.169-0.405,0.262-0.514 c0.259-0.306,0.418-0.587,0.337-0.996C120.513,101.952,120.128,102.059,120.177,102.31L120.177,102.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M121.057,105.013c-0.406,0.678-1.317,0.684-1.728,0.005 c-0.133-0.22-0.479-0.019-0.345,0.202c0.564,0.933,1.858,0.932,2.418-0.005 C121.534,104.993,121.188,104.792,121.057,105.013L121.057,105.013z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_72_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M124.693,105.644c1.654,0,1.656-2.57,0-2.57 C123.04,103.074,123.037,105.644,124.693,105.644L124.693,105.644z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M115.711,105.644c1.653,0,1.656-2.57,0-2.57 C114.058,103.074,114.055,105.644,115.711,105.644L115.711,105.644z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    style: {
      fill: "#5D3338"
    },
    d: "M116.504,103.001c-0.343,0-0.621-0.375-0.621-0.838 c0-0.462,0.278-0.837,0.621-0.837c0.343,0,0.621,0.375,0.621,0.838C117.125,102.626,116.847,103.001,116.504,103.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    style: {
      fill: "#5D3338"
    },
    d: "M123.881,103.002c0.343,0,0.621-0.375,0.621-0.837 c0-0.463-0.278-0.838-0.621-0.838c-0.343,0-0.621,0.375-0.621,0.837S123.538,103.002,123.881,103.002z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M125.974,101.085c-0.182-0.714-0.938-1.105-1.621-1.196 c-0.587-0.078-1.529-0.004-1.766,0.634c-0.068,0.183,0.104,0.332,0.265,0.348c0.437,0.044,0.821-0.271,1.282-0.257 c0.589,0.018,1.015,0.329,1.438,0.704C125.749,101.475,126.035,101.326,125.974,101.085L125.974,101.085z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M118.052,100.916c-0.359-0.63-0.884-1.008-1.64-0.961 c-0.601,0.037-1.371,0.388-1.258,1.085c0.014,0.086,0.111,0.143,0.191,0.145c0.416,0.012,0.649-0.257,1.037-0.36 c0.448-0.118,1.06-0.011,1.427,0.279C117.939,101.207,118.146,101.08,118.052,100.916L118.052,100.916z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M126.463,93.195c-0.176-0.34-0.356-0.683-0.615-0.964c-0.24-0.26-0.54-0.457-0.842-0.643 c-0.638-0.394-1.298-0.751-1.976-1.071c-0.666-0.314-1.365-0.594-2.099-0.643c-0.467-0.031-0.934,0.033-1.396,0.099 c-0.768,0.109-1.54,0.224-2.274,0.472c-1.774,0.601-3.237,1.979-4.098,3.643c-0.748,1.445-1.094,3.706-1.062,5.498 c2.825-0.08,5.649-0.161,8.474-0.241c0.217-0.006,0.45-0.018,0.622-0.149c0.142-0.108,0.218-0.279,0.292-0.442 c0.294-0.647,0.641-1.27,1.036-1.86c0.14,0.761,0.253,1.528,0.339,2.297c1.776-0.106,3.553-0.213,5.33-0.319 C128.298,96.9,127.384,94.971,126.463,93.195z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 242.035,
    cy: 304.074,
    rx: 37.042,
    ry: 9.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 242.035,
    cy: 306.247,
    rx: 53.158,
    ry: 14.012
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M235.341,205.454c-0.837,1.194-1.625,2.699-2.354,4.261c-0.732,1.57-1.415,3.226-2.092,4.917 l-1.02,2.571l-0.13,0.326l-0.203,0.537l-0.429,1.113c-0.289,0.735-0.586,1.459-0.903,2.146 c-0.629,1.382-1.376,2.568-2.216,3.313c-0.419,0.385-0.846,0.685-1.341,0.922c-0.247,0.112-0.527,0.222-0.85,0.252 l-0.12,0.005c-0.036,0.021-0.076,0.006-0.109,0.007c-0.069-0.006-0.132-0.016-0.194-0.027 c-0.124-0.022-0.241-0.054-0.359-0.086l-0.748-0.316c-0.253-0.118-0.512-0.198-0.778-0.378 c-0.529-0.32-1.076-0.797-1.602-1.348c-1.054-1.113-2.059-2.347-3.033-3.535l-0.342-0.423l-0.226-0.29l-0.45-0.58 l-0.893-1.162l-1.768-2.329l3.194-2.666l1.97,2.118l0.99,1.051l0.496,0.523l0.248,0.261l0.09,0.09l0.074,0.072 c0.791,0.755,1.492,1.432,2.19,1.942c0.088,0.046,0.169,0.139,0.286,0.105c0.112-0.04,0.199-0.139,0.269-0.24 c0.14-0.207,0.237-0.439,0.323-0.664c0.169-0.455,0.289-0.901,0.396-1.322l0.147-0.615l0.065-0.294 c0.014-0.057,0.014-0.076,0.038-0.163l0.095-0.33l0.761-2.669c0.518-1.794,1.059-3.61,1.698-5.443 c0.646-1.835,1.359-3.685,2.404-5.589L235.341,205.454z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M235.587,205.268l-6.596-4.232c-1.293,1.962-2.184,3.882-3.008,5.786l7.672,3.317 C234.322,208.394,234.954,206.68,235.587,205.268z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M217.172,215.238c0.247-1.36,0.445-2.729,0.589-4.104c0.027-0.265,0.266-0.47,0.532-0.46 c0.236,0.009,0.414,0.185,0.433,0.409c0.117,1.386,0.18,2.787,0.191,4.199v0.003c0.004,0.479-0.385,0.896-0.871,0.928 c-0.486,0.033-0.884-0.332-0.888-0.813C217.158,215.347,217.163,215.289,217.172,215.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M217.261,215.76c-1.279-2.132-2.608-4.234-3.996-6.3c-0.144-0.215-0.078-0.514,0.148-0.669 c0.211-0.145,0.488-0.11,0.64,0.07c1.609,1.915,3.169,3.879,4.68,5.877c0.281,0.371,0.192,0.917-0.2,1.221 c-0.392,0.303-0.941,0.247-1.224-0.127C217.292,215.808,217.275,215.784,217.261,215.76z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M216.024,216.024c-1.391-2.007-2.84-3.973-4.354-5.895c-0.16-0.203-0.116-0.507,0.099-0.676 c0.201-0.158,0.481-0.143,0.647,0.025c1.726,1.759,3.4,3.575,5.019,5.439c0.307,0.353,0.253,0.902-0.12,1.228 c-0.374,0.326-0.928,0.304-1.236-0.051C216.059,216.072,216.041,216.048,216.024,216.024z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M215.006,216.494c-1.376-1.639-2.737-3.286-4.09-4.941c-0.164-0.201-0.126-0.505,0.087-0.678 c0.197-0.16,0.473-0.153,0.643,0.009l0.011,0.01c1.538,1.461,3.083,2.912,4.638,4.351l0.019,0.018 c0.345,0.319,0.349,0.869,0.008,1.23c-0.341,0.361-0.898,0.394-1.245,0.073 C215.052,216.546,215.027,216.519,215.006,216.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M214.981,217.755l-3.697-3.455c-0.19-0.179-0.189-0.484,0.002-0.681 c0.173-0.178,0.442-0.207,0.632-0.077l0.005,0.004l4.182,2.816l0.009,0.006c0.394,0.262,0.483,0.802,0.199,1.208 c-0.284,0.406-0.835,0.523-1.231,0.26C215.048,217.812,215.012,217.783,214.981,217.755z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M218.116,214.626c-0.208,0.758-0.064,1.493-0.823,2.039 c-0.896,0.645-1.693-0.016-2.301-0.619c-0.471-0.469-1.184,0.144-0.823,0.692c0.59,0.895,1.409,1.701,2.613,1.414 c1.074-0.256,1.73-1.259,1.773-2.291c0.018-0.43-0.504-0.781-0.878-0.427c-0.354,0.335-0.681,0.544-1.15,0.668l0.569,0.671 l-0.187-0.21l-0.215-0.467l-0.255,0.097l0.213,0.335l-0.443,0.266l-0.296-0.265l0.145-0.301l0.426,0.289 c-0.095-0.155-0.167-0.273-0.33-0.364c-0.195-0.109-0.445-0.076-0.589,0.124l-0.058,0.081 c-0.098,0.137-0.146,0.369-0.057,0.515c0.335,0.548,1.131,0.511,1.445-0.135c0.286-0.59-0.284-1.195-0.888-0.902 c-0.647,0.312-0.525,1.195,0.092,1.406c0.679,0.232,1.601-0.378,1.639-1.089c0.009-0.17-0.049-0.387-0.214-0.466 c-0.627-0.302-1.202,0.117-1.413,0.768c-0.115,0.354,0.162,0.78,0.57,0.672c0.636-0.169,1.177-0.446,1.673-0.892 l-0.879-0.427c-0.035,0.615-0.407,1.363-1.145,1.366c-0.642,0.002-1.037-0.669-1.34-1.126l-0.823,0.692 c0.933,0.919,2.12,1.694,3.473,0.896c0.951-0.563,1.737-2.213,0.952-3.109C218.471,214.385,218.175,214.412,218.116,214.626 z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M253.179,201.515c0.336,0.433,0.527,0.766,0.762,1.132c0.234,0.365,0.4,0.687,0.601,1.033 c0.369,0.673,0.71,1.332,1.026,1.987c0.636,1.311,1.221,2.609,1.766,3.922c0.546,1.314,1.064,2.633,1.549,3.994l0.356,1.034 l0.341,1.076l0.163,0.574l0.081,0.287l0.079,0.327c0.047,0.22,0.112,0.441,0.158,0.73c0.044,0.29,0.082,0.581,0.112,0.87 c0.021,1.331-0.128,2.198-0.294,3.097c-0.092,0.427-0.175,0.866-0.276,1.279l-0.317,1.219 c-0.45,1.592-0.937,3.135-1.478,4.639c-1.064,3.02-2.255,5.946-3.55,8.851l-3.871-1.524c0.97-2.896,1.848-5.839,2.576-8.786 c0.375-1.472,0.686-2.946,0.95-4.397l0.172-1.079c0.051-0.356,0.08-0.698,0.122-1.046c0.07-0.664,0.071-1.369,0.026-1.71 c-0.017-0.072-0.045-0.142-0.059-0.214l-0.107-0.306c-0.034-0.11-0.087-0.246-0.143-0.386l-0.161-0.412l-0.367-0.86 l-0.399-0.875c-0.549-1.171-1.145-2.344-1.762-3.5c-0.616-1.157-1.268-2.294-1.936-3.388 c-0.333-0.549-0.677-1.077-1.019-1.58c-0.171-0.235-0.345-0.507-0.512-0.711c-0.164-0.205-0.342-0.452-0.469-0.567 L253.179,201.515z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M252.893,200.99l-5.876,5.186c0.081,0.12,0.161,0.226,0.253,0.348l0.319,0.491 c0.108,0.168,0.22,0.37,0.331,0.553c0.111,0.182,0.222,0.379,0.332,0.583c0.445,0.789,0.872,1.648,1.292,2.501l7.546-3.598 c-0.528-0.99-1.08-1.958-1.731-2.936c-0.31-0.482-0.677-0.985-1.044-1.479l-0.625-0.779 C253.446,201.579,253.161,201.272,252.893,200.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M252.25,234.043c-1.311,0.484-2.613,0.995-3.887,1.531c-0.246,0.102-0.54-0.01-0.658-0.247 c-0.106-0.212-0.038-0.453,0.148-0.578c1.159-0.768,2.353-1.531,3.578-2.272l0.003-0.001 c0.415-0.251,0.972-0.127,1.241,0.286c0.268,0.413,0.15,0.96-0.275,1.21C252.352,234,252.299,234.025,252.25,234.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M252.666,233.695c-1.245,2.235-2.474,4.501-3.746,6.64c-0.136,0.214-0.434,0.269-0.667,0.125 c-0.218-0.134-0.305-0.389-0.209-0.586c1.011-2.223,2.004-4.603,3.004-6.954c0.183-0.439,0.703-0.644,1.162-0.456 c0.459,0.188,0.681,0.703,0.495,1.151C252.694,233.642,252.68,233.67,252.666,233.695z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M253.499,234.657c-0.544,1.144-1.087,2.289-1.632,3.436 c-0.546,1.146-1.088,2.293-1.687,3.424c-0.127,0.241-0.424,0.326-0.662,0.191c-0.223-0.126-0.32-0.393-0.234-0.614 c0.459-1.147,0.877-2.343,1.296-3.534c0.42-1.194,0.839-2.39,1.26-3.587c0.162-0.452,0.668-0.69,1.136-0.53 c0.47,0.161,0.723,0.667,0.558,1.127C253.524,234.6,253.511,234.63,253.499,234.657z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M254.405,235.323c-0.789,2.098-1.611,4.169-2.594,6.253 c-0.122,0.256-0.432,0.366-0.674,0.241c-0.227-0.115-0.324-0.382-0.241-0.615l0.005-0.015 c0.707-2.119,1.263-4.236,1.782-6.367l0.006-0.026c0.113-0.472,0.596-0.761,1.08-0.647c0.484,0.114,0.783,0.594,0.666,1.074 C254.428,235.254,254.417,235.292,254.405,235.323z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M255.531,234.68c-0.411,1.722-0.849,3.44-1.351,5.174c-0.081,0.27-0.361,0.426-0.624,0.347 c-0.238-0.071-0.382-0.307-0.348-0.548l0.001-0.007c0.234-1.764,0.412-3.501,0.547-5.237l0.001-0.012 c0.043-0.486,0.464-0.853,0.961-0.815c0.495,0.037,0.869,0.466,0.833,0.963C255.548,234.589,255.541,234.638,255.531,234.68 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M251.252,233.522c0.771-0.202,1.334-0.717,2.187-0.33c1.01,0.457,0.818,1.518,0.576,2.378 c-0.185,0.668,0.697,0.994,1.007,0.378c0.512-1.004,0.816-2.172-0.029-3.09c-0.753-0.817-1.958-0.862-2.88-0.364 c-0.385,0.208-0.429,0.851,0.063,0.999c0.467,0.14,0.81,0.321,1.146,0.673l0.308-0.858l-0.091,0.277l-0.304,0.436 l0.209,0.176l0.191-0.364l0.451,0.256l-0.091,0.403l-0.336,0.028l0.049-0.531c-0.091,0.166-0.16,0.291-0.161,0.484 c-0.002,0.23,0.148,0.437,0.394,0.461l0.099,0.009c0.169,0.016,0.396-0.063,0.482-0.219 c0.325-0.589-0.107-1.281-0.825-1.218c-0.653,0.057-0.91,0.875-0.36,1.263c0.586,0.416,1.312-0.155,1.192-0.82 c-0.131-0.731-1.12-1.224-1.76-0.885c-0.153,0.081-0.313,0.245-0.3,0.434c0.04,0.711,0.687,1.008,1.363,0.856 c0.371-0.082,0.605-0.556,0.31-0.862c-0.461-0.477-0.971-0.81-1.606-1.014l0.062,1.002c0.553-0.289,1.391-0.355,1.757,0.302 c0.322,0.573-0.087,1.279-0.341,1.79l1.007,0.378c0.37-1.326,0.458-2.804-0.906-3.577c-0.964-0.542-2.796-0.368-3.185,0.781 C250.867,233.332,251.036,233.58,251.252,233.522z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#638A89"
    },
    d: "M250.733,199.802c2.668,0.548,4.257,3.209,3.746,5.77c0,0-1.004,4.894-1.411,6.509 c-0.612,2.426-2.771,9.617-2.771,9.617h-9.223h-9.223c0,0-2.16-7.191-2.771-9.617c-0.407-1.615-1.411-6.509-1.411-6.509 c-0.511-2.561,1.078-5.222,3.746-5.77c2.388-0.49,9.659-1.404,9.659-1.404S248.345,199.312,250.733,199.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M252.196,223.89c1.541,2.716,4.415,7.003,4.415,14.642h-15.537h-15.537 c0-7.639,2.874-11.926,4.415-14.642c0.625-1.102,1.899-2.193,1.899-2.193h9.223h9.223 C250.297,221.698,251.571,222.788,252.196,223.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_107_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M240.395,221.925c0.042,3.238,0.083,6.476,0.125,9.714c-0.175-0.047-0.35-0.095-0.525-0.142 c0.277-0.431,0.606-0.794,0.897-1.206c0.657-0.931,0.853-1.675,0.86-2.813c0.011-1.933-0.12-3.853-0.346-5.772 c-0.042-0.359,0.521-0.356,0.563,0c0.264,2.245,0.55,4.666,0.326,6.929c-0.145,1.466-1.032,1.928-1.813,3.146 c-0.149,0.232-0.521,0.144-0.525-0.142c-0.042-3.238-0.083-6.476-0.124-9.714C239.827,221.563,240.39,221.563,240.395,221.925 L240.395,221.925z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_106_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M235.999,221.853c-0.698,3.991-3.942,7.559-8.277,6.328c-0.348-0.099-0.2-0.642,0.15-0.543 c4.056,1.151,6.944-2.271,7.585-5.935C235.518,221.347,236.061,221.498,235.999,221.853L235.999,221.853z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M246.632,221.704c0.641,3.664,3.526,7.087,7.585,5.935c0.349-0.099,0.498,0.444,0.15,0.543 c-4.334,1.23-7.58-2.337-8.278-6.328C246.027,221.499,246.569,221.347,246.632,221.704L246.632,221.704z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 5.2315,
      strokeMiterlimit: 10
    },
    points: "250.096,300.605  250.059,296.611 250.043,293.028  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M245.835,297.033l-0.023-0.396c-0.644-10.139-1.183-20.247-1.713-30.366l-0.195-3.795 l-0.048-0.891c-0.004-0.066-0.011-0.1-0.016-0.151l-0.018-0.229l-0.036-0.462l-0.149-1.861 c-0.205-2.485-0.43-4.971-0.676-7.442c-0.248-2.47-0.515-4.932-0.829-7.345c-0.158-1.204-0.323-2.4-0.507-3.561 c-0.085-0.595-0.195-1.136-0.289-1.706c-0.097-0.567-0.216-1.059-0.32-1.591l15.32-2.4c0.061,0.722,0.14,1.474,0.181,2.168 c0.037,0.687,0.091,1.397,0.111,2.064c0.058,1.354,0.089,2.678,0.111,3.994c0.04,2.628,0.024,5.212-0.011,7.79 c-0.036,2.577-0.098,5.142-0.178,7.708l-0.065,1.928l-0.036,1.049l-0.06,1.009l-0.237,3.782 c-0.621,10.088-1.232,20.189-1.738,30.256l-0.019,0.48L245.835,297.033z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M252.812,298.841c-1.848,0.077-3.697,0.111-5.546,0.104c-0.723,1.384-1.19,2.902-1.346,4.483 c-0.041,0.4,0.268,0.748,0.663,0.737l6.949-0.179c0.396-0.01,0.702-0.365,0.63-0.747 C253.875,301.746,253.429,300.257,252.812,298.841z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M247.534,300.927l0.18-1.501c0.059-0.484,0.137-1.004,0.478-1.35 c0.244-0.248,0.589-0.368,0.928-0.444c0.63-0.141,1.317-0.153,1.893,0.138c0.607,0.307,1.014,0.917,1.226,1.561 c0.214,0.643,0.254,1.328,0.293,2.003"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 5.2315,
      strokeMiterlimit: 10
    },
    d: "M235.807,300.54 c-0.037-1.35-0.11-2.683-0.166-4.024l-0.193-3.596"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183E43"
    },
    d: "M231.437,297.114l-0.037-0.39c-1.111-10.013-2.455-20.042-3.829-30.051l-0.261-1.876 l-0.131-0.937c-0.042-0.306-0.092-0.635-0.133-1.009c-0.156-1.298-0.296-2.574-0.429-3.858 c-0.263-2.565-0.488-5.134-0.668-7.72c-0.177-2.587-0.308-5.189-0.363-7.831c-0.049-2.647-0.046-5.311,0.18-8.137 l15.372,2.027c-0.406,1.985-0.693,4.277-0.917,6.595c-0.222,2.329-0.38,4.727-0.493,7.146 c-0.109,2.421-0.177,4.865-0.208,7.31c-0.014,1.218-0.02,2.451-0.015,3.637c-0.005,0.224,0.001,0.471,0.01,0.814l0.025,0.956 l0.047,1.909c0.233,10.181,0.434,20.323,0.407,30.601l0,0.493L231.437,297.114z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M232.967,298.971c0,0-1.297,0.648-2.994,1.496c-1.674,0.854-3.741,1.909-5.329,2.719 c-0.315,0.166-0.667,0.525-0.418,0.769c0.114,0.112,0.302,0.12,0.468,0.12h10.799c0.048-0.974,0.539-1.928,1.27-2.52 c0.268,0.627,0.513,1.282,0.771,1.93c0.148,0.385,0.228,0.591,0.228,0.591h2.155c0,0,0.036-0.321,0.052-0.787 c0.014-0.462,0.014-1.083-0.076-1.643c-0.127-0.759-0.816-2.713-1.069-2.843c-0.158-0.09-0.348-0.07-0.525-0.047 C236.725,298.962,232.967,298.971,232.967,298.971"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M254.029,205.392c0.23,2.292,0.003,4.517-0.677,6.716c-0.107,0.345-0.65,0.198-0.543-0.15 c0.665-2.149,0.881-4.33,0.657-6.566C253.43,205.032,253.993,205.034,254.029,205.392L254.029,205.392z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M228.884,204.382c-0.717,2.759-0.063,5.583,0.77,8.253c0.108,0.347-0.435,0.495-0.543,0.15 c-0.865-2.772-1.513-5.693-0.77-8.552C228.432,203.882,228.975,204.03,228.884,204.382L228.884,204.382z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M248.782,192.751c2.493-2.431,3.783-5.64,4.675-8.828c0.462-1.651,0.831-3.401,0.303-5.037 c-0.596-1.847-2.285-3.299-4.215-4.172c-1.929-0.873-4.095-1.238-6.237-1.52c-1.744-0.23-3.593-0.4-5.216,0.212 c-1.623,0.612-2.874,2.279-2.261,3.745l0.051-0.786c-1.023-1.082-3.091-0.932-4.284,0.004 c-1.193,0.936-1.67,2.398-1.854,3.801c-0.583,4.439,1.202,8.85,3.359,12.89"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M248.867,192.836c4.75-3.939,8.407-13.836,1.951-17.789 c-3.167-1.94-16.08-5.098-15.317,2.104c0.044,0.42,0.625,0.428,0.66,0c0.021-0.262,0.043-0.524,0.065-0.786 c0.01-0.123-0.074-0.234-0.17-0.297c-2.621-1.72-5.339-0.327-6.372,2.551c-1.746,4.862,0.89,10.43,3.258,14.535 c0.122,0.211,0.418,0.026,0.321-0.188c-1.311-2.882-3.841-7.775-3.232-11.133c0.424-2.339,9.044-8.315,11.955-8.5 c1.594-0.102,3.701,0.435,5.218,0.891c9.974,3.002,5.719,12.335,1.474,18.465 C248.594,192.81,248.769,192.918,248.867,192.836L248.867,192.836z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 241.061,
    y1: 195.988,
    x2: 241.061,
    y2: 200.281
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M241.061,201.064c-2.198,0-3.979-0.35-3.979-0.783c0-0.432,1.781-0.782,3.979-0.782 c2.198,0,3.979,0.35,3.979,0.782C245.04,200.713,243.259,201.064,241.061,201.064z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFAE80",
      strokeWidth: 7.9312,
      strokeMiterlimit: 10
    },
    x1: 241.061,
    y1: 195.988,
    x2: 241.061,
    y2: 200.281
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M241.061,201.064c-2.198,0-3.979-0.35-3.979-0.783c0-0.432,1.781-0.782,3.979-0.782 c2.198,0,3.979,0.35,3.979,0.782C245.04,200.713,243.259,201.064,241.061,201.064z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M242.559,198.16h-2.996c-4.166,0-7.542-3.377-7.542-7.542v-6.954 c0-4.993,4.047-9.04,9.04-9.04h0c4.993,0,9.04,4.047,9.04,9.04v6.954C250.101,194.783,246.724,198.16,242.559,198.16z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M234.076,189.736c0,0.016,0.001,0.033,0.001,0.049c0.016,0.41-0.07,0.792-0.256,1.146 c-0.12,0.369-0.325,0.688-0.615,0.957c-0.269,0.29-0.589,0.495-0.957,0.615c-0.354,0.186-0.736,0.272-1.146,0.256 c-0.769-0.035-1.567-0.287-2.103-0.871c-0.542-0.591-0.85-1.291-0.871-2.103c0-0.017-0.001-0.033-0.001-0.049 c-0.016-0.41,0.07-0.792,0.256-1.146c0.12-0.369,0.325-0.688,0.615-0.957c0.269-0.29,0.589-0.495,0.957-0.615 c0.354-0.186,0.736-0.272,1.146-0.256c0.769,0.035,1.567,0.287,2.103,0.871 C233.747,188.223,234.055,188.923,234.076,189.736L234.076,189.736z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M229.35,189.427c0.14-1.337,2.38-1.771,2.773-0.382c0.045,0.159-0.087,0.378-0.271,0.356 c-0.438-0.052-0.688,0.274-0.638,0.667c0.052,0.415,0.383,0.565,0.761,0.621c0.357,0.053,0.205,0.596-0.15,0.543 c-0.661-0.098-1.171-0.548-1.18-1.245c-0.008-0.661,0.519-1.23,1.207-1.148c-0.09,0.119-0.181,0.238-0.271,0.356 c-0.211-0.747-1.592-0.482-1.667,0.232C229.875,189.784,229.312,189.788,229.35,189.427L229.35,189.427z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAE80"
    },
    d: "M254.023,189.736c-0.001,0.016-0.001,0.033-0.001,0.049c-0.02,0.775-0.318,1.55-0.871,2.103 c-0.27,0.29-0.589,0.495-0.957,0.615c-0.354,0.186-0.736,0.272-1.146,0.256c-0.769-0.035-1.567-0.287-2.103-0.871 c-0.526-0.573-0.892-1.305-0.871-2.103c0-0.017,0.001-0.033,0.001-0.049c0.02-0.775,0.318-1.55,0.871-2.103 c0.269-0.29,0.589-0.495,0.957-0.615c0.355-0.186,0.737-0.272,1.146-0.256c0.769,0.035,1.567,0.287,2.103,0.871 C253.678,188.205,254.043,188.937,254.023,189.736L254.023,189.736z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M252.236,189.427c-0.075-0.716-1.456-0.978-1.667-0.232 c-0.09-0.119-0.181-0.238-0.271-0.356c0.684-0.081,1.218,0.487,1.207,1.148c-0.012,0.697-0.516,1.146-1.18,1.245 c-0.355,0.053-0.508-0.49-0.15-0.543c0.377-0.056,0.708-0.205,0.761-0.621c0.05-0.394-0.205-0.718-0.638-0.667 c-0.185,0.022-0.316-0.197-0.271-0.356c0.393-1.39,2.633-0.955,2.773,0.382 C252.837,189.787,252.274,189.784,252.236,189.427L252.236,189.427z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M241.084,189.239c-0.148,0.747,1.091,1.151,0.708,1.961 c-0.217,0.46-1.112,0.645-1.454,0.257c-0.21-0.239,0.139-0.59,0.351-0.35c0.114,0.129,0.576,0.038,0.66-0.127 c0.113-0.221-0.21-0.502-0.325-0.637c-0.322-0.379-0.519-0.728-0.419-1.236 C240.668,188.794,241.146,188.927,241.084,189.239L241.084,189.239z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M239.994,192.591c0.503,0.841,1.634,0.848,2.143,0.006c0.165-0.273,0.594-0.024,0.428,0.25 c-0.7,1.158-2.304,1.156-2.999-0.006C239.402,192.566,239.83,192.317,239.994,192.591L239.994,192.591z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M235.483,193.374c0.834,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.594,1.594C233.928,192.643,234.59,193.374,235.483,193.374L235.483,193.374z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M246.624,193.374c0.834,0,1.632-0.733,1.594-1.594c-0.039-0.863-0.7-1.594-1.594-1.594 c-0.834,0-1.632,0.733-1.594,1.594C245.069,192.643,245.73,193.374,246.624,193.374L246.624,193.374z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    style: {
      fill: "#5D3338"
    },
    d: "M245.64,190.096c0.425,0,0.77-0.465,0.77-1.039 c0-0.574-0.345-1.039-0.77-1.039c-0.425,0-0.77,0.465-0.77,1.039C244.87,189.631,245.215,190.096,245.64,190.096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      fill: "#5D3338"
    },
    d: "M236.491,190.096c-0.425,0-0.77-0.465-0.77-1.039 c0-0.574,0.345-1.039,0.77-1.039c0.425,0,0.77,0.465,0.77,1.039C237.26,189.631,236.916,190.096,236.491,190.096z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M234.393,188.009c0.524-0.465,1.053-0.85,1.783-0.873c0.571-0.018,1.048,0.373,1.59,0.319 c0.2-0.02,0.414-0.205,0.329-0.432c-0.294-0.793-1.46-0.883-2.19-0.786c-0.847,0.112-1.784,0.597-2.01,1.483 C233.819,188.017,234.174,188.203,234.393,188.009L234.393,188.009z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M244.022,187.742c0.456-0.361,1.215-0.492,1.77-0.346 c0.478,0.126,0.772,0.461,1.286,0.446c0.098-0.003,0.219-0.073,0.236-0.18c0.14-0.864-0.816-1.299-1.561-1.346 c-0.938-0.058-1.589,0.411-2.034,1.192C243.604,187.711,243.859,187.872,244.022,187.742L244.022,187.742z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M233.288,177.933c0.218-0.421,0.441-0.847,0.763-1.195c0.298-0.323,0.67-0.567,1.044-0.797 c0.791-0.488,1.61-0.932,2.451-1.328c0.826-0.389,1.692-0.737,2.604-0.797c0.579-0.038,1.158,0.041,1.732,0.122 c0.952,0.135,1.91,0.277,2.821,0.586c2.201,0.745,4.015,2.454,5.083,4.518c0.927,1.792,1.357,4.596,1.318,6.818 c-3.503-0.1-7.007-0.199-10.51-0.299c-0.269-0.008-0.558-0.022-0.772-0.185c-0.176-0.134-0.27-0.346-0.362-0.548 c-0.365-0.802-0.795-1.575-1.285-2.307c-0.173,0.944-0.313,1.895-0.42,2.849c-2.203-0.132-4.407-0.264-6.61-0.396 C231.013,182.528,232.146,180.137,233.288,177.933z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC0A9"
    },
    cx: 312.815,
    cy: 409.388,
    rx: 48.3,
    ry: 12.065
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.18,
      fill: "#FCC0A9"
    },
    cx: 312.815,
    cy: 412.221,
    rx: 69.315,
    ry: 18.271
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M295.428,273.967c-4.737,0.964-6.869,2.999-5.854,9.155l4.837,34.17h15.421h15.421l4.837-34.17 c1.014-6.156-1.117-8.19-5.854-9.155l-14.404-2.375L295.428,273.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M291.142,334.506h18.69h18.69c0-5.613-1.676-12.175-3.299-17.214h-15.391h-15.391 C292.819,322.332,291.142,328.893,291.142,334.506z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M320.636,320.32c0.23,4.038,3.224,7.472,7.226,8.168c0.518,0.09,0.741-0.704,0.219-0.794 c-3.626-0.631-6.41-3.681-6.621-7.373C321.43,319.793,320.605,319.789,320.636,320.32L320.636,320.32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M309.394,317.354c0.055,3.805,0.11,7.61,0.166,11.415c0.234-0.097,0.469-0.194,0.703-0.291 c-0.562-0.461-1.546-0.994-1.961-1.608c-0.723-1.071-0.536-2.637-0.535-3.857c0.003-1.835,0.064-3.667,0.161-5.499 c0.028-0.53-0.796-0.528-0.824,0c-0.141,2.657-0.301,5.379-0.132,8.038c0.117,1.832,1.31,2.362,2.708,3.509 c0.262,0.215,0.709,0.092,0.703-0.291c-0.055-3.805-0.111-7.61-0.166-11.415C310.21,316.825,309.386,316.823,309.394,317.354 L309.394,317.354z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M298.07,320.32c-0.211,3.692-2.994,6.742-6.621,7.373c-0.521,0.091-0.3,0.885,0.219,0.794 c4.001-0.696,6.995-4.13,7.226-8.168C298.924,319.79,298.1,319.792,298.07,320.32L298.07,320.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 6.2284,
      strokeMiterlimit: 10
    },
    points: "320.603,392.681  320.701,400.277 320.756,404.491  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M315.47,401.262l-0.067-0.954l-2.546-34.645l-0.318-4.324 c-0.111-1.441-0.189-2.882-0.375-4.321l-0.968-8.633l-1.934-17.25l18.972-0.97l-0.155,17.538l-0.078,8.761 c0.011,1.459-0.086,2.921-0.149,4.383l-0.205,4.384L326,400.245l-0.042,0.961L315.47,401.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M324.111,402.959c-2.2,0.081-4.401,0.11-6.603,0.09c-0.859,1.629-1.407,3.416-1.613,5.246 c-0.052,0.465,0.312,0.878,0.783,0.878l8.276-0.001c0.472,0,0.838-0.422,0.756-0.889 C325.388,406.454,324.85,404.663,324.111,402.959z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M317.831,405.393l0.213-1.772c0.069-0.572,0.158-1.188,0.561-1.597 c0.289-0.293,0.699-0.434,1.102-0.523c0.749-0.166,1.567-0.179,2.255,0.17c0.724,0.368,1.214,1.099,1.469,1.872 c0.255,0.773,0.304,1.594,0.35,2.405"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 6.2284,
      strokeMiterlimit: 10
    },
    points: "300.501,392.896  300.714,400.492 300.803,404.706  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94533B"
    },
    d: "M295.493,401.57l-0.076-0.949c-0.994-11.528-2.141-23.102-3.301-34.657l-0.44-4.333 l-0.222-2.165l-0.029-0.291l-0.039-0.495c-0.038-0.331-0.006-0.661-0.006-0.993l-0.003-1.151l-0.055-8.727l-0.11-17.455 l18.969,1.023l-1.986,17.342l-0.994,8.671l-0.12,1.023c-0.012,0.031-0.028,0.062-0.034,0.094l-0.016,0.049l-0.006,0.253 l-0.04,2.187l-0.084,4.372c-0.236,11.658-0.488,23.3-0.889,34.995l-0.033,0.966L295.493,401.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M304.15,403.119c-2.198,0.117-4.4,0.182-6.601,0.198c-0.851,1.633-1.385,3.424-1.609,5.211 c-0.055,0.456,0.307,0.86,0.777,0.861l8.276-0.001c0.472,0,0.841-0.43,0.761-0.907 C305.449,406.608,304.898,404.821,304.15,403.119z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M297.882,405.645l0.207-1.767c0.066-0.57,0.147-1.187,0.547-1.603 c0.286-0.298,0.695-0.446,1.097-0.542c0.747-0.179,1.565-0.207,2.256,0.131c0.727,0.356,1.226,1.079,1.486,1.851 c0.258,0.772,0.309,1.598,0.359,2.412"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_29_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M290.53,276.457c-0.211,0.215-0.418,0.435-0.618,0.659l-0.145,0.166l-0.108,0.139l-0.214,0.28 c-0.137,0.185-0.29,0.385-0.408,0.56l-0.322,0.503c-0.227,0.347-0.393,0.654-0.565,0.965 c-0.181,0.318-0.331,0.617-0.476,0.911c-0.588,1.188-1.061,2.31-1.484,3.417c-0.857,2.215-1.537,4.373-2.175,6.542 c-0.629,2.166-1.184,4.333-1.686,6.521l-0.363,1.647l-0.436,2.101c-0.376,1.809-0.689,3.618-0.824,5.328 c-0.032,0.427-0.08,0.861-0.063,1.258l0.003,0.608c-0.004,0.206,0.001,0.405,0.033,0.585l0.07,0.559 c0.022,0.187,0.042,0.375,0.094,0.537c0.09,0.334,0.168,0.681,0.269,1l0.143,0.487l0.204,0.444 c0.062,0.15,0.151,0.29,0.235,0.432c0.077,0.142,0.176,0.284,0.285,0.424l0.078,0.106c0.06,0.005,0.066,0.068,0.101,0.098 c0.06,0.072,0.133,0.139,0.204,0.194c0.146,0.114,0.292,0.212,0.438,0.295c0.294,0.17,0.589,0.31,0.902,0.423 c1.223,0.473,2.726,0.639,4.398,0.519c1.663-0.109,3.413-0.432,5.111-0.769l1.274-0.267l0.576-0.127l0.403-0.097l1.602-0.398 c1.064-0.27,2.12-0.548,3.172-0.833c2.103-0.569,4.189-1.163,6.267-1.771l-1.41-5.798c-2.093,0.405-4.187,0.793-6.278,1.153 l-3.132,0.515l-1.561,0.235l-0.389,0.056c-0.15,0.023-0.174,0.02-0.261,0.03l-0.43,0.041 c-1.137,0.092-2.184,0.18-3.147,0.064c-0.12-0.017-0.239-0.041-0.353-0.082c-0.106-0.041-0.246-0.098-0.258-0.25 c-0.042-0.274-0.003-0.558,0.043-0.828c0.093-0.543,0.233-1.057,0.376-1.544c0.144-0.487,0.298-0.948,0.455-1.382 l0.058-0.162c0.021-0.06,0.032-0.078,0.077-0.23l0.227-0.738l0.473-1.474c0.649-1.962,1.35-3.915,2.106-5.828 c0.76-1.906,1.562-3.798,2.439-5.55c0.433-0.88,0.892-1.72,1.349-2.455c0.114-0.187,0.228-0.369,0.339-0.52 c0.112-0.162,0.223-0.33,0.322-0.442l0.149-0.19c0.046-0.054,0.08-0.075,0.117-0.115l0.053-0.055 c0.019-0.024,0.034-0.038,0.032-0.024c0.006,0.01,0.007,0.017,0.004,0.02L290.53,276.457z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M291.292,275.627l6.883,8.864c-0.022,0.023-0.08,0.066-0.071,0.073 c0.017,0.007,0.046-0.033,0.03-0.012c-0.032,0.055-0.067,0.106-0.106,0.155l-0.16,0.257l-0.086,0.135l-0.095,0.171 l-0.193,0.342c-0.131,0.266-0.266,0.507-0.398,0.791c-0.533,1.11-1.045,2.364-1.524,3.646 c-3.749-1.384-7.504-2.751-11.266-4.101c0.641-1.563,1.361-3.116,2.281-4.73c0.459-0.806,0.979-1.637,1.646-2.544l0.537-0.696 c0.224-0.265,0.452-0.525,0.684-0.78c0.097-0.114,0.283-0.293,0.435-0.44c0.16-0.154,0.322-0.304,0.486-0.451 c0.172-0.163,0.31-0.247,0.463-0.361L291.292,275.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M301.79,306.415c0.958-1.792,1.976-3.555,3.057-5.282c0.209-0.332,0.109-0.773-0.22-0.984 c-0.292-0.188-0.667-0.132-0.894,0.113c-1.405,1.519-2.763,3.096-4.08,4.726l-0.003,0.003 c-0.447,0.553-0.366,1.367,0.187,1.818c0.554,0.451,1.372,0.364,1.82-0.192C301.707,306.554,301.754,306.482,301.79,306.415 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M301.201,306.947c3.511-1.398,7.046-2.746,10.604-4.025c0.37-0.133,0.56-0.541,0.426-0.91 c-0.125-0.345-0.491-0.535-0.839-0.449c-3.685,0.916-7.365,1.908-11.018,2.948c-0.68,0.193-1.077,0.901-0.887,1.587 c0.19,0.685,0.902,1.086,1.589,0.891C301.118,306.978,301.161,306.963,301.201,306.947z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M302.446,308.301c3.537-1.164,7.096-2.257,10.687-3.269c0.38-0.107,0.602-0.502,0.493-0.879 c-0.101-0.353-0.454-0.566-0.808-0.506c-3.694,0.641-7.381,1.37-11.049,2.171c-0.694,0.151-1.138,0.835-0.991,1.531 c0.147,0.696,0.836,1.139,1.538,0.987C302.36,308.327,302.405,308.314,302.446,308.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M303.241,309.708c3.185-0.752,6.35-1.546,9.511-2.373c0.384-0.101,0.615-0.491,0.514-0.87 c-0.093-0.352-0.437-0.571-0.791-0.522l-0.023,0.004c-3.204,0.444-6.407,0.854-9.612,1.22l-0.04,0.005 c-0.711,0.081-1.225,0.718-1.149,1.426c0.076,0.708,0.718,1.219,1.436,1.138C303.137,309.73,303.193,309.72,303.241,309.708 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M302.098,311.199c2.568-0.285,5.127-0.601,7.684-0.938c0.396-0.052,0.676-0.412,0.625-0.801 c-0.046-0.354-0.348-0.612-0.697-0.618h-0.01c-2.559-0.048-5.114-0.117-7.664-0.217l-0.017-0.001 c-0.717-0.028-1.327,0.523-1.363,1.236c-0.037,0.712,0.52,1.317,1.244,1.345 C301.964,311.208,302.036,311.205,302.098,311.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M301.219,304.904c-0.449,1.059-1.302,1.789-0.896,3.067c0.48,1.511,2.057,1.417,3.351,1.224 c1.003-0.15,1.301,1.166,0.354,1.502c-1.546,0.548-3.291,0.793-4.475-0.565c-1.055-1.212-0.904-2.932-0.003-4.166 c0.377-0.515,1.327-0.478,1.45,0.249c0.116,0.69,0.316,1.209,0.767,1.75l-1.308,0.298l0.42-0.086l0.693-0.362l0.217,0.329 l-0.567,0.21l0.288,0.685l0.603-0.059l0.104-0.474l-0.782-0.023c0.258-0.1,0.455-0.177,0.736-0.145 c0.336,0.037,0.608,0.287,0.596,0.642l-0.005,0.143c-0.008,0.243-0.166,0.554-0.41,0.648 c-0.915,0.356-1.841-0.364-1.617-1.381c0.203-0.928,1.448-1.149,1.907-0.299c0.492,0.91-0.474,1.836-1.417,1.559 c-1.037-0.305-1.577-1.798-0.963-2.656c0.146-0.204,0.417-0.408,0.689-0.36c1.033,0.179,1.341,1.154,0.992,2.09 c-0.19,0.51-0.921,0.771-1.312,0.299c-0.61-0.736-1.003-1.518-1.184-2.457l1.452,0.25c-0.526,0.745-0.776,1.929,0.113,2.559 c0.773,0.547,1.874,0.099,2.663-0.18l0.354,1.502c-1.983,0.289-4.144,0.18-5.026-1.898 c-0.618-1.464-0.029-4.043,1.736-4.418C301.014,304.322,301.345,304.606,301.219,304.904z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M328.358,275.964c1.394,1.085,2.399,2.221,3.267,3.335c0.866,1.118,1.569,2.225,2.194,3.325 c1.255,2.201,2.216,4.377,3.064,6.553c0.846,2.175,1.561,4.348,2.197,6.534c0.632,2.192,1.185,4.373,1.647,6.663l0.23,1.171 c0.093,0.447,0.15,0.897,0.219,1.343l0.065,0.668c0.012,0.222,0.005,0.441,0.009,0.662l-0.021,0.328l-0.006,0.082 l-0.003,0.041l-0.001,0.021c-0.122-0.008-0.036,0.009-0.064,0.013l-0.023,0.164c-0.026,0.22-0.071,0.436-0.114,0.651 c-0.211,0.853-0.649,1.651-1.093,2.428c-0.228,0.374-0.466,0.799-0.686,1.126l-0.492,0.73 c-1.308,1.889-2.626,3.627-3.96,5.361c-2.666,3.455-5.378,6.814-8.111,10.159l-4.789-3.559 c2.386-3.554,4.752-7.124,7.02-10.714c1.129-1.792,2.247-3.6,3.243-5.374l0.358-0.656c0.08-0.153,0.116-0.247,0.174-0.371 c0.104-0.235,0.203-0.467,0.266-0.707c0.082-0.243-0.039-0.502-0.099-0.739l-0.115-0.355l-0.059-0.173 c-0.018-0.047-0.059-0.193-0.094-0.307c-1.175-3.851-2.706-7.757-4.485-11.33c-0.893-1.785-1.868-3.503-2.926-5.002 c-0.525-0.753-1.075-1.448-1.625-2.023c-0.544-0.578-1.1-1.049-1.538-1.303L328.358,275.964z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9754C"
    },
    d: "M327.654,275.287l-6,9.505c0.449,0.333,1.151,1.025,1.8,1.928 c0.657,0.906,1.297,1.978,1.892,3.118c3.543-1.847,7.102-3.665,10.677-5.455c-0.877-1.567-1.89-3.126-3.175-4.667 C331.565,278.193,329.978,276.615,327.654,275.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M325.312,321.614c-2.027,0.176-4.053,0.429-6.072,0.761 c-0.388,0.064-0.756-0.199-0.821-0.587c-0.057-0.343,0.142-0.67,0.457-0.785c1.957-0.713,3.95-1.354,5.975-1.924 l0.004-0.001c0.687-0.193,1.402,0.206,1.594,0.894c0.193,0.689-0.213,1.406-0.901,1.599 C325.472,321.592,325.388,321.607,325.312,321.614z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M326.034,321.281c-2.677,2.679-5.298,5.422-7.851,8.229 c-0.265,0.292-0.715,0.313-1.005,0.048c-0.271-0.248-0.305-0.66-0.092-0.95c2.27-3.068,4.622-6.088,7.039-9.052 c0.45-0.551,1.259-0.637,1.813-0.189c0.553,0.448,0.637,1.262,0.185,1.816C326.095,321.217,326.064,321.251,326.034,321.281 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M326.785,322.961c-2.464,2.791-4.852,5.652-7.161,8.586 c-0.245,0.311-0.694,0.365-1.001,0.121c-0.288-0.228-0.35-0.637-0.158-0.942c2.01-3.176,4.116-6.3,6.307-9.366 c0.414-0.581,1.219-0.719,1.8-0.308c0.581,0.412,0.715,1.219,0.298,1.803C326.844,322.891,326.814,322.928,326.785,322.961z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M327.766,324.245c-1.94,2.625-3.896,5.233-5.869,7.831c-0.24,0.316-0.688,0.379-1,0.141 c-0.289-0.221-0.361-0.622-0.179-0.93l0.012-0.02c1.639-2.789,3.258-5.585,4.858-8.39l0.02-0.035 c0.355-0.622,1.144-0.843,1.764-0.494c0.62,0.35,0.837,1.142,0.48,1.766C327.826,324.158,327.795,324.206,327.766,324.245z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M329.583,323.788c-1.271,2.236-2.554,4.461-3.848,6.681 c-0.201,0.344-0.639,0.462-0.979,0.265c-0.308-0.179-0.43-0.556-0.301-0.881l0.004-0.009 c0.942-2.374,1.872-4.751,2.787-7.132l0.006-0.016c0.257-0.671,1.006-1.01,1.674-0.76c0.668,0.25,1.002,1,0.743,1.673 C329.645,323.669,329.614,323.733,329.583,323.788z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M324.149,320.492c1.152,0.003,2.164-0.493,3.174,0.388c1.195,1.041,0.486,2.448-0.198,3.56 c-0.531,0.863,0.563,1.651,1.242,0.915c1.108-1.201,2.016-2.696,1.245-4.32c-0.691-1.45-2.324-2.005-3.821-1.663 c-0.623,0.143-0.97,1.034-0.35,1.434c0.587,0.379,0.986,0.769,1.304,1.397l0.793-1.083l-0.246,0.352l-0.607,0.493 l0.216,0.33l0.417-0.438l0.515,0.535l-0.292,0.53l-0.476-0.091l0.287-0.728c-0.194,0.197-0.342,0.348-0.423,0.618 c-0.098,0.323,0.024,0.672,0.354,0.8l0.134,0.052c0.227,0.088,0.574,0.066,0.757-0.119c0.686-0.699,0.394-1.831-0.628-2.03 c-0.933-0.183-1.63,0.877-1.029,1.633c0.643,0.81,1.873,0.289,1.991-0.684c0.13-1.07-1.023-2.162-2.055-1.939 c-0.246,0.054-0.541,0.222-0.605,0.492c-0.245,1.022,0.53,1.689,1.527,1.738c0.543,0.027,1.072-0.539,0.794-1.085 c-0.434-0.852-0.993-1.525-1.783-2.065l-0.35,1.436c0.894-0.19,2.079,0.053,2.305,1.118 c0.195,0.925-0.649,1.756-1.214,2.372l1.242,0.915c1.039-1.704,1.794-3.717,0.243-5.358 c-1.092-1.154-3.698-1.642-4.75-0.157C323.696,320.074,323.825,320.491,324.149,320.492z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1219_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 10.3418,
      strokeMiterlimit: 10
    },
    x1: 309.768,
    y1: 268.45,
    x2: 309.768,
    y2: 274.049
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M309.768,275.069c2.865,0,5.188-0.457,5.188-1.02c0-0.564-2.323-1.02-5.188-1.02 c-2.866,0-5.188,0.457-5.188,1.02C304.58,274.612,306.903,275.069,309.768,275.069z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FCC0A9",
      strokeWidth: 10.3418,
      strokeMiterlimit: 10
    },
    x1: 309.768,
    y1: 268.45,
    x2: 309.768,
    y2: 274.049
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M309.768,275.069c2.865,0,5.188-0.457,5.188-1.02c0-0.564-2.323-1.02-5.188-1.02 c-2.866,0-5.188,0.457-5.188,1.02C304.58,274.612,306.903,275.069,309.768,275.069z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1217_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M304.714,271.283h10.108c3.719,0,6.734-3.015,6.734-6.734v-13.11 c0-5.99-4.856-10.847-10.847-10.847h-1.882c-5.99,0-10.847,4.856-10.847,10.847v13.11 C297.98,268.268,300.995,271.283,304.714,271.283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1214_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1216_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M318.894,260.298c-0.001,0.022-0.001,0.043-0.002,0.065 c-0.02,0.534,0.091,1.032,0.334,1.494c0.156,0.481,0.424,0.897,0.802,1.248c0.351,0.378,0.767,0.646,1.248,0.802 c0.462,0.243,0.96,0.354,1.494,0.334c1.003-0.045,2.043-0.374,2.742-1.136c0.707-0.77,1.109-1.683,1.136-2.743 c0-0.022,0.001-0.043,0.002-0.065c0.02-0.534-0.091-1.032-0.334-1.494c-0.156-0.481-0.424-0.897-0.802-1.248 c-0.351-0.378-0.767-0.646-1.248-0.802c-0.462-0.243-0.96-0.354-1.494-0.334c-1.003,0.045-2.043,0.374-2.743,1.136 C319.323,258.325,318.922,259.238,318.894,260.298L318.894,260.298z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1215_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M325.056,259.895c-0.183-1.743-3.104-2.31-3.616-0.497 c-0.059,0.208,0.113,0.493,0.354,0.465c0.571-0.068,0.897,0.357,0.832,0.869c-0.068,0.541-0.499,0.736-0.992,0.809 c-0.466,0.069-0.268,0.777,0.195,0.708c0.862-0.128,1.527-0.714,1.539-1.623c0.011-0.862-0.677-1.604-1.574-1.498 c0.118,0.155,0.236,0.31,0.354,0.465c0.275-0.974,2.076-0.629,2.174,0.302 C324.371,260.361,325.106,260.366,325.056,259.895L325.056,259.895z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1211_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1213_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC0A9"
    },
    d: "M292.885,260.298c0.001,0.022,0.001,0.043,0.002,0.065 c0.026,1.011,0.414,2.021,1.136,2.743c0.351,0.378,0.767,0.646,1.248,0.802c0.462,0.243,0.96,0.354,1.494,0.334 c1.003-0.045,2.043-0.374,2.743-1.136c0.686-0.747,1.163-1.702,1.136-2.743c0-0.022-0.001-0.043-0.002-0.065 c-0.026-1.011-0.414-2.021-1.136-2.743c-0.351-0.378-0.767-0.646-1.248-0.802c-0.462-0.243-0.96-0.354-1.494-0.334 c-1.003,0.045-2.043,0.374-2.743,1.136C293.335,258.303,292.858,259.257,292.885,260.298L292.885,260.298z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1212_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M295.214,259.895c0.098-0.933,1.899-1.275,2.174-0.302c0.118-0.155,0.236-0.31,0.354-0.465 c-0.893-0.106-1.589,0.635-1.574,1.498c0.016,0.909,0.673,1.495,1.539,1.623c0.462,0.069,0.662-0.639,0.195-0.708 c-0.492-0.073-0.923-0.268-0.992-0.809c-0.065-0.513,0.267-0.936,0.832-0.869c0.241,0.029,0.413-0.257,0.354-0.465 c-0.512-1.813-3.433-1.245-3.616,0.497C294.43,260.365,295.165,260.361,295.214,259.895L295.214,259.895z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1198_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1210_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M309.744,259.65c0.192,0.974-1.423,1.501-0.924,2.558c0.283,0.599,1.45,0.841,1.896,0.335 c0.274-0.311-0.181-0.77-0.457-0.457c-0.148,0.169-0.751,0.049-0.861-0.165c-0.147-0.288,0.274-0.655,0.423-0.831 c0.419-0.494,0.677-0.949,0.546-1.611C310.286,259.071,309.663,259.243,309.744,259.65L309.744,259.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1209_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D3338"
    },
    d: "M311.165,264.021c-0.656,1.096-2.131,1.106-2.795,0.008 c-0.215-0.355-0.774-0.031-0.558,0.326c0.913,1.509,3.004,1.508,3.911-0.008 C311.937,263.989,311.379,263.664,311.165,264.021L311.165,264.021z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1207_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M317.047,265.041c1.087,0,2.128-0.956,2.078-2.078c-0.05-1.126-0.913-2.078-2.078-2.078 c-1.087,0-2.128,0.956-2.078,2.078C315.019,264.089,315.882,265.041,317.047,265.041L317.047,265.041z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1205_",
    style: {
      opacity: 0.43
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5857F"
    },
    d: "M302.521,265.041c1.087,0,2.128-0.956,2.078-2.078c-0.051-1.126-0.913-2.078-2.078-2.078 c-1.087,0-2.128,0.956-2.078,2.078C300.493,264.089,301.356,265.041,302.521,265.041L302.521,265.041z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1204_",
    style: {
      fill: "#5D3338"
    },
    d: "M303.803,260.767c-0.554,0-1.004-0.606-1.004-1.354 c0-0.748,0.449-1.354,1.004-1.354c0.554,0,1.004,0.606,1.004,1.354C304.806,260.161,304.357,260.767,303.803,260.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1203_",
    style: {
      fill: "#5D3338"
    },
    d: "M315.733,260.768c0.554,0,1.004-0.606,1.004-1.354 c0-0.748-0.449-1.354-1.004-1.354c-0.554,0-1.004,0.606-1.004,1.354C314.729,260.161,315.179,260.768,315.733,260.768z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1201_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M319.117,257.669c-0.295-1.155-1.517-1.788-2.621-1.934 c-0.95-0.126-2.473-0.007-2.856,1.025c-0.11,0.297,0.168,0.537,0.429,0.564c0.706,0.071,1.328-0.439,2.073-0.415 c0.952,0.03,1.642,0.533,2.325,1.138C318.754,258.299,319.217,258.057,319.117,257.669L319.117,257.669z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1199_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M306.307,257.394c-0.581-1.018-1.43-1.63-2.653-1.554 c-0.971,0.06-2.218,0.628-2.035,1.755c0.023,0.139,0.179,0.231,0.308,0.235c0.673,0.019,1.05-0.417,1.677-0.582 c0.725-0.191,1.714-0.019,2.307,0.451C306.124,257.866,306.458,257.66,306.307,257.394L306.307,257.394z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M321.985,247.528c-2.058,1.162-4.289,1.956-6.522,2.696 c-3.237,1.073-6.504,2.046-9.797,2.917c-1.06,0.281-2.136,0.552-3.23,0.549c-1.094-0.003-2.225-0.308-3.045-1.057 c-0.735-0.672-1.157-1.632-1.513-2.578c-0.7-1.862-1.23-3.793-1.579-5.759c-0.236-1.326-0.37-2.778,0.276-3.949 c0.393,1.167,1.737,1.737,2.928,1.638c1.191-0.099,2.278-0.702,3.359-1.228c3.941-1.916,8.486-2.925,12.679-1.709 c1.522,0.442,2.982,1.18,4.152,2.279c1.171,1.1,2.038,2.577,2.291,4.192c0.103,0.661,0.102,1.351-0.103,1.986"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M321.848,247.293c-4.852,2.352-10.182,4.109-15.428,5.373 c-2.447,0.59-3.571,1.002-5.82-0.307c-2.139-1.245-2.408-2.228-3.136-4.509c-0.35-1.096-1.756-5.861-0.398-6.357 c0.308-0.113,0.854,0.698,1.238,0.635c1.302-0.212,2.176-0.097,3.546-0.578c2.501-0.879,4.656-2.07,7.302-2.473 c4.91-0.749,13.611,1.189,12.363,8.328c-0.084,0.482,0.656,0.686,0.736,0.203c0.673-4.059-2.2-7.267-5.88-8.581 c-2.36-0.843-4.872-0.938-7.336-0.566c-3.09,0.466-9.968,4.903-12.266,1.775c-0.111-0.151-0.346-0.141-0.406,0.053 c-1.163,3.797,0.104,11.851,4.389,13.383c2.774,0.992,6.464-0.653,9.088-1.416c4.185-1.217,8.438-2.405,12.283-4.491 C322.434,247.595,322.16,247.141,321.848,247.293L321.848,247.293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M297.89,247.227c-0.381,3.644-0.525,7.402,0.574,10.897 c0.375-3.505,0.998-6.983,1.864-10.399"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M297.701,247.175c-0.533,3.723-0.584,7.392,0.504,11.02c0.07,0.233,0.478,0.278,0.519,0 c0.516-3.49,1.202-6.95,1.717-10.44c0.021-0.146-0.173-0.206-0.224-0.062c-1.197,3.389-1.745,6.858-2.021,10.43 c0.176-0.024,0.352-0.048,0.529-0.072c-0.982-3.554-0.839-7.184-0.637-10.825 C298.098,247.01,297.732,246.954,297.701,247.175L297.701,247.175z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M321.624,247.227c0.381,3.644,0.525,7.402-0.574,10.897 c-0.375-3.505-0.998-6.983-1.864-10.399"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1A043"
    },
    d: "M321.428,247.227c0.202,3.643,0.345,7.27-0.637,10.825c0.176,0.024,0.352,0.048,0.529,0.072 c-0.276-3.572-0.823-7.04-2.021-10.43c-0.051-0.144-0.246-0.085-0.224,0.062c0.514,3.49,1.2,6.95,1.717,10.44 c0.041,0.278,0.449,0.233,0.519,0c1.088-3.629,1.037-7.297,0.504-11.02C321.783,246.956,321.416,247.008,321.428,247.227 L321.428,247.227z"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg201818446238850);
export default __webpack_public_path__ + "static/media/20181844_6238850.2b5126287b5f8b08527e35429f9464a1.svg";
export { ForwardRef as ReactComponent };